<template>
    <kinsta-advanced-cta language="en_US" type-int-post="10984" type-int-position="0">
        <div class="advanced-cta-wrapper">
            <div class="row ml--0 mr--0 flex-direction-column-reverse">
                <div class="align-self-center col-xs-20 col-sm-20">
                    <div class="pt--6"></div>
                    <div class="pt--6"></div>
                    <div class="pt--6"></div>
                    <div class="kinsta-book kinsta-book--animated kinsta-book--3d cta--ebook">
                        <div class="kinsta-book__cover kinsta-book__cover--front">
                            <figure>
                                <img width="320" height="345" loading="lazy" alt="How to Speed up Your WordPress Site"
                                    :src="magazineList[0].image" />
                            </figure>
                        </div>
                        <ul class="kinsta-book__pages" aria-hidden="true">
                            <li class="kinsta-book__page">
                                <figure><img alt="" width="320" height="345" loading="lazy" aria-hidden="true"
                                        src="https://kinsta.com/cta/v1/images/ebook/page-1.png" /></figure>
                            </li>
                            <li class="kinsta-book__page">
                                <figure><img alt="" width="320" height="345" loading="lazy" aria-hidden="true"
                                        src="https://kinsta.com/cta/v1/images/ebook/page-generic.png" /></figure>
                            </li>
                            <li class="kinsta-book__page">
                                <figure><img alt="" width="320" height="345" loading="lazy" aria-hidden="true"
                                        src="https://kinsta.com/cta/v1/images/ebook/page-generic.png" /></figure>
                            </li>
                            <li class="kinsta-book__page">
                                <figure><img alt="" width="320" height="345" loading="lazy" aria-hidden="true"
                                        src="https://kinsta.com/cta/v1/images/ebook/page-2.png" /></figure>
                            </li>
                            <li class="kinsta-book__page"></li>
                        </ul>
                        <div class="kinsta-book__cover kinsta-book__cover--back" aria-hidden="true">
                            <div class="kinsta-book__spine"></div>
                        </div>
                    </div>
                    <div class="pt--6"></div>
                    <div class="pt--6"></div>
                    <div class="pt--6"></div>
                </div>
            </div>
        </div>
    </kinsta-advanced-cta>
</template>
<script>
export default {
    name: 'BookAnimation',
    props: {
        magazineList: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style scoped>
/* .advanced-cta-wrapper {
    transform: rotate(-10deg);
} */

a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
main,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
    border: 0;
    font-size: 100%;
    font: inherit;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section {
    display: block;
}

[hidden] {
    display: none;
}

body {
    line-height: 1;
}

menu,
ol,
ul {
    list-style: none;
}

blockquote,
q {
    quotes: none;
}

blockquote:after,
blockquote:before,
q:after,
q:before {
    content: "";
    content: none;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

.show-xs-only {
    display: block;
}

.show-lg-only,
.show-md-only,
.show-sm-only {
    display: none;
}

.show-md-down,
.show-sm-down {
    display: block;
}

.show-md-up,
.show-sm-up,
.show-sm-up--inline {
    display: none;
}

@media only screen and (min-width: 48em) {
    .show-xs-only {
        display: none;
    }

    .show-sm-only {
        display: block;
    }

    .show-lg-only,
    .show-md-only {
        display: none;
    }

    .show-md-down,
    .show-sm-down,
    .show-sm-up {
        display: block;
    }

    .show-sm-up--inline {
        display: inline;
    }

    .show-md-up {
        display: none;
    }
}

@media only screen and (min-width: 64em) {

    .show-sm-only,
    .show-xs-only {
        display: none;
    }

    .show-md-only {
        display: block;
    }

    .show-lg-only,
    .show-sm-down {
        display: none;
    }

    .show-md-down,
    .show-sm-up {
        display: block;
    }

    .show-sm-up--inline {
        display: inline;
    }

    .show-md-up {
        display: block;
    }
}

@media only screen and (min-width: 75em) {

    .show-md-only,
    .show-sm-only,
    .show-xs-only {
        display: none;
    }

    .show-lg-only {
        display: block;
    }

    .show-md-down,
    .show-sm-down {
        display: none;
    }

    .show-sm-up {
        display: block;
    }

    .show-sm-up--inline {
        display: inline;
    }

    .show-md-up {
        display: block;
    }
}

.flex {
    display: flex;
}

.flex--1 {
    flex: 1;
}

.flex--wrap {
    flex-wrap: wrap;
}

.container {
    margin-left: auto;
    margin-right: auto;
    max-width: 1200px;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 100%;
}

@media (min-width: 48em) {
    .container {
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.container:after,
.container:before {
    clear: both;
    content: "";
    display: block;
    height: 0;
    visibility: hidden;
}

.container .container {
    padding-left: 0;
    padding-right: 0;
}

.container--full {
    max-width: 100%;
}

.container--narrow {
    max-width: 43rem;
}

@media (min-width: 48em) {
    .container--narrow {
        max-width: 45rem;
    }
}

.container--noclear:after,
.container--noclear:before {
    display: none;
}

.boxes--alternating,
.boxes--pair,
.row {
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
}

.container .boxes--alternating,
.container .boxes--pair,
.container .row {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
}

.nocol.boxes--alternating,
.nocol.boxes--pair,
.row.nocol {
    flex-wrap: unset;
}

.row--reverse {
    flex-direction: row-reverse;
}

.nomargin.boxes--alternating,
.nomargin.boxes--pair,
.row.nomargin {
    margin-left: 0;
    margin-right: 0;
}

@media only screen and (max-width: 47em) {

    .nocol.xs-all-12-centered.boxes--alternating,
    .nocol.xs-all-12-centered.boxes--pair,
    .row.nocol.xs-all-12-centered {
        display: block;
    }

    .nocol.xs-all-12-centered.boxes--alternating> :not(img),
    .nocol.xs-all-12-centered.boxes--pair> :not(img),
    .row.nocol.xs-all-12-centered> :not(img) {
        width: 100%;
    }

    .nocol.xs-all-6-centered.boxes--alternating,
    .nocol.xs-all-6-centered.boxes--pair,
    .row.nocol.xs-all-6-centered {
        display: flex;
    }

    .nocol.xs-all-6-centered.boxes--alternating> :not(img),
    .nocol.xs-all-6-centered.boxes--pair> :not(img),
    .row.nocol.xs-all-6-centered> :not(img) {
        width: 50%;
    }
}

@media only screen and (min-width: 47.001em) and (max-width: 63.999em) {

    .nocol.md-all-12-centered.boxes--alternating,
    .nocol.md-all-12-centered.boxes--pair,
    .row.nocol.md-all-12-centered {
        display: block;
    }

    .nocol.md-all-12-centered.boxes--alternating> :not(img),
    .nocol.md-all-12-centered.boxes--pair> :not(img),
    .row.nocol.md-all-12-centered> :not(img) {
        width: 100%;
    }

    .nocol.md-all-6-centered.boxes--alternating,
    .nocol.md-all-6-centered.boxes--pair,
    .row.nocol.md-all-6-centered {
        display: flex;
    }

    .nocol.md-all-6-centered.boxes--alternating> :not(img),
    .nocol.md-all-6-centered.boxes--pair> :not(img),
    .row.nocol.md-all-6-centered> :not(img) {
        width: 50%;
    }
}

.nocol.gutter--small.boxes--alternating>div,
.nocol.gutter--small.boxes--pair>div,
.row.nocol.gutter--small>div {
    margin-right: 15px;
}

.nocol.gutter--small.boxes--alternating>div:last-of-type,
.nocol.gutter--small.boxes--pair>div:last-of-type,
.row.nocol.gutter--small>div:last-of-type {
    margin-right: 0;
}

.nocol.gutter--medium.boxes--alternating>div,
.nocol.gutter--medium.boxes--pair>div,
.row.nocol.gutter--medium>div {
    margin-right: 25px;
}

.nocol.gutter--medium.boxes--alternating>div:last-of-type,
.nocol.gutter--medium.boxes--pair>div:last-of-type,
.row.nocol.gutter--medium>div:last-of-type {
    margin-right: 0;
}

.nocol.gutter--large.boxes--alternating>div,
.nocol.gutter--large.boxes--pair>div,
.row.nocol.gutter--large>div {
    margin-right: 40px;
}

.nocol.gutter--large.boxes--alternating>div:last-of-type,
.nocol.gutter--large.boxes--pair>div:last-of-type,
.row.nocol.gutter--large>div:last-of-type {
    margin-right: 0;
}

.nocol.gutter--huge.boxes--alternating>div,
.nocol.gutter--huge.boxes--pair>div,
.row.nocol.gutter--huge>div {
    margin-right: 55px;
}

.nocol.gutter--huge.boxes--alternating>div:last-of-type,
.nocol.gutter--huge.boxes--pair>div:last-of-type,
.row.nocol.gutter--huge>div:last-of-type {
    margin-right: 0;
}

.boxes--alternating .boxes--alternating div[class^="col-"]:not(.button),
.boxes--alternating .boxes--alternating:not(.button),
.boxes--alternating .boxes--pair div[class^="col-"]:not(.button),
.boxes--alternating .boxes--pair:not(.button),
.boxes--alternating .row div[class^="col-"]:not(.button),
.boxes--alternating .row:not(.button),
.boxes--pair .boxes--alternating div[class^="col-"]:not(.button),
.boxes--pair .boxes--alternating:not(.button),
.boxes--pair .boxes--pair div[class^="col-"]:not(.button),
.boxes--pair .boxes--pair:not(.button),
.boxes--pair .row div[class^="col-"]:not(.button),
.boxes--pair .row:not(.button),
.row .boxes--alternating div[class^="col-"]:not(.button),
.row .boxes--alternating:not(.button),
.row .boxes--pair div[class^="col-"]:not(.button),
.row .boxes--pair:not(.button),
.row .row div[class^="col-"]:not(.button),
.row .row:not(.button),
div[class^="col-"].nopadding:not(.button) {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.boxes--alternating,
.reverse.boxes--pair,
.row.reverse {
    flex-direction: row-reverse;
}

.boxes--alternating,
.col.reverse {
    flex-direction: column-reverse;
}

.col-xs,
.col-xs-1,
.col-xs-10,
.col-xs-11,
.col-xs-12,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-offset-0,
.col-xs-offset-1,
.col-xs-offset-10,
.col-xs-offset-11,
.col-xs-offset-12,
.col-xs-offset-2,
.col-xs-offset-3,
.col-xs-offset-4,
.col-xs-offset-5,
.col-xs-offset-6,
.col-xs-offset-7,
.col-xs-offset-8,
.col-xs-offset-9,
.text-quote.text-quote--alternating:nth-of-type(2n)>.col-sm-6 {
    flex: 0 0 auto;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.col-xs {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
}

.col-xs-1 {
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
}

.col-xs-2 {
    flex-basis: 16.6666666667%;
    max-width: 16.6666666667%;
}

.col-xs-3 {
    flex-basis: 25%;
    max-width: 25%;
}

.col-xs-4 {
    flex-basis: 33.3333333333%;
    max-width: 33.3333333333%;
}

.col-xs-5 {
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
}

.col-xs-6 {
    flex-basis: 50%;
    max-width: 50%;
}

.col-xs-7 {
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
}

.col-xs-8 {
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
}

.col-xs-9 {
    flex-basis: 75%;
    max-width: 75%;
}

.col-xs-10 {
    flex-basis: 83.3333333333%;
    max-width: 83.3333333333%;
}

.col-xs-11 {
    flex-basis: 91.6666666667%;
    max-width: 91.6666666667%;
}

.col-xs-12 {
    flex-basis: 100%;
    max-width: 100%;
}

.gutter--small {
    justify-content: space-between;
}

.gutter--small>.col-xs-1 {
    flex-basis: calc(8.33333% - 15px);
    max-width: calc(8.33333% - 15px);
}

.gutter--small>.col-xs-2 {
    flex-basis: calc(16.66667% - 15px);
    max-width: calc(16.66667% - 15px);
}

.gutter--small>.col-xs-3 {
    flex-basis: calc(25% - 15px);
    max-width: calc(25% - 15px);
}

.gutter--small>.col-xs-4 {
    flex-basis: calc(33.33333% - 15px);
    max-width: calc(33.33333% - 15px);
}

.gutter--small>.col-xs-5 {
    flex-basis: calc(41.66667% - 15px);
    max-width: calc(41.66667% - 15px);
}

.gutter--small>.col-xs-6 {
    flex-basis: calc(50% - 15px);
    max-width: calc(50% - 15px);
}

.gutter--small>.col-xs-7 {
    flex-basis: calc(58.33333% - 15px);
    max-width: calc(58.33333% - 15px);
}

.gutter--small>.col-xs-8 {
    flex-basis: calc(66.66667% - 15px);
    max-width: calc(66.66667% - 15px);
}

.gutter--small>.col-xs-9 {
    flex-basis: calc(75% - 15px);
    max-width: calc(75% - 15px);
}

.gutter--small>.col-xs-10 {
    flex-basis: calc(83.33333% - 15px);
    max-width: calc(83.33333% - 15px);
}

.gutter--small>.col-xs-11 {
    flex-basis: calc(91.66667% - 15px);
    max-width: calc(91.66667% - 15px);
}

.gutter--small>.col-xs-12 {
    flex-basis: calc(100% - 15px);
    flex-basis: 100%;
    max-width: calc(100% - 15px);
    max-width: 100%;
}

.gutter--medium {
    justify-content: space-between;
}

.gutter--medium>.col-xs-1 {
    flex-basis: calc(8.33333% - 25px);
    max-width: calc(8.33333% - 25px);
}

.gutter--medium>.col-xs-2 {
    flex-basis: calc(16.66667% - 25px);
    max-width: calc(16.66667% - 25px);
}

.gutter--medium>.col-xs-3 {
    flex-basis: calc(25% - 25px);
    max-width: calc(25% - 25px);
}

.gutter--medium>.col-xs-4 {
    flex-basis: calc(33.33333% - 25px);
    max-width: calc(33.33333% - 25px);
}

.gutter--medium>.col-xs-5 {
    flex-basis: calc(41.66667% - 25px);
    max-width: calc(41.66667% - 25px);
}

.gutter--medium>.col-xs-6 {
    flex-basis: calc(50% - 25px);
    max-width: calc(50% - 25px);
}

.gutter--medium>.col-xs-7 {
    flex-basis: calc(58.33333% - 25px);
    max-width: calc(58.33333% - 25px);
}

.gutter--medium>.col-xs-8 {
    flex-basis: calc(66.66667% - 25px);
    max-width: calc(66.66667% - 25px);
}

.gutter--medium>.col-xs-9 {
    flex-basis: calc(75% - 25px);
    max-width: calc(75% - 25px);
}

.gutter--medium>.col-xs-10 {
    flex-basis: calc(83.33333% - 25px);
    max-width: calc(83.33333% - 25px);
}

.gutter--medium>.col-xs-11 {
    flex-basis: calc(91.66667% - 25px);
    max-width: calc(91.66667% - 25px);
}

.gutter--medium>.col-xs-12 {
    flex-basis: calc(100% - 25px);
    flex-basis: 100%;
    max-width: calc(100% - 25px);
    max-width: 100%;
}

.gutter--large {
    justify-content: space-between;
}

.gutter--large>.col-xs-1 {
    flex-basis: calc(8.33333% - 40px);
    max-width: calc(8.33333% - 40px);
}

.gutter--large>.col-xs-2 {
    flex-basis: calc(16.66667% - 40px);
    max-width: calc(16.66667% - 40px);
}

.gutter--large>.col-xs-3 {
    flex-basis: calc(25% - 40px);
    max-width: calc(25% - 40px);
}

.gutter--large>.col-xs-4 {
    flex-basis: calc(33.33333% - 40px);
    max-width: calc(33.33333% - 40px);
}

.gutter--large>.col-xs-5 {
    flex-basis: calc(41.66667% - 40px);
    max-width: calc(41.66667% - 40px);
}

.gutter--large>.col-xs-6 {
    flex-basis: calc(50% - 40px);
    max-width: calc(50% - 40px);
}

.gutter--large>.col-xs-7 {
    flex-basis: calc(58.33333% - 40px);
    max-width: calc(58.33333% - 40px);
}

.gutter--large>.col-xs-8 {
    flex-basis: calc(66.66667% - 40px);
    max-width: calc(66.66667% - 40px);
}

.gutter--large>.col-xs-9 {
    flex-basis: calc(75% - 40px);
    max-width: calc(75% - 40px);
}

.gutter--large>.col-xs-10 {
    flex-basis: calc(83.33333% - 40px);
    max-width: calc(83.33333% - 40px);
}

.gutter--large>.col-xs-11 {
    flex-basis: calc(91.66667% - 40px);
    max-width: calc(91.66667% - 40px);
}

.gutter--large>.col-xs-12 {
    flex-basis: calc(100% - 40px);
    flex-basis: 100%;
    max-width: calc(100% - 40px);
    max-width: 100%;
}

.gutter--huge {
    justify-content: space-between;
}

.gutter--huge>.col-xs-1 {
    flex-basis: calc(8.33333% - 55px);
    max-width: calc(8.33333% - 55px);
}

.gutter--huge>.col-xs-2 {
    flex-basis: calc(16.66667% - 55px);
    max-width: calc(16.66667% - 55px);
}

.gutter--huge>.col-xs-3 {
    flex-basis: calc(25% - 55px);
    max-width: calc(25% - 55px);
}

.gutter--huge>.col-xs-4 {
    flex-basis: calc(33.33333% - 55px);
    max-width: calc(33.33333% - 55px);
}

.gutter--huge>.col-xs-5 {
    flex-basis: calc(41.66667% - 55px);
    max-width: calc(41.66667% - 55px);
}

.gutter--huge>.col-xs-6 {
    flex-basis: calc(50% - 55px);
    max-width: calc(50% - 55px);
}

.gutter--huge>.col-xs-7 {
    flex-basis: calc(58.33333% - 55px);
    max-width: calc(58.33333% - 55px);
}

.gutter--huge>.col-xs-8 {
    flex-basis: calc(66.66667% - 55px);
    max-width: calc(66.66667% - 55px);
}

.gutter--huge>.col-xs-9 {
    flex-basis: calc(75% - 55px);
    max-width: calc(75% - 55px);
}

.gutter--huge>.col-xs-10 {
    flex-basis: calc(83.33333% - 55px);
    max-width: calc(83.33333% - 55px);
}

.gutter--huge>.col-xs-11 {
    flex-basis: calc(91.66667% - 55px);
    max-width: calc(91.66667% - 55px);
}

.gutter--huge>.col-xs-12 {
    flex-basis: calc(100% - 55px);
    flex-basis: 100%;
    max-width: calc(100% - 55px);
    max-width: 100%;
}

.col-xs-offset-0 {
    margin-left: 0;
}

.col-xs-offset-1 {
    margin-left: 8.3333333333%;
}

.col-xs-offset-2 {
    margin-left: 16.6666666667%;
}

.col-xs-offset-3 {
    margin-left: 25%;
}

.col-xs-offset-4 {
    margin-left: 33.3333333333%;
}

.col-xs-offset-5 {
    margin-left: 41.6666666667%;
}

.col-xs-offset-6,
.text-quote.text-quote--alternating:nth-of-type(2n)>.col-sm-6 {
    margin-left: 50%;
}

.col-xs-offset-7 {
    margin-left: 58.3333333333%;
}

.col-xs-offset-8 {
    margin-left: 66.6666666667%;
}

.col-xs-offset-9 {
    margin-left: 75%;
}

.col-xs-offset-10 {
    margin-left: 83.3333333333%;
}

.col-xs-offset-11 {
    margin-left: 91.6666666667%;
}

.col-xs-offset-12 {
    margin-left: 100%;
}

[dir="ltr"] .start-xs {
    text-align: left;
}

[dir="rtl"] .start-xs {
    text-align: right;
}

.start-xs {
    justify-content: flex-start;
}

.center-xs {
    justify-content: center;
    text-align: center;
}

[dir="ltr"] .end-xs {
    text-align: right;
}

[dir="rtl"] .end-xs {
    text-align: left;
}

.end-xs {
    justify-content: flex-end;
}

.top-xs {
    align-items: flex-start;
}

.middle-xs {
    align-items: center;
}

.bottom-xs {
    align-items: flex-end;
}

.baseline-xs {
    align-items: baseline;
}

.around-xs {
    justify-content: space-around;
}

.between-xs {
    justify-content: space-between;
}

.first-xs {
    order: -1;
}

.last-xs {
    order: 1;
}

@media only screen and (min-width: 48em) {

    .col-sm,
    .col-sm-1,
    .col-sm-10,
    .col-sm-11,
    .col-sm-12,
    .col-sm-2,
    .col-sm-3,
    .col-sm-4,
    .col-sm-5,
    .col-sm-6,
    .col-sm-7,
    .col-sm-8,
    .col-sm-9,
    .col-sm-offset-0,
    .col-sm-offset-1,
    .col-sm-offset-10,
    .col-sm-offset-11,
    .col-sm-offset-12,
    .col-sm-offset-2,
    .col-sm-offset-3,
    .col-sm-offset-4,
    .col-sm-offset-5,
    .col-sm-offset-6,
    .col-sm-offset-7,
    .col-sm-offset-8,
    .col-sm-offset-9 {
        flex: 0 0 auto;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .col-sm {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-sm-1 {
        flex-basis: 8.3333333333%;
        max-width: 8.3333333333%;
    }

    .col-sm-2 {
        flex-basis: 16.6666666667%;
        max-width: 16.6666666667%;
    }

    .col-sm-3 {
        flex-basis: 25%;
        max-width: 25%;
    }

    .col-sm-4 {
        flex-basis: 33.3333333333%;
        max-width: 33.3333333333%;
    }

    .col-sm-5 {
        flex-basis: 41.6666666667%;
        max-width: 41.6666666667%;
    }

    .col-sm-6 {
        flex-basis: 50%;
        max-width: 50%;
    }

    .col-sm-7 {
        flex-basis: 58.3333333333%;
        max-width: 58.3333333333%;
    }

    .col-sm-8 {
        flex-basis: 66.6666666667%;
        max-width: 66.6666666667%;
    }

    .col-sm-9 {
        flex-basis: 75%;
        max-width: 75%;
    }

    .col-sm-10 {
        flex-basis: 83.3333333333%;
        max-width: 83.3333333333%;
    }

    .col-sm-11 {
        flex-basis: 91.6666666667%;
        max-width: 91.6666666667%;
    }

    .col-sm-12 {
        flex-basis: 100%;
        max-width: 100%;
    }

    .col-sm-offset-0 {
        margin-left: 0;
    }

    .col-sm-offset-1 {
        margin-left: 8.3333333333%;
    }

    .col-sm-offset-2 {
        margin-left: 16.6666666667%;
    }

    .col-sm-offset-3 {
        margin-left: 25%;
    }

    .col-sm-offset-4 {
        margin-left: 33.3333333333%;
    }

    .col-sm-offset-5 {
        margin-left: 41.6666666667%;
    }

    .col-sm-offset-6 {
        margin-left: 50%;
    }

    .col-sm-offset-7 {
        margin-left: 58.3333333333%;
    }

    .col-sm-offset-8 {
        margin-left: 66.6666666667%;
    }

    .col-sm-offset-9 {
        margin-left: 75%;
    }

    .col-sm-offset-10 {
        margin-left: 83.3333333333%;
    }

    .col-sm-offset-11 {
        margin-left: 91.6666666667%;
    }

    .col-sm-offset-12 {
        margin-left: 100%;
    }

    .gutter--small {
        justify-content: space-between;
    }

    .gutter--small>.col-sm-1 {
        flex-basis: calc(8.33333% - 15px);
        max-width: calc(8.33333% - 15px);
    }

    .gutter--small>.col-sm-2 {
        flex-basis: calc(16.66667% - 15px);
        max-width: calc(16.66667% - 15px);
    }

    .gutter--small>.col-sm-3 {
        flex-basis: calc(25% - 15px);
        max-width: calc(25% - 15px);
    }

    .gutter--small>.col-sm-4 {
        flex-basis: calc(33.33333% - 15px);
        max-width: calc(33.33333% - 15px);
    }

    .gutter--small>.col-sm-5 {
        flex-basis: calc(41.66667% - 15px);
        max-width: calc(41.66667% - 15px);
    }

    .gutter--small>.col-sm-6 {
        flex-basis: calc(50% - 15px);
        max-width: calc(50% - 15px);
    }

    .gutter--small>.col-sm-7 {
        flex-basis: calc(58.33333% - 15px);
        max-width: calc(58.33333% - 15px);
    }

    .gutter--small>.col-sm-8 {
        flex-basis: calc(66.66667% - 15px);
        max-width: calc(66.66667% - 15px);
    }

    .gutter--small>.col-sm-9 {
        flex-basis: calc(75% - 15px);
        max-width: calc(75% - 15px);
    }

    .gutter--small>.col-sm-10 {
        flex-basis: calc(83.33333% - 15px);
        max-width: calc(83.33333% - 15px);
    }

    .gutter--small>.col-sm-11 {
        flex-basis: calc(91.66667% - 15px);
        max-width: calc(91.66667% - 15px);
    }

    .gutter--small>.col-sm-12 {
        flex-basis: calc(100% - 15px);
        flex-basis: 100%;
        max-width: calc(100% - 15px);
        max-width: 100%;
    }

    .gutter--medium {
        justify-content: space-between;
    }

    .gutter--medium>.col-sm-1 {
        flex-basis: calc(8.33333% - 25px);
        max-width: calc(8.33333% - 25px);
    }

    .gutter--medium>.col-sm-2 {
        flex-basis: calc(16.66667% - 25px);
        max-width: calc(16.66667% - 25px);
    }

    .gutter--medium>.col-sm-3 {
        flex-basis: calc(25% - 25px);
        max-width: calc(25% - 25px);
    }

    .gutter--medium>.col-sm-4 {
        flex-basis: calc(33.33333% - 25px);
        max-width: calc(33.33333% - 25px);
    }

    .gutter--medium>.col-sm-5 {
        flex-basis: calc(41.66667% - 25px);
        max-width: calc(41.66667% - 25px);
    }

    .gutter--medium>.col-sm-6 {
        flex-basis: calc(50% - 25px);
        max-width: calc(50% - 25px);
    }

    .gutter--medium>.col-sm-7 {
        flex-basis: calc(58.33333% - 25px);
        max-width: calc(58.33333% - 25px);
    }

    .gutter--medium>.col-sm-8 {
        flex-basis: calc(66.66667% - 25px);
        max-width: calc(66.66667% - 25px);
    }

    .gutter--medium>.col-sm-9 {
        flex-basis: calc(75% - 25px);
        max-width: calc(75% - 25px);
    }

    .gutter--medium>.col-sm-10 {
        flex-basis: calc(83.33333% - 25px);
        max-width: calc(83.33333% - 25px);
    }

    .gutter--medium>.col-sm-11 {
        flex-basis: calc(91.66667% - 25px);
        max-width: calc(91.66667% - 25px);
    }

    .gutter--medium>.col-sm-12 {
        flex-basis: calc(100% - 25px);
        flex-basis: 100%;
        max-width: calc(100% - 25px);
        max-width: 100%;
    }

    .gutter--large {
        justify-content: space-between;
    }

    .gutter--large>.col-sm-1 {
        flex-basis: calc(8.33333% - 40px);
        max-width: calc(8.33333% - 40px);
    }

    .gutter--large>.col-sm-2 {
        flex-basis: calc(16.66667% - 40px);
        max-width: calc(16.66667% - 40px);
    }

    .gutter--large>.col-sm-3 {
        flex-basis: calc(25% - 40px);
        max-width: calc(25% - 40px);
    }

    .gutter--large>.col-sm-4 {
        flex-basis: calc(33.33333% - 40px);
        max-width: calc(33.33333% - 40px);
    }

    .gutter--large>.col-sm-5 {
        flex-basis: calc(41.66667% - 40px);
        max-width: calc(41.66667% - 40px);
    }

    .gutter--large>.col-sm-6 {
        flex-basis: calc(50% - 40px);
        max-width: calc(50% - 40px);
    }

    .gutter--large>.col-sm-7 {
        flex-basis: calc(58.33333% - 40px);
        max-width: calc(58.33333% - 40px);
    }

    .gutter--large>.col-sm-8 {
        flex-basis: calc(66.66667% - 40px);
        max-width: calc(66.66667% - 40px);
    }

    .gutter--large>.col-sm-9 {
        flex-basis: calc(75% - 40px);
        max-width: calc(75% - 40px);
    }

    .gutter--large>.col-sm-10 {
        flex-basis: calc(83.33333% - 40px);
        max-width: calc(83.33333% - 40px);
    }

    .gutter--large>.col-sm-11 {
        flex-basis: calc(91.66667% - 40px);
        max-width: calc(91.66667% - 40px);
    }

    .gutter--large>.col-sm-12 {
        flex-basis: calc(100% - 40px);
        flex-basis: 100%;
        max-width: calc(100% - 40px);
        max-width: 100%;
    }

    .gutter--huge {
        justify-content: space-between;
    }

    .gutter--huge>.col-sm-1 {
        flex-basis: calc(8.33333% - 55px);
        max-width: calc(8.33333% - 55px);
    }

    .gutter--huge>.col-sm-2 {
        flex-basis: calc(16.66667% - 55px);
        max-width: calc(16.66667% - 55px);
    }

    .gutter--huge>.col-sm-3 {
        flex-basis: calc(25% - 55px);
        max-width: calc(25% - 55px);
    }

    .gutter--huge>.col-sm-4 {
        flex-basis: calc(33.33333% - 55px);
        max-width: calc(33.33333% - 55px);
    }

    .gutter--huge>.col-sm-5 {
        flex-basis: calc(41.66667% - 55px);
        max-width: calc(41.66667% - 55px);
    }

    .gutter--huge>.col-sm-6 {
        flex-basis: calc(50% - 55px);
        max-width: calc(50% - 55px);
    }

    .gutter--huge>.col-sm-7 {
        flex-basis: calc(58.33333% - 55px);
        max-width: calc(58.33333% - 55px);
    }

    .gutter--huge>.col-sm-8 {
        flex-basis: calc(66.66667% - 55px);
        max-width: calc(66.66667% - 55px);
    }

    .gutter--huge>.col-sm-9 {
        flex-basis: calc(75% - 55px);
        max-width: calc(75% - 55px);
    }

    .gutter--huge>.col-sm-10 {
        flex-basis: calc(83.33333% - 55px);
        max-width: calc(83.33333% - 55px);
    }

    .gutter--huge>.col-sm-11 {
        flex-basis: calc(91.66667% - 55px);
        max-width: calc(91.66667% - 55px);
    }

    .gutter--huge>.col-sm-12 {
        flex-basis: calc(100% - 55px);
        flex-basis: 100%;
        max-width: calc(100% - 55px);
        max-width: 100%;
    }

    [dir="ltr"] .start-sm {
        text-align: left;
    }

    [dir="rtl"] .start-sm {
        text-align: right;
    }

    .start-sm {
        justify-content: flex-start;
    }

    .center-sm {
        justify-content: center;
        text-align: center;
    }

    [dir="ltr"] .end-sm {
        text-align: right;
    }

    [dir="rtl"] .end-sm {
        text-align: left;
    }

    .end-sm {
        justify-content: flex-end;
    }

    .top-sm {
        align-items: flex-start;
    }

    .middle-sm {
        align-items: center;
    }

    .bottom-sm {
        align-items: flex-end;
    }

    .baseline-sm {
        align-items: baseline;
    }

    .around-sm {
        justify-content: space-around;
    }

    .between-sm {
        justify-content: space-between;
    }

    .first-sm {
        order: -1;
    }

    .last-sm {
        order: 1;
    }
}

@media only screen and (min-width: 64em) {

    .col-md,
    .col-md-1,
    .col-md-10,
    .col-md-11,
    .col-md-12,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-offset-0,
    .col-md-offset-1,
    .col-md-offset-10,
    .col-md-offset-11,
    .col-md-offset-12,
    .col-md-offset-2,
    .col-md-offset-3,
    .col-md-offset-4,
    .col-md-offset-5,
    .col-md-offset-6,
    .col-md-offset-7,
    .col-md-offset-8,
    .col-md-offset-9 {
        flex: 0 0 auto;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .col-md {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-md-1 {
        flex-basis: 8.3333333333%;
        max-width: 8.3333333333%;
    }

    .col-md-2 {
        flex-basis: 16.6666666667%;
        max-width: 16.6666666667%;
    }

    .col-md-3 {
        flex-basis: 25%;
        max-width: 25%;
    }

    .col-md-4 {
        flex-basis: 33.3333333333%;
        max-width: 33.3333333333%;
    }

    .col-md-5 {
        flex-basis: 41.6666666667%;
        max-width: 41.6666666667%;
    }

    .col-md-6 {
        flex-basis: 50%;
        max-width: 50%;
    }

    .col-md-7 {
        flex-basis: 58.3333333333%;
        max-width: 58.3333333333%;
    }

    .col-md-8 {
        flex-basis: 66.6666666667%;
        max-width: 66.6666666667%;
    }

    .col-md-9 {
        flex-basis: 75%;
        max-width: 75%;
    }

    .col-md-10 {
        flex-basis: 83.3333333333%;
        max-width: 83.3333333333%;
    }

    .col-md-11 {
        flex-basis: 91.6666666667%;
        max-width: 91.6666666667%;
    }

    .col-md-12 {
        flex-basis: 100%;
        max-width: 100%;
    }

    .gutter--small {
        justify-content: space-between;
    }

    .gutter--small>.col-md-1 {
        flex-basis: calc(8.33333% - 15px);
        max-width: calc(8.33333% - 15px);
    }

    .gutter--small>.col-md-2 {
        flex-basis: calc(16.66667% - 15px);
        max-width: calc(16.66667% - 15px);
    }

    .gutter--small>.col-md-3 {
        flex-basis: calc(25% - 15px);
        max-width: calc(25% - 15px);
    }

    .gutter--small>.col-md-4 {
        flex-basis: calc(33.33333% - 15px);
        max-width: calc(33.33333% - 15px);
    }

    .gutter--small>.col-md-5 {
        flex-basis: calc(41.66667% - 15px);
        max-width: calc(41.66667% - 15px);
    }

    .gutter--small>.col-md-6 {
        flex-basis: calc(50% - 15px);
        max-width: calc(50% - 15px);
    }

    .gutter--small>.col-md-7 {
        flex-basis: calc(58.33333% - 15px);
        max-width: calc(58.33333% - 15px);
    }

    .gutter--small>.col-md-8 {
        flex-basis: calc(66.66667% - 15px);
        max-width: calc(66.66667% - 15px);
    }

    .gutter--small>.col-md-9 {
        flex-basis: calc(75% - 15px);
        max-width: calc(75% - 15px);
    }

    .gutter--small>.col-md-10 {
        flex-basis: calc(83.33333% - 15px);
        max-width: calc(83.33333% - 15px);
    }

    .gutter--small>.col-md-11 {
        flex-basis: calc(91.66667% - 15px);
        max-width: calc(91.66667% - 15px);
    }

    .gutter--small>.col-md-12 {
        flex-basis: calc(100% - 15px);
        flex-basis: 100%;
        max-width: calc(100% - 15px);
        max-width: 100%;
    }

    .gutter--medium {
        justify-content: space-between;
    }

    .gutter--medium>.col-md-1 {
        flex-basis: calc(8.33333% - 25px);
        max-width: calc(8.33333% - 25px);
    }

    .gutter--medium>.col-md-2 {
        flex-basis: calc(16.66667% - 25px);
        max-width: calc(16.66667% - 25px);
    }

    .gutter--medium>.col-md-3 {
        flex-basis: calc(25% - 25px);
        max-width: calc(25% - 25px);
    }

    .gutter--medium>.col-md-4 {
        flex-basis: calc(33.33333% - 25px);
        max-width: calc(33.33333% - 25px);
    }

    .gutter--medium>.col-md-5 {
        flex-basis: calc(41.66667% - 25px);
        max-width: calc(41.66667% - 25px);
    }

    .gutter--medium>.col-md-6 {
        flex-basis: calc(50% - 25px);
        max-width: calc(50% - 25px);
    }

    .gutter--medium>.col-md-7 {
        flex-basis: calc(58.33333% - 25px);
        max-width: calc(58.33333% - 25px);
    }

    .gutter--medium>.col-md-8 {
        flex-basis: calc(66.66667% - 25px);
        max-width: calc(66.66667% - 25px);
    }

    .gutter--medium>.col-md-9 {
        flex-basis: calc(75% - 25px);
        max-width: calc(75% - 25px);
    }

    .gutter--medium>.col-md-10 {
        flex-basis: calc(83.33333% - 25px);
        max-width: calc(83.33333% - 25px);
    }

    .gutter--medium>.col-md-11 {
        flex-basis: calc(91.66667% - 25px);
        max-width: calc(91.66667% - 25px);
    }

    .gutter--medium>.col-md-12 {
        flex-basis: calc(100% - 25px);
        flex-basis: 100%;
        max-width: calc(100% - 25px);
        max-width: 100%;
    }

    .gutter--large {
        justify-content: space-between;
    }

    .gutter--large>.col-md-1 {
        flex-basis: calc(8.33333% - 40px);
        max-width: calc(8.33333% - 40px);
    }

    .gutter--large>.col-md-2 {
        flex-basis: calc(16.66667% - 40px);
        max-width: calc(16.66667% - 40px);
    }

    .gutter--large>.col-md-3 {
        flex-basis: calc(25% - 40px);
        max-width: calc(25% - 40px);
    }

    .gutter--large>.col-md-4 {
        flex-basis: calc(33.33333% - 40px);
        max-width: calc(33.33333% - 40px);
    }

    .gutter--large>.col-md-5 {
        flex-basis: calc(41.66667% - 40px);
        max-width: calc(41.66667% - 40px);
    }

    .gutter--large>.col-md-6 {
        flex-basis: calc(50% - 40px);
        max-width: calc(50% - 40px);
    }

    .gutter--large>.col-md-7 {
        flex-basis: calc(58.33333% - 40px);
        max-width: calc(58.33333% - 40px);
    }

    .gutter--large>.col-md-8 {
        flex-basis: calc(66.66667% - 40px);
        max-width: calc(66.66667% - 40px);
    }

    .gutter--large>.col-md-9 {
        flex-basis: calc(75% - 40px);
        max-width: calc(75% - 40px);
    }

    .gutter--large>.col-md-10 {
        flex-basis: calc(83.33333% - 40px);
        max-width: calc(83.33333% - 40px);
    }

    .gutter--large>.col-md-11 {
        flex-basis: calc(91.66667% - 40px);
        max-width: calc(91.66667% - 40px);
    }

    .gutter--large>.col-md-12 {
        flex-basis: calc(100% - 40px);
        flex-basis: 100%;
        max-width: calc(100% - 40px);
        max-width: 100%;
    }

    .gutter--huge {
        justify-content: space-between;
    }

    .gutter--huge>.col-md-1 {
        flex-basis: calc(8.33333% - 55px);
        max-width: calc(8.33333% - 55px);
    }

    .gutter--huge>.col-md-2 {
        flex-basis: calc(16.66667% - 55px);
        max-width: calc(16.66667% - 55px);
    }

    .gutter--huge>.col-md-3 {
        flex-basis: calc(25% - 55px);
        max-width: calc(25% - 55px);
    }

    .gutter--huge>.col-md-4 {
        flex-basis: calc(33.33333% - 55px);
        max-width: calc(33.33333% - 55px);
    }

    .gutter--huge>.col-md-5 {
        flex-basis: calc(41.66667% - 55px);
        max-width: calc(41.66667% - 55px);
    }

    .gutter--huge>.col-md-6 {
        flex-basis: calc(50% - 55px);
        max-width: calc(50% - 55px);
    }

    .gutter--huge>.col-md-7 {
        flex-basis: calc(58.33333% - 55px);
        max-width: calc(58.33333% - 55px);
    }

    .gutter--huge>.col-md-8 {
        flex-basis: calc(66.66667% - 55px);
        max-width: calc(66.66667% - 55px);
    }

    .gutter--huge>.col-md-9 {
        flex-basis: calc(75% - 55px);
        max-width: calc(75% - 55px);
    }

    .gutter--huge>.col-md-10 {
        flex-basis: calc(83.33333% - 55px);
        max-width: calc(83.33333% - 55px);
    }

    .gutter--huge>.col-md-11 {
        flex-basis: calc(91.66667% - 55px);
        max-width: calc(91.66667% - 55px);
    }

    .gutter--huge>.col-md-12 {
        flex-basis: calc(100% - 55px);
        flex-basis: 100%;
        max-width: calc(100% - 55px);
        max-width: 100%;
    }

    .col-md-offset-0 {
        margin-left: 0;
    }

    .col-md-offset-1 {
        margin-left: 8.3333333333%;
    }

    .col-md-offset-2 {
        margin-left: 16.6666666667%;
    }

    .col-md-offset-3 {
        margin-left: 25%;
    }

    .col-md-offset-4 {
        margin-left: 33.3333333333%;
    }

    .col-md-offset-5 {
        margin-left: 41.6666666667%;
    }

    .col-md-offset-6 {
        margin-left: 50%;
    }

    .col-md-offset-7 {
        margin-left: 58.3333333333%;
    }

    .col-md-offset-8 {
        margin-left: 66.6666666667%;
    }

    .col-md-offset-9 {
        margin-left: 75%;
    }

    .col-md-offset-10 {
        margin-left: 83.3333333333%;
    }

    .col-md-offset-11 {
        margin-left: 91.6666666667%;
    }

    .col-md-offset-12 {
        margin-left: 100%;
    }

    [dir="ltr"] .start-md {
        text-align: left;
    }

    [dir="rtl"] .start-md {
        text-align: right;
    }

    .start-md {
        justify-content: flex-start;
    }

    .center-md {
        justify-content: center;
        text-align: center;
    }

    [dir="ltr"] .end-md {
        text-align: right;
    }

    [dir="rtl"] .end-md {
        text-align: left;
    }

    .end-md {
        justify-content: flex-end;
    }

    .top-md {
        align-items: flex-start;
    }

    .middle-md {
        align-items: center;
    }

    .bottom-md {
        align-items: flex-end;
    }

    .baseline-md {
        align-items: baseline;
    }

    .around-md {
        justify-content: space-around;
    }

    .between-md {
        justify-content: space-between;
    }

    .first-md {
        order: -1;
    }

    .last-md {
        order: 1;
    }
}

@media only screen and (min-width: 75em) {

    .col-lg,
    .col-lg-1,
    .col-lg-10,
    .col-lg-11,
    .col-lg-12,
    .col-lg-2,
    .col-lg-3,
    .col-lg-4,
    .col-lg-5,
    .col-lg-6,
    .col-lg-7,
    .col-lg-8,
    .col-lg-9,
    .col-lg-offset-0,
    .col-lg-offset-1,
    .col-lg-offset-10,
    .col-lg-offset-11,
    .col-lg-offset-12,
    .col-lg-offset-2,
    .col-lg-offset-3,
    .col-lg-offset-4,
    .col-lg-offset-5,
    .col-lg-offset-6,
    .col-lg-offset-7,
    .col-lg-offset-8,
    .col-lg-offset-9 {
        flex: 0 0 auto;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .col-lg {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-lg-1 {
        flex-basis: 8.3333333333%;
        max-width: 8.3333333333%;
    }

    .col-lg-2 {
        flex-basis: 16.6666666667%;
        max-width: 16.6666666667%;
    }

    .col-lg-3 {
        flex-basis: 25%;
        max-width: 25%;
    }

    .col-lg-4 {
        flex-basis: 33.3333333333%;
        max-width: 33.3333333333%;
    }

    .col-lg-5 {
        flex-basis: 41.6666666667%;
        max-width: 41.6666666667%;
    }

    .col-lg-6 {
        flex-basis: 50%;
        max-width: 50%;
    }

    .col-lg-7 {
        flex-basis: 58.3333333333%;
        max-width: 58.3333333333%;
    }

    .col-lg-8 {
        flex-basis: 66.6666666667%;
        max-width: 66.6666666667%;
    }

    .col-lg-9 {
        flex-basis: 75%;
        max-width: 75%;
    }

    .col-lg-10 {
        flex-basis: 83.3333333333%;
        max-width: 83.3333333333%;
    }

    .col-lg-11 {
        flex-basis: 91.6666666667%;
        max-width: 91.6666666667%;
    }

    .col-lg-12 {
        flex-basis: 100%;
        max-width: 100%;
    }

    .gutter--small {
        justify-content: space-between;
    }

    .gutter--small>.col-lg-1 {
        flex-basis: calc(8.33333% - 15px);
        max-width: calc(8.33333% - 15px);
    }

    .gutter--small>.col-lg-2 {
        flex-basis: calc(16.66667% - 15px);
        max-width: calc(16.66667% - 15px);
    }

    .gutter--small>.col-lg-3 {
        flex-basis: calc(25% - 15px);
        max-width: calc(25% - 15px);
    }

    .gutter--small>.col-lg-4 {
        flex-basis: calc(33.33333% - 15px);
        max-width: calc(33.33333% - 15px);
    }

    .gutter--small>.col-lg-5 {
        flex-basis: calc(41.66667% - 15px);
        max-width: calc(41.66667% - 15px);
    }

    .gutter--small>.col-lg-6 {
        flex-basis: calc(50% - 15px);
        max-width: calc(50% - 15px);
    }

    .gutter--small>.col-lg-7 {
        flex-basis: calc(58.33333% - 15px);
        max-width: calc(58.33333% - 15px);
    }

    .gutter--small>.col-lg-8 {
        flex-basis: calc(66.66667% - 15px);
        max-width: calc(66.66667% - 15px);
    }

    .gutter--small>.col-lg-9 {
        flex-basis: calc(75% - 15px);
        max-width: calc(75% - 15px);
    }

    .gutter--small>.col-lg-10 {
        flex-basis: calc(83.33333% - 15px);
        max-width: calc(83.33333% - 15px);
    }

    .gutter--small>.col-lg-11 {
        flex-basis: calc(91.66667% - 15px);
        max-width: calc(91.66667% - 15px);
    }

    .gutter--small>.col-lg-12 {
        flex-basis: calc(100% - 15px);
        flex-basis: 100%;
        max-width: calc(100% - 15px);
        max-width: 100%;
    }

    .gutter--medium {
        justify-content: space-between;
    }

    .gutter--medium>.col-lg-1 {
        flex-basis: calc(8.33333% - 25px);
        max-width: calc(8.33333% - 25px);
    }

    .gutter--medium>.col-lg-2 {
        flex-basis: calc(16.66667% - 25px);
        max-width: calc(16.66667% - 25px);
    }

    .gutter--medium>.col-lg-3 {
        flex-basis: calc(25% - 25px);
        max-width: calc(25% - 25px);
    }

    .gutter--medium>.col-lg-4 {
        flex-basis: calc(33.33333% - 25px);
        max-width: calc(33.33333% - 25px);
    }

    .gutter--medium>.col-lg-5 {
        flex-basis: calc(41.66667% - 25px);
        max-width: calc(41.66667% - 25px);
    }

    .gutter--medium>.col-lg-6 {
        flex-basis: calc(50% - 25px);
        max-width: calc(50% - 25px);
    }

    .gutter--medium>.col-lg-7 {
        flex-basis: calc(58.33333% - 25px);
        max-width: calc(58.33333% - 25px);
    }

    .gutter--medium>.col-lg-8 {
        flex-basis: calc(66.66667% - 25px);
        max-width: calc(66.66667% - 25px);
    }

    .gutter--medium>.col-lg-9 {
        flex-basis: calc(75% - 25px);
        max-width: calc(75% - 25px);
    }

    .gutter--medium>.col-lg-10 {
        flex-basis: calc(83.33333% - 25px);
        max-width: calc(83.33333% - 25px);
    }

    .gutter--medium>.col-lg-11 {
        flex-basis: calc(91.66667% - 25px);
        max-width: calc(91.66667% - 25px);
    }

    .gutter--medium>.col-lg-12 {
        flex-basis: calc(100% - 25px);
        flex-basis: 100%;
        max-width: calc(100% - 25px);
        max-width: 100%;
    }

    .gutter--large {
        justify-content: space-between;
    }

    .gutter--large>.col-lg-1 {
        flex-basis: calc(8.33333% - 40px);
        max-width: calc(8.33333% - 40px);
    }

    .gutter--large>.col-lg-2 {
        flex-basis: calc(16.66667% - 40px);
        max-width: calc(16.66667% - 40px);
    }

    .gutter--large>.col-lg-3 {
        flex-basis: calc(25% - 40px);
        max-width: calc(25% - 40px);
    }

    .gutter--large>.col-lg-4 {
        flex-basis: calc(33.33333% - 40px);
        max-width: calc(33.33333% - 40px);
    }

    .gutter--large>.col-lg-5 {
        flex-basis: calc(41.66667% - 40px);
        max-width: calc(41.66667% - 40px);
    }

    .gutter--large>.col-lg-6 {
        flex-basis: calc(50% - 40px);
        max-width: calc(50% - 40px);
    }

    .gutter--large>.col-lg-7 {
        flex-basis: calc(58.33333% - 40px);
        max-width: calc(58.33333% - 40px);
    }

    .gutter--large>.col-lg-8 {
        flex-basis: calc(66.66667% - 40px);
        max-width: calc(66.66667% - 40px);
    }

    .gutter--large>.col-lg-9 {
        flex-basis: calc(75% - 40px);
        max-width: calc(75% - 40px);
    }

    .gutter--large>.col-lg-10 {
        flex-basis: calc(83.33333% - 40px);
        max-width: calc(83.33333% - 40px);
    }

    .gutter--large>.col-lg-11 {
        flex-basis: calc(91.66667% - 40px);
        max-width: calc(91.66667% - 40px);
    }

    .gutter--large>.col-lg-12 {
        flex-basis: calc(100% - 40px);
        flex-basis: 100%;
        max-width: calc(100% - 40px);
        max-width: 100%;
    }

    .gutter--huge {
        justify-content: space-between;
    }

    .gutter--huge>.col-lg-1 {
        flex-basis: calc(8.33333% - 55px);
        max-width: calc(8.33333% - 55px);
    }

    .gutter--huge>.col-lg-2 {
        flex-basis: calc(16.66667% - 55px);
        max-width: calc(16.66667% - 55px);
    }

    .gutter--huge>.col-lg-3 {
        flex-basis: calc(25% - 55px);
        max-width: calc(25% - 55px);
    }

    .gutter--huge>.col-lg-4 {
        flex-basis: calc(33.33333% - 55px);
        max-width: calc(33.33333% - 55px);
    }

    .gutter--huge>.col-lg-5 {
        flex-basis: calc(41.66667% - 55px);
        max-width: calc(41.66667% - 55px);
    }

    .gutter--huge>.col-lg-6 {
        flex-basis: calc(50% - 55px);
        max-width: calc(50% - 55px);
    }

    .gutter--huge>.col-lg-7 {
        flex-basis: calc(58.33333% - 55px);
        max-width: calc(58.33333% - 55px);
    }

    .gutter--huge>.col-lg-8 {
        flex-basis: calc(66.66667% - 55px);
        max-width: calc(66.66667% - 55px);
    }

    .gutter--huge>.col-lg-9 {
        flex-basis: calc(75% - 55px);
        max-width: calc(75% - 55px);
    }

    .gutter--huge>.col-lg-10 {
        flex-basis: calc(83.33333% - 55px);
        max-width: calc(83.33333% - 55px);
    }

    .gutter--huge>.col-lg-11 {
        flex-basis: calc(91.66667% - 55px);
        max-width: calc(91.66667% - 55px);
    }

    .gutter--huge>.col-lg-12 {
        flex-basis: calc(100% - 55px);
        flex-basis: 100%;
        max-width: calc(100% - 55px);
        max-width: 100%;
    }

    .col-lg-offset-0 {
        margin-left: 0;
    }

    .col-lg-offset-1 {
        margin-left: 8.3333333333%;
    }

    .col-lg-offset-2 {
        margin-left: 16.6666666667%;
    }

    .col-lg-offset-3 {
        margin-left: 25%;
    }

    .col-lg-offset-4 {
        margin-left: 33.3333333333%;
    }

    .col-lg-offset-5 {
        margin-left: 41.6666666667%;
    }

    .col-lg-offset-6 {
        margin-left: 50%;
    }

    .col-lg-offset-7 {
        margin-left: 58.3333333333%;
    }

    .col-lg-offset-8 {
        margin-left: 66.6666666667%;
    }

    .col-lg-offset-9 {
        margin-left: 75%;
    }

    .col-lg-offset-10 {
        margin-left: 83.3333333333%;
    }

    .col-lg-offset-11 {
        margin-left: 91.6666666667%;
    }

    .col-lg-offset-12 {
        margin-left: 100%;
    }

    [dir="ltr"] .start-lg {
        text-align: left;
    }

    [dir="rtl"] .start-lg {
        text-align: right;
    }

    .start-lg {
        justify-content: flex-start;
    }

    .center-lg {
        justify-content: center;
        text-align: center;
    }

    [dir="ltr"] .end-lg {
        text-align: right;
    }

    [dir="rtl"] .end-lg {
        text-align: left;
    }

    .end-lg {
        justify-content: flex-end;
    }

    .top-lg {
        align-items: flex-start;
    }

    .middle-lg {
        align-items: center;
    }

    .bottom-lg {
        align-items: flex-end;
    }

    .baseline-lg {
        align-items: baseline;
    }

    .around-lg {
        justify-content: space-around;
    }

    .between-lg {
        justify-content: space-between;
    }

    .first-lg {
        order: -1;
    }

    .last-lg {
        order: 1;
    }
}

@font-face {
    font-display: swap;
    font-family: Brandon Text;
    font-style: normal;
    font-weight: 300;
    src: url(/wp-content/themes/kinsta/fonts/BrandonText-light.woff2) format("woff2"),
        url(/wp-content/themes/kinsta/fonts/BrandonText-light.woff) format("woff");
}

@font-face {
    font-display: swap;
    font-family: Brandon Text;
    font-style: bold;
    font-weight: 600;
    src: url(/wp-content/themes/kinsta/fonts/BrandonText-Medium.woff2) format("woff2"),
        url(/wp-content/themes/kinsta/fonts/BrandonText-Medium.woff) format("woff");
}

@font-face {
    font-display: swap;
    font-family: Brandon Text;
    font-style: normal;
    font-weight: 900;
    src: url(/wp-content/themes/kinsta/fonts/BrandonText-Black.woff2) format("woff2"),
        url(/wp-content/themes/kinsta/fonts/BrandonText-Black.woff) format("woff");
}

@font-face {
    font-display: fallback;
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    src: local(""),
        url(/wp-content/themes/kinsta/fonts/roboto/Roboto-300.woff2) format("woff2"),
        url(/wp-content/themes/kinsta/fonts/roboto/Roboto-300.woff) format("woff");
}

@font-face {
    font-display: fallback;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    src: local(""),
        url(/wp-content/themes/kinsta/fonts/roboto/Roboto-regular.woff2) format("woff2"),
        url(/wp-content/themes/kinsta/fonts/roboto/Roboto-regular.woff) format("woff");
}

@font-face {
    font-display: fallback;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    src: local(""),
        url(/wp-content/themes/kinsta/fonts/roboto/Roboto-500.woff2) format("woff2"),
        url(/wp-content/themes/kinsta/fonts/roboto/Roboto-500.woff) format("woff");
}

@font-face {
    font-display: fallback;
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    src: local(""),
        url(/wp-content/themes/kinsta/fonts/roboto/Roboto-700.woff2) format("woff2"),
        url(/wp-content/themes/kinsta/fonts/roboto/Roboto-700.woff) format("woff");
}

body {
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: "kern";
    color: #6e7076;
    font-family: Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen-Sans,
        Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-kerning: normal;
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.6;
}

@media (min-width: 64em) {
    body {
        font-size: 1.125rem;
    }
}

p {
    margin-bottom: 1rem;
    margin-top: 0;
}

em {
    font-style: italic;
}

li code,
p code {
    background: #f9f9fb;
    border: 1px solid #eaeaf1;
    border-radius: 0.25rem;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono,
        Courier New, monospace;
    font-size: 0.8em;
    padding: 0.25rem 0.5rem;
}

.breadcrumbs__link:link,
.slidelink,
.slidelink--mediumGray,
.slidelink--purple,
.slidelink--text,
.slidelink--white,
.unslidelink,
.unslidelink--mediumGray,
.unslidelink--purple,
.unslidelink--text,
.unslidelink--white,
.user-content a:not(.button):not(.notusercontentlink) {
    background-repeat: no-repeat;
    position: relative;
    text-decoration: none;
    transition: all 0.2s;
}

.breadcrumbs__link:link,
.slidelink,
.slidelink--mediumGray,
.slidelink--purple,
.slidelink--text,
.slidelink--white {
    background-size: 0 100%;
}

.breadcrumbs__link:hover:link,
.hovered.breadcrumbs__link:link,
.hovered.slidelink--mediumGray,
.hovered.slidelink--purple,
.hovered.slidelink--text,
.hovered.slidelink--white,
.slidelink--mediumGray:hover,
.slidelink--purple:hover,
.slidelink--text:hover,
.slidelink--white:hover,
.slidelink.hovered,
.slidelink:hover {
    background-size: 100% 100%;
}

.unslidelink,
.unslidelink--mediumGray,
.unslidelink--purple,
.unslidelink--text,
.unslidelink--white,
.user-content a:not(.button):not(.notusercontentlink) {
    background-position: 100%;
    background-size: 100% 100%;
}

.hovered.unslidelink--mediumGray,
.hovered.unslidelink--purple,
.hovered.unslidelink--text,
.hovered.unslidelink--white,
.unslidelink--mediumGray:hover,
.unslidelink--purple:hover,
.unslidelink--text:hover,
.unslidelink--white:hover,
.unslidelink.hovered,
.unslidelink:hover,
.user-content a.hovered:not(.button):not(.notusercontentlink),
.user-content a:hover:not(.button):not(.notusercontentlink) {
    background-size: 0 100%;
}

.breadcrumbs__link:link,
.slidelink--mediumGray {
    background-image: linear-gradient(transparent calc(100% - 2px), #999 2px);
    color: #999;
}

.unslidelink--mediumGray {
    background-image: linear-gradient(transparent calc(100% - 1px), #999 1px);
    color: #999;
}

.slidelink--text {
    background-image: linear-gradient(transparent calc(100% - 2px), #44414e 2px);
    color: #44414e;
}

.unslidelink--text {
    background-image: linear-gradient(transparent calc(100% - 1px), #6e7076 1px);
    color: #6e7076;
}

.slidelink--purple {
    background-image: linear-gradient(transparent calc(100% - 2px), #5333ed 2px);
    color: #5333ed;
}

.unslidelink--purple,
.user-content a:not(.button):not(.notusercontentlink) {
    background-image: linear-gradient(transparent calc(100% - 1px), #5333ed 1px);
    color: #5333ed;
}

.unslidelink--white {
    background-image: linear-gradient(transparent calc(100% - 1px), #fff 1px);
    color: #fff;
}

.slidelink--thin,
.unslidelink--thin {
    background-image: linear-gradient(transparent calc(100% - 0.5px), #fff 1px);
}

.slidelink--white {
    background-image: linear-gradient(transparent calc(100% - 2px), #fff 2px);
    color: #fff;
}

@supports (-ms-ime-align: auto) {

    .breadcrumbs__link:link,
    .slidelink,
    .slidelink--mediumGray,
    .slidelink--purple,
    .slidelink--text,
    .slidelink--white {
        background-size: 0;
    }

    .breadcrumbs__link:hover:link,
    .slidelink--mediumGray:hover,
    .slidelink--purple:hover,
    .slidelink--text:hover,
    .slidelink--white:hover,
    .slidelink:hover,
    .unslidelink,
    .unslidelink--mediumGray,
    .unslidelink--purple,
    .unslidelink--text,
    .unslidelink--white,
    .user-content a:not(.button):not(.notusercontentlink) {
        background-size: 0;
        text-decoration: underline;
    }

    .unslidelink--mediumGray:hover,
    .unslidelink--purple:hover,
    .unslidelink--text:hover,
    .unslidelink--white:hover,
    .unslidelink:hover,
    .user-content a:hover:not(.button):not(.notusercontentlink) {
        background-size: 0;
        text-decoration: none;
    }
}

.underline--dashed,
.user-content abbr {
    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
}

.underline--dashed:hover,
.user-content abbr:hover {
    border-bottom: 1px dashed #5333ed;
    cursor: pointer;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
.heading,
.heading--big,
.heading--huge,
.heading--large,
.heading--medium,
.heading--normal,
.heading--small,
.heading--tiny,
.heading--white,
.plan-box--up-to,
h1,
h2,
h3,
h4,
h5,
h6 {
    color: #0c022f;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 900;
    line-height: 1.2;
    word-break: break-word;
}

.h1 strong,
.h2 strong,
.h3 strong,
.h4 strong,
.h5 strong,
.h6 strong,
.heading strong,
.heading--big strong,
.heading--huge strong,
.heading--large strong,
.heading--medium strong,
.heading--normal strong,
.heading--small strong,
.heading--tiny strong,
.heading--white strong,
.plan-box--up-to strong,
h1 strong,
h2 strong,
h3 strong,
h4 strong,
h5 strong,
h6 strong {
    font-weight: inherit;
}

.h1 a,
.h2 a,
.h3 a,
.h4 a,
.h5 a,
.h6 a,
.heading a,
.heading--big a,
.heading--huge a,
.heading--large a,
.heading--medium a,
.heading--normal a,
.heading--small a,
.heading--tiny a,
.heading--white a,
.plan-box--up-to a,
[class*="color--"] .h1,
[class*="color--"] .h2,
[class*="color--"] .h3,
[class*="color--"] .h4,
[class*="color--"] .h5,
[class*="color--"] .h6,
[class*="color--"] .heading,
[class*="color--"] .heading--big,
[class*="color--"] .heading--huge,
[class*="color--"] .heading--large,
[class*="color--"] .heading--medium,
[class*="color--"] .heading--normal,
[class*="color--"] .heading--small,
[class*="color--"] .heading--tiny,
[class*="color--"] .heading--white,
[class*="color--"] .plan-box--up-to,
[class*="color--"] h1,
[class*="color--"] h2,
[class*="color--"] h3,
[class*="color--"] h4,
[class*="color--"] h5,
[class*="color--"] h6,
h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a {
    color: inherit;
}

.h1,
.heading--huge,
h1 {
    font-size: 2.75rem;
    line-height: 1.1;
    margin-bottom: 2.5rem;
    margin-top: 2rem;
}

@media (min-width: 64em) {

    .h1,
    .heading--huge,
    h1 {
        font-size: 3.5rem;
    }
}

.h2,
.heading--big,
.heading--large,
h2 {
    font-size: 2rem;
    line-height: 1.1;
    margin-bottom: 1.5rem;
    margin-top: 5rem;
}

@media (min-width: 64em) {

    .h2,
    .heading--big,
    .heading--large,
    h2 {
        font-size: 2.625rem;
    }
}

.h3,
h3 {
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
    margin-top: 3rem;
}

@media (min-width: 64em) {

    .h3,
    h3 {
        font-size: 1.5rem;
    }
}

.h4,
h4 {
    font-size: 1rem;
    margin-bottom: 1rem;
    margin-top: 2rem;
}

@media (min-width: 64em) {

    .h4,
    h4 {
        font-size: 1.125rem;
    }
}

.h5,
h5 {
    font-size: 0.875rem;
    margin-bottom: 1rem;
    margin-top: 2.5rem;
}

@media (min-width: 64em) {

    .h5,
    h5 {
        font-size: 1rem;
    }
}

.h6,
h6 {
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
}

@media (min-width: 64em) {

    .h6,
    h6 {
        font-size: 1rem;
    }
}

.heading,
.heading--big,
.heading--huge,
.heading--large,
.heading--medium,
.heading--normal,
.heading--small,
.heading--tiny,
.heading--white,
.plan-box--up-to {
    margin-bottom: 0;
    margin-top: 0;
}

.heading--medium {
    font-size: 1.25rem;
}

@media (min-width: 64em) {
    .heading--medium {
        font-size: 1.5rem;
    }
}

.heading--normal {
    font-size: 1rem;
}

@media (min-width: 64em) {
    .heading--normal {
        font-size: 1.125rem;
    }
}

.heading--small,
.plan-box--up-to {
    font-size: 1rem;
    font-weight: 600;
}

@media (min-width: 64em) {

    .heading--small,
    .plan-box--up-to {
        font-size: 1.125rem;
    }
}

.heading--tiny {
    font-size: 0.875rem;
    font-weight: 600;
}

@media (min-width: 64em) {
    .heading--tiny {
        font-size: 1rem;
    }
}

.heading--uppercased {
    text-transform: uppercase;
}

.color--mediumGray {
    color: #999;
}

.color--white,
.color--white .heading,
.color--white.heading,
.swiper-slide-active .heading.plan-box.plan-box--active--color--white,
.swiper-slide-active .plan-box.plan-box--active--color--white,
.swiper-slide-active .plan-box.plan-box--active--color--white .heading {
    color: #fff;
}

.color--green,
.color--green .heading,
.color--green.heading {
    color: #2cd4d9;
}

.color--purple,
.color--purple .heading,
.color--purple.heading {
    color: #5333ed;
}

.color--blue,
.color--blue .heading,
.color--blue.heading {
    color: #150773;
}

.color--darkBlue,
.color--darkBlue .heading,
.color--darkBlue.heading {
    color: #0c022f;
}

.link--on--dark {
    color: #fff;
    text-decoration: underline;
}

.link--on--dark:hover {
    color: #2cd4d9;
}

.text--link,
.text--link--green--underline,
.text--link--greenhover {
    color: inherit;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.12s linear;
}

.hovered.text--link--green--underline,
.hovered.text--link--green--underline h1,
.hovered.text--link--green--underline h2,
.hovered.text--link--green--underline h3,
.hovered.text--link--green--underline h4,
.hovered.text--link--green--underline h5,
.hovered.text--link--green--underline h6,
.hovered.text--link--greenhover,
.hovered.text--link--greenhover h1,
.hovered.text--link--greenhover h2,
.hovered.text--link--greenhover h3,
.hovered.text--link--greenhover h4,
.hovered.text--link--greenhover h5,
.hovered.text--link--greenhover h6,
.text--link--green--underline:hover,
.text--link--green--underline:hover h1,
.text--link--green--underline:hover h2,
.text--link--green--underline:hover h3,
.text--link--green--underline:hover h4,
.text--link--green--underline:hover h5,
.text--link--green--underline:hover h6,
.text--link--greenhover:hover,
.text--link--greenhover:hover h1,
.text--link--greenhover:hover h2,
.text--link--greenhover:hover h3,
.text--link--greenhover:hover h4,
.text--link--greenhover:hover h5,
.text--link--greenhover:hover h6,
.text--link.hovered,
.text--link.hovered h1,
.text--link.hovered h2,
.text--link.hovered h3,
.text--link.hovered h4,
.text--link.hovered h5,
.text--link.hovered h6,
.text--link:hover,
.text--link:hover h1,
.text--link:hover h2,
.text--link:hover h3,
.text--link:hover h4,
.text--link:hover h5,
.text--link:hover h6 {
    color: #5333ed;
}

.text--link--greenhover.hovered,
.text--link--greenhover:hover {
    color: #2cd4d9;
}

.text--link--underlined {
    text-decoration: underline;
}

.link--purple--green--underline,
.text--link--green--underline {
    border-bottom: 2px solid #2cd4d9;
    text-decoration: none;
}

.link--purple--green--underline {
    color: #5333ed;
    position: relative;
}

.link--purple--green--underline:before {
    border-bottom: 2px solid #5333ed;
    content: " ";
    height: 100%;
    position: absolute;
    top: 0;
    transition: all 0.12s linear;
    width: 0;
}

.link--purple--green--underline:hover:before {
    width: 100%;
}

.has-text-align-center,
.text--center {
    text-align: center;
}

.text--left {
    text-align: left;
}

.text--right {
    text-align: right;
}

@media only screen and (max-width: 47em) {
    .xs--text--center {
        text-align: center;
    }

    .xs--text--left {
        text-align: left;
    }
}

.label,
.label--blue,
.label--green,
.label--purple,
.text--tiny {
    font-size: 12px;
}

.kinsta-form .control-message,
.kinsta-form label,
.text--small,
.user-content .wp-caption-text,
.user-content code,
.user-content pre,
.user-content pre[class*="language-"],
.user-content table {
    font-size: 14px;
}

.text--normal {
    font-size: 16px;
}

.text--large {
    font-size: 18px;
    line-height: 1.6;
}

.text--huge {
    font-size: 22px;
}

.has-smallest-font-size {
    font-size: 0.625rem;
}

@media (min-width: 64em) {
    .has-smallest-font-size {
        font-size: 0.75rem;
    }
}

.has-smaller-font-size {
    font-size: 0.75rem;
}

@media (min-width: 64em) {
    .has-smaller-font-size {
        font-size: 0.875rem;
    }
}

.has-small-font-size {
    font-size: 0.875rem;
}

@media (min-width: 64em) {
    .has-small-font-size {
        font-size: 1rem;
    }
}

.has-normal-font-size {
    font-size: 1rem;
}

@media (min-width: 64em) {
    .has-normal-font-size {
        font-size: 1.125rem;
    }
}

.has-large-font-size {
    font-size: 1.25rem;
}

@media (min-width: 64em) {
    .has-large-font-size {
        font-size: 1.5rem;
    }
}

.has-larger-font-size {
    font-size: 2rem;
    line-height: 1.1;
}

@media (min-width: 64em) {
    .has-larger-font-size {
        font-size: 2.625rem;
    }
}

.has-largest-font-size {
    font-size: 2.75rem;
    line-height: 1.1;
}

@media (min-width: 64em) {
    .has-largest-font-size {
        font-size: 3.5rem;
    }
}

.text--color {
    color: #999;
}

.text--superbold {
    font-weight: 900;
}

.kinsta-form label:not(.optional):not(.checkbox-label),
.label--blue:not(.label--small),
.label--green:not(.label--small),
.label--purple:not(.label--small),
.label:not(.label--small),
.text--bold,
.user-content table th,
b,
strong {
    font-weight: 600;
}

.text--semibold {
    font-weight: 500;
}

.text--light {
    font-weight: 400;
}

.nowrap {
    white-space: nowrap;
}

.link--noformat {
    color: inherit;
    text-decoration: none;
}

.link--noformat:hover {
    color: inherit;
}

.anchor-hash {
    align-items: center;
    background: none !important;
    display: inline-flex;
    height: 1em;
    opacity: 0;
    position: absolute !important;
    transition: opacity 0.3s;
    vertical-align: middle;
}

.anchor-hash .icon {
    font-size: 0.9rem;
    margin-left: 0.1rem;
    pointer-events: none;
    vertical-align: middle;
}

@media (min-width: 64em) {
    .anchor-hash .icon {
        margin-left: 0.8rem;
    }
}

.has-anchor-hash:hover .anchor-hash {
    opacity: 0.3;
}

.has-anchor-hash:hover .anchor-hash:hover {
    opacity: 0.6;
}

.site-menu {
    height: 4.375rem;
    left: 0;
    position: relative;
    top: 0;
    width: 100%;
    z-index: 5000;
}

.site-menu.is-open,
.site-menu:target {
    height: 100%;
    position: fixed;
}

@media (min-width: 62em) {

    .site-menu,
    .site-menu.is-open,
    .site-menu:target {
        height: 5.625rem;
        overflow: visible;
        position: relative;
        z-index: 2;
    }
}

.site-menu.is-scrolled {
    position: fixed;
    transform: translateY(-100%);
}

@media (min-width: 62em) {
    .site-menu.is-scrolled {
        z-index: 5000;
    }
}

body.admin-bar .site-menu.is-scrolled {
    top: 32px;
}

@media screen and (max-width: 782px) {
    body.admin-bar .site-menu.is-scrolled {
        top: 0;
    }
}

.site-menu.is-open+.site-menu-placeholder,
.site-menu.is-scrolled+.site-menu-placeholder,
.site-menu:target+.site-menu-placeholder {
    height: 4.375rem;
}

@media (min-width: 62em) {

    .site-menu.is-open+.site-menu-placeholder,
    .site-menu.is-scrolled+.site-menu-placeholder,
    .site-menu:target+.site-menu-placeholder {
        height: 5.625rem;
    }
}

.site-menu.is-pinned {
    transform: translateY(0);
    transform: translateY(-1px);
}

.site-menu__inner {
    grid-column-gap: 1rem;
    align-items: stretch;
    column-gap: 1rem;
    display: grid;
    grid-template-areas: "toggle logo search" "nav nav nav" "extras extras extras";
    grid-template-columns: 4.375rem 1fr 4.375rem;
    grid-template-rows: 4.375rem;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    max-width: 1200px;
    overflow: hidden;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 100%;
}

@media (min-width: 48em) {
    .site-menu__inner {
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.site-menu__inner:after,
.site-menu__inner:before {
    clear: both;
    content: "";
    display: block;
    height: 0;
    visibility: hidden;
}

.site-menu__inner .site-menu__inner {
    padding-left: 0;
    padding-right: 0;
}

@media (min-width: 62em) {
    .site-menu__inner {
        overflow: visible;
    }
}

.site-menu.is-open .site-menu__inner,
.site-menu:target .site-menu__inner {
    grid-template-rows: 4.375rem 1fr 4.375rem;
}

.site-menu__inner:after,
.site-menu__inner:before {
    display: none;
}

@media (min-width: 62em) {

    .site-menu.is-open .site-menu__inner,
    .site-menu:target .site-menu__inner,
    .site-menu__inner {
        align-items: center;
        grid-template-areas: "logo nav search extras";
        grid-template-columns: auto 1fr auto auto;
        grid-template-rows: 5.625rem;
        height: 100%;
    }
}

.site-menu__nav__toggle {
    align-self: center;
    grid-area: toggle;
}

.site-menu__logo {
    align-self: center;
    grid-area: logo;
    justify-self: center;
}

@media (min-width: 62em) {
    .site-menu__logo {
        justify-self: auto;
    }
}

.site-menu__nav {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    grid-area: nav;
    justify-content: stretch;
    overflow: auto;
    position: relative;
}

@media (min-width: 62em) {
    .site-menu__nav {
        align-self: center;
        display: block;
        overflow: visible;
    }
}

.site-menu__search {
    align-self: center;
    grid-area: search;
    justify-self: end;
}

.site-menu__extras {
    grid-gap: 0.5rem;
    align-items: center;
    align-self: flex-end;
    bottom: 0;
    display: none;
    flex-direction: row;
    flex-grow: 0;
    flex-wrap: wrap;
    gap: 0.5rem;
    grid-area: extras;
    justify-content: stretch;
    margin-left: -1rem;
    margin-right: -1rem;
    margin-top: 1rem;
    max-width: 1200px;
    padding-left: 1rem;
    padding-right: 1rem;
    position: sticky;
    width: 100%;
    z-index: 10;
}

@media (min-width: 48em) {
    .site-menu__extras {
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.site-menu__extras:after,
.site-menu__extras:before {
    clear: both;
    content: "";
    display: block;
    height: 0;
    visibility: hidden;
}

.site-menu__extras .site-menu__extras {
    padding-left: 0;
    padding-right: 0;
}

@media (min-width: 48em) {
    .site-menu__extras {
        margin-left: -2rem;
        margin-right: -2rem;
    }
}

.site-menu.is-open .site-menu__extras,
.site-menu:target .site-menu__extras {
    display: flex;
}

@media (min-width: 62em) {

    .site-menu__extras,
    .site-menu__extras .site-menu.is-open,
    .site-menu__extras .site-menu:target {
        grid-gap: 1rem;
        align-self: center;
        display: flex;
        flex-grow: 0;
        flex-wrap: nowrap;
        gap: 1rem;
        justify-content: flex-end;
        margin: 0;
        padding: 0;
        position: static;
        width: auto;
    }

    .site-menu__extras .site-menu.is-open:after,
    .site-menu__extras .site-menu.is-open:before,
    .site-menu__extras .site-menu:target:after,
    .site-menu__extras .site-menu:target:before,
    .site-menu__extras:after,
    .site-menu__extras:before {
        display: none;
    }
}

.megamenu {
    overflow: hidden;
    position: relative;
}

@media (min-width: 62em) {
    .megamenu {
        overflow: visible;
    }
}

.site-menu__nav>.megamenu {
    bottom: 0;
    left: 0;
    overflow: auto;
    overflow-x: hidden;
    position: absolute;
    right: 0;
    top: 0;
}

@media (min-width: 62em) {
    .site-menu__nav>.megamenu {
        overflow: visible;
        position: relative;
    }
}

.megamenu__ul,
.site-menu__nav .menu {
    display: flex;
    flex-direction: column;
}

@media (min-width: 62em) {

    .megamenu__ul,
    .site-menu__nav .menu {
        grid-gap: 1rem;
        align-items: center;
        flex-direction: row;
        gap: 1rem;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
    }
}

@media (min-width: 62em) and (min-width: 75em) {

    .megamenu__ul,
    .site-menu__nav .menu {
        grid-gap: 2rem;
        gap: 2rem;
    }
}

@media (min-width: 62em) {

    .megamenu__li,
    .site-menu__nav .menu-item {
        position: relative;
    }
}

.megamenu__item--has-children:after,
.site-menu__nav .menu-item-has-children>span:after {
    speak: never;
    background-color: currentColor;
    content: "";
    display: block;
    height: 1.2em;
    margin-left: auto;
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#chevron-thin-left-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#chevron-thin-left-usage);
    transform: rotateY(180deg);
    width: 1.2em;
}

@media (min-width: 62em) {

    .megamenu__item--has-children:after,
    .site-menu__nav .menu-item-has-children>span:after {
        background: none;
        content: "▾";
        content: "▾" /"";
        display: inline-block;
        height: auto;
        margin-left: 0.2em;
        -webkit-mask-image: none;
        mask-image: none;
        opacity: 0.3;
        width: auto;
    }
}

.megamenu__item,
.megamenu__submenu__item,
.site-menu__extras>a:not(.button),
.site-menu__nav .menu-item>a,
.site-menu__nav .menu-item>span,
.site-menu__nav .sub-menu .menu-item>a {
    align-items: center;
    color: inherit;
    display: flex;
    flex-direction: row;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 600;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    text-decoration: none;
}

@media (min-width: 62em) {

    .megamenu__item,
    .megamenu__submenu__item,
    .site-menu__extras>a:not(.button),
    .site-menu__nav .menu-item>a,
    .site-menu__nav .menu-item>span,
    .site-menu__nav .sub-menu .menu-item>a {
        background-image: linear-gradient(transparent calc(100% - 2px),
                currentColor 2px);
        background-position: 0 -1rem;
        background-repeat: no-repeat;
        background-size: 0 100%;
        padding: 1rem 0;
        position: relative;
        text-decoration: none;
        transition: background-size 0.2s, color 0.2s;
    }

    .megamenu__item:hover,
    .megamenu__submenu__item:hover,
    .site-menu__extras>a:hover:not(.button),
    .site-menu__nav .menu-item>a:hover,
    .site-menu__nav .menu-item>span:hover,
    .site-menu__nav .sub-menu .menu-item>a:hover {
        background-size: 100% 100%;
    }
}

@media (min-width: 62em) and (min-height: 44em) and (min-width: 75em) {

    .megamenu__item,
    .megamenu__submenu__item,
    .site-menu__extras>a:not(.button),
    .site-menu__nav .menu-item>a,
    .site-menu__nav .menu-item>span,
    .site-menu__nav .sub-menu .menu-item>a {
        background-position: 0 -1.5rem;
        padding-bottom: 1.5rem;
        padding-top: 1.5rem;
    }
}

.megamenu__item .icon,
.megamenu__submenu__item .icon,
.site-menu__extras>a:not(.button) .icon,
.site-menu__nav .menu-item>a .icon,
.site-menu__nav .menu-item>span .icon {
    height: 1.2em;
    margin-right: 0.2em;
    vertical-align: -0.25em;
    width: 1.2em;
}

@media (min-width: 62em) {

    .megamenu__item,
    .site-menu__extras>a:not(.button),
    .site-menu__nav .menu-item>a,
    .site-menu__nav .menu-item>span {
        white-space: nowrap;
    }
}

.megamenu__submenu,
.site-menu__nav .sub-menu {
    background: #fff;
    bottom: 0;
    box-shadow: 0 2px 8px 0 rgba(16, 7, 104, 0.1),
        0 1px 2px 0 rgba(83, 51, 237, 0.06);
    color: #44414e;
    display: block;
    height: 100%;
    left: 0;
    left: 100%;
    margin: 0;
    opacity: 0;
    overflow: auto;
    padding: 0;
    position: absolute;
    top: 0;
    transition: opacity 0.4s, transform 0.4s;
    width: 100%;
    z-index: 2;
}

@media (min-width: 62em) {

    .megamenu__submenu,
    .site-menu__nav .sub-menu {
        border: 1px solid #fafafa;
        border-radius: 0.25rem;
        bottom: auto;
        height: auto;
        left: 50%;
        min-width: 15rem;
        overflow: hidden;
        pointer-events: none;
        top: 99%;
        top: calc(100% - 1px);
        transform: translateX(-50%);
        transform: translateY(-0.5rem) scale(0.98) translateX(-50%);
        width: auto;
    }
}

@media (min-width: 62em) and (min-height: 40em) {

    .megamenu__submenu,
    .site-menu__nav .sub-menu {
        font-size: 1rem;
    }
}

@media (min-width: 62em) and (min-height: 40em) and (min-width: 64em) {

    .megamenu__submenu,
    .site-menu__nav .sub-menu {
        font-size: 1.125rem;
    }
}

.megamenu__submenu[aria-hidden="false"],
.megamenu__submenu[focus-within],
.site-menu__nav .sub-menu[focus-within],
.site-menu__nav [aria-hidden="false"].sub-menu {
    opacity: 1;
    transform: translateX(-100%);
}

.megamenu__submenu:focus-within,
.megamenu__submenu[aria-hidden="false"],
.site-menu__nav .sub-menu:focus-within,
.site-menu__nav [aria-hidden="false"].sub-menu {
    opacity: 1;
    transform: translateX(-100%);
}

@media (min-width: 62em) {

    .megamenu__item:hover+.megamenu__submenu,
    .megamenu__li:hover>.megamenu__submenu,
    .megamenu__submenu:hover,
    .megamenu__submenu[aria-hidden="false"],
    .megamenu__submenu[focus-within],
    .site-menu__extras>a:hover:not(.button)+.megamenu__submenu,
    .site-menu__nav .megamenu__item:hover+.sub-menu,
    .site-menu__nav .megamenu__li:hover>.sub-menu,
    .site-menu__nav .menu-item:hover>.megamenu__submenu,
    .site-menu__nav .menu-item:hover>.sub-menu,
    .site-menu__nav .menu-item>a:hover+.megamenu__submenu,
    .site-menu__nav .menu-item>a:hover+.sub-menu,
    .site-menu__nav .menu-item>span:hover+.megamenu__submenu,
    .site-menu__nav .menu-item>span:hover+.sub-menu,
    .site-menu__nav .site-menu__extras>a:hover:not(.button)+.sub-menu,
    .site-menu__nav .sub-menu:hover,
    .site-menu__nav .sub-menu[focus-within],
    .site-menu__nav [aria-hidden="false"].sub-menu {
        height: auto;
        opacity: 1;
        pointer-events: all;
        transform: translateY(0) scale(1) translateX(-50%);
    }

    .megamenu__item:hover+.megamenu__submenu,
    .megamenu__li:hover>.megamenu__submenu,
    .megamenu__submenu:focus-within,
    .megamenu__submenu:hover,
    .megamenu__submenu[aria-hidden="false"],
    .site-menu__extras>a:hover:not(.button)+.megamenu__submenu,
    .site-menu__nav .megamenu__item:hover+.sub-menu,
    .site-menu__nav .megamenu__li:hover>.sub-menu,
    .site-menu__nav .menu-item:hover>.megamenu__submenu,
    .site-menu__nav .menu-item:hover>.sub-menu,
    .site-menu__nav .menu-item>a:hover+.megamenu__submenu,
    .site-menu__nav .menu-item>a:hover+.sub-menu,
    .site-menu__nav .menu-item>span:hover+.megamenu__submenu,
    .site-menu__nav .menu-item>span:hover+.sub-menu,
    .site-menu__nav .site-menu__extras>a:hover:not(.button)+.sub-menu,
    .site-menu__nav .sub-menu:focus-within,
    .site-menu__nav .sub-menu:hover,
    .site-menu__nav [aria-hidden="false"].sub-menu {
        height: auto;
        opacity: 1;
        pointer-events: all;
        transform: translateY(0) scale(1) translateX(-50%);
    }
}

.megamenu__submenu[data-title]:before,
.site-menu__nav [data-title].sub-menu:before {
    speak: never;
    color: #999;
    content: attr(data-title);
    content: attr(data-title) / "";
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.2;
    padding: 0.5rem 1rem;
}

@media (min-width: 64em) {

    .megamenu__submenu[data-title]:before,
    .site-menu__nav [data-title].sub-menu:before {
        font-size: 0.875rem;
    }
}

@media (min-width: 62em) {

    .megamenu__submenu[data-title]:before,
    .site-menu__nav [data-title].sub-menu:before {
        display: none;
    }

    .megamenu__submenu--has-descriptions {
        min-width: 22rem;
    }

    .megamenu__submenu--post-type {
        min-width: 40rem;
    }
}

.megamenu__submenu--post-type .related-posts {
    background: none;
    padding: 0;
}

.megamenu__submenu--post-type .related-posts__inner {
    padding: 0 0 1rem;
}

@media (min-width: 62em) {
    .megamenu__submenu--post-type .related-posts__inner {
        padding: 1.5rem 2rem;
    }
}

.megamenu__submenu--post-type .related-posts__title {
    color: #999;
    font-size: 0.625rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    padding: 0 1rem;
    text-transform: uppercase;
}

@media (min-width: 64em) {
    .megamenu__submenu--post-type .related-posts__title {
        font-size: 0.75rem;
    }
}

@media (min-width: 62em) {
    .megamenu__submenu--post-type .related-posts__title {
        margin-top: 0;
        padding: 0;
    }
}

@media (min-width: 32em) {
    .megamenu__submenu--post-type .related-posts__list {
        grid-gap: 1rem;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr !important;
        padding: 0 1rem;
    }
}

@media (min-width: 32em) and (min-width: 62em) {
    .megamenu__submenu--post-type .related-posts__list {
        padding: 0;
    }
}

.megamenu__submenu--post-type .post-preview__thumbnail {
    display: none;
}

@media (min-width: 32em) {
    .megamenu__submenu--post-type .post-preview__thumbnail {
        display: block;
        margin-bottom: 0.5rem;
    }
}

.megamenu__submenu--post-type .post-preview {
    border-bottom: 1px solid #fafafa;
    font-size: 1em;
    padding: 0.5rem 1rem;
}

@media (min-width: 32em) {
    .megamenu__submenu--post-type .post-preview {
        border-bottom: 0;
        padding: 0;
    }
}

.megamenu__submenu--post-type .post-preview__title {
    background-color: #fff;
    color: inherit;
    display: block;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 1em;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 0;
    text-decoration: none;
    transition: background-color 0.2s;
}

@media (min-width: 32em) {
    .megamenu__submenu--post-type .post-preview__title {
        font-size: 0.875rem;
        line-height: 1.3;
    }
}

@media (min-width: 32em) and (min-width: 64em) {
    .megamenu__submenu--post-type .post-preview__title {
        font-size: 1rem;
    }
}

.megamenu__submenu--post-type .post-preview__excerpt,
.megamenu__submenu--post-type .post-preview__label,
.megamenu__submenu--post-type .post-preview__subtitle {
    display: none;
}

.megamenu__submenu--post-type__all-link {
    background-color: #fff;
    color: inherit;
    display: block;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 600;
    line-height: 1.2;
    padding: 0.5rem 1rem;
    text-decoration: none;
    transition: background-color 0.2s;
}

@media (min-width: 62em) {
    .megamenu__submenu--post-type__all-link {
        background: none;
        color: inherit;
        color: #5333ed;
        display: inline-block;
        font-size: 0.75rem;
        font-weight: 600;
        line-height: 1.1;
        margin-top: -0.1em;
        padding: 0;
        position: absolute;
        right: 2rem;
        text-decoration: none;
        top: 1.5rem;
    }
}

@media (min-width: 62em) and (min-width: 64em) {
    .megamenu__submenu--post-type__all-link {
        font-size: 0.875rem;
    }
}

.megamenu__submenu__li,
.site-menu__nav .sub-menu .menu-item {
    list-style: none;
    padding: 0;
}

.megamenu__submenu__item,
.site-menu__nav .sub-menu .menu-item>a {
    display: block;
}

@media (min-width: 62em) {

    .megamenu__submenu__item,
    .site-menu__nav .sub-menu .menu-item>a {
        background: none;
        padding: 0.5rem 1rem;
        transition: background-color 0.2s;
    }
}

@media (min-width: 62em) and (min-height: 40em) {

    .megamenu__submenu__item,
    .site-menu__nav .sub-menu .menu-item>a {
        padding: 1rem 1.5rem;
    }
}

@media (min-width: 62em) {

    .megamenu__submenu__item:focus,
    .megamenu__submenu__item:hover,
    .site-menu__nav .sub-menu .menu-item>a:focus,
    .site-menu__nav .sub-menu .menu-item>a:hover {
        background-color: #fafafa;
    }
}

.megamenu__submenu__item__icon {
    display: none;
}

@media (min-width: 62em) {
    .megamenu__submenu__item__icon {
        display: inline-block;
        height: 1.5em;
        margin-right: 0.5em;
        vertical-align: -0.375em;
        width: 1.5em;
    }
}

.megamenu__submenu__item__description {
    color: #999;
    display: block;
    font-family: Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen-Sans,
        Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 0.75em;
    font-weight: 400;
    line-height: 1.4;
}

@media (min-width: 62em) {
    .megamenu__submenu__item__description {
        padding-left: 2.85em;
    }
}

.megamenu__submenu__item__description b {
    color: #5333ed;
    font-weight: 700;
}

.site-menu {
    background-color: hsla(0, 0%, 100%, 0);
    border-bottom: 1px solid transparent;
    color: #44414e;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 1.25rem;
    transition: background-color 0.3s, box-shadow 0.3s, color 0.3;
}

@media (min-width: 64em) {
    .site-menu {
        font-size: 1.5rem;
    }
}

@media (min-width: 62em) {
    .site-menu {
        font-size: 0.875rem;
    }
}

@media (min-width: 62em) and (min-width: 64em) {
    .site-menu {
        font-size: 1rem;
    }
}

.site-menu--theme-light {
    border-bottom-color: hsla(0, 0%, 100%, 0.1);
    color: #fff;
}

@media (min-width: 62em) {
    .site-menu--theme-light:not(.is-scrolled) .button {
        background-color: #2cd4d9;
        color: #0c022f;
    }

    .site-menu--theme-light:not(.is-scrolled) .button:focus,
    .site-menu--theme-light:not(.is-scrolled) .button:hover {
        background-color: transparent;
        border-color: #2cd4d9;
        color: #2cd4d9;
    }

    .site-menu--theme-light:not(.is-scrolled) .button--ghost--purple {
        background-color: transparent;
        border-color: #fff;
        color: #fff;
    }

    .site-menu--theme-light:not(.is-scrolled) .button--ghost--purple:focus,
    .site-menu--theme-light:not(.is-scrolled) .button--ghost--purple:hover {
        background-color: #fff;
        border-color: #fff;
        color: #5333ed;
    }
}

.site-menu.is-open,
.site-menu.is-scrolled,
.site-menu:target {
    background-color: #fff;
    border-bottom-color: rgba(0, 0, 0, 0.05);
    box-shadow: 0 2px 8px 0 rgba(16, 7, 104, 0.07);
    color: #44414e;
}

.site-menu__logo {
    color: inherit;
    display: block;
    text-decoration: none;
}

@media (min-width: 62em) {
    .site-menu__logo {
        font-size: 1rem;
    }
}

@media (min-width: 62em) and (min-width: 64em) {
    .site-menu__logo {
        font-size: 1.125rem;
    }
}

.site-menu__logo img,
.site-menu__logo svg {
    display: block;
    height: auto;
    max-height: 1.875rem;
}

.site-menu__logo img {
    width: auto;
}

.site-menu__nav {
    background-color: #fff;
    margin-left: -1rem;
    margin-right: -1rem;
    max-width: 1200px;
    padding-left: 0;
    padding-right: 0;
    width: 100%;
    width: auto;
}

@media (min-width: 48em) {
    .site-menu__nav {
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.site-menu__nav:after,
.site-menu__nav:before {
    clear: both;
    content: "";
    display: block;
    height: 0;
    visibility: hidden;
}

.site-menu__nav .site-menu__nav {
    padding-left: 0;
    padding-right: 0;
}

@media (min-width: 48em) {
    .site-menu__nav {
        margin-left: -2rem;
        margin-right: -2rem;
    }
}

@media (min-width: 62em) {

    .site-menu.is-open .site-menu__nav,
    .site-menu:target .site-menu__nav,
    .site-menu__nav {
        background-color: transparent;
        margin: 0;
        padding: 0;
    }
}

.site-menu__nav__toggle {
    align-items: center;
    color: inherit;
    display: flex;
    flex-direction: column;
    font-size: 0;
    height: 4.375rem;
    justify-content: center;
    margin-left: -1.5625rem;
    margin-right: -2.8125rem;
    position: relative;
    text-decoration: none;
    width: 4.375rem;
}

.site-menu__nav__toggle:after,
.site-menu__nav__toggle:before {
    background-color: currentColor;
    border-radius: 1px;
    content: "";
    display: block;
    height: 2px;
    transform: rotate(0deg);
    transform-origin: center left;
    transition: transform 0.3s ease 0s, box-shadow 0.3s ease 0.3s,
        margin 0.3s ease, transform-origin 0.3s ease;
    width: 20px;
    will-change: transform;
}

.site-menu__nav__toggle:before {
    box-shadow: 0 7px 0 currentColor;
    margin-bottom: 12px;
}

.site-menu.is-open .site-menu__nav__toggle:after,
.site-menu.is-open .site-menu__nav__toggle:before,
.site-menu:target .site-menu__nav__toggle:after,
.site-menu:target .site-menu__nav__toggle:before {
    transition: transform 0.3s ease 0.3s, box-shadow 0.3s ease 0s,
        margin 0.3s ease 0.3s, transform-origin 0.3s ease 0.3s;
}

.site-menu.is-open .site-menu__nav__toggle:before,
.site-menu:target .site-menu__nav__toggle:before {
    box-shadow: 0 7px 0 transparent;
    transform: rotate(45deg);
}

.site-menu.is-open .site-menu__nav__toggle:after,
.site-menu:target .site-menu__nav__toggle:after {
    transform: rotate(-45deg);
}

.site-menu.is-submenu-open .site-menu__nav__toggle:before {
    margin-bottom: -2px;
    transform: rotate(35deg) scaleX(0.7);
    transform-origin: top left;
}

.site-menu.is-submenu-open .site-menu__nav__toggle:after {
    transform: rotate(-35deg) scaleX(0.7);
    transform-origin: bottom left;
}

@media (min-width: 62em) {
    .site-menu__nav__toggle {
        display: none;
    }
}

.site-menu__extras {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    height: 4.375rem;
    padding-bottom: 1rem;
    padding-top: 1rem;
    width: auto;
}

.site-menu__extras>a {
    display: block;
    flex-grow: 1;
    text-align: center;
}

.site-menu__extras>a.button {
    font-size: 0.7em;
    font-weight: 600;
    padding: 0.5em;
}

@media (min-width: 30em) {
    .site-menu__extras>a.button {
        font-size: 0.8em;
    }
}

@media (min-width: 62em) {

    .site-menu__extras,
    .site-menu__extras .site-menu.is-open,
    .site-menu__extras .site-menu:target {
        background: none;
        border: none;
    }

    .site-menu__extras .site-menu.is-open>a,
    .site-menu__extras .site-menu:target>a,
    .site-menu__extras>a {
        display: block;
        flex-grow: 0;
        max-width: none;
    }

    .site-menu__extras .site-menu.is-open>a.button,
    .site-menu__extras .site-menu:target>a.button,
    .site-menu__extras>a.button {
        font-size: 1em;
        padding: 0.5em 1.5em;
    }
}

@media (min-width: 62em) and (min-width: 62em) {

    .site-menu__extras .site-menu.is-open>a.button,
    .site-menu__extras .site-menu:target>a.button,
    .site-menu__extras>a.button {
        font-size: 0.8em;
    }
}

@media (min-width: 62em) and (min-width: 62em) and (min-width: 76em) {

    .site-menu__extras .site-menu.is-open>a.button,
    .site-menu__extras .site-menu:target>a.button,
    .site-menu__extras>a.button {
        font-size: 1em;
    }
}

@media (min-width: 62em) {

    .site-menu__extras>.site-menu__nav>ul>li>a:last-child,
    .site-menu__extras>.site-menu__nav>ul>li>span:last-child {
        margin-right: -1.5rem;
    }
}

.site-menu__hidden-small {
    display: none !important;
}

@media (min-width: 62em) {
    .site-menu__hidden-small {
        display: unset !important;
    }

    .site-menu__hidden-large {
        display: none !important;
    }
}

.site-menu__search {
    border-radius: 1rem;
    height: 2rem;
    width: 2rem;
}

.site-menu__search.is-open,
.site-menu__search[focus-within] {
    background-color: #fff;
    border-radius: 0;
    height: 4.375rem;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
    width: 100vw;
    z-index: 11;
}

.site-menu__search.is-open,
.site-menu__search:focus-within {
    background-color: #fff;
    border-radius: 0;
    height: 4.375rem;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
    width: 100vw;
    z-index: 11;
}

@media (min-width: 62em) {

    .site-menu__search.is-open,
    .site-menu__search[focus-within] {
        background-color: none;
        border-radius: 1rem;
        height: 2rem;
        position: static;
        width: 2rem;
    }

    .site-menu__search.is-open,
    .site-menu__search:focus-within {
        background-color: none;
        border-radius: 1rem;
        height: 2rem;
        position: static;
        width: 2rem;
    }
}

@media (min-width: 62em) {
    .site-menu__nav {
        transition: opacity 0.2s;
    }

    .site-menu.is-search-open .site-menu__nav {
        opacity: 0;
    }
}

.site-menu__search__form {
    display: flex;
    flex-direction: row;
    position: relative;
}

.site-menu__search__form input {
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 1rem;
    box-shadow: none;
    color: inherit;
    display: block;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 0.8em;
    font-weight: 600;
    height: 2rem;
    line-height: 1;
    opacity: 0;
    outline: none;
    overflow: hidden;
    padding: 0.25rem 2.5rem 0.25rem 1rem;
    position: absolute;
    right: 0;
    top: 0;
    transition: box-shadow 0.2s, background-color 0.2s, border-color 0.2s,
        opacity 0.2s;
    width: 0;
}

@media (min-width: 62em) {
    .site-menu__search__form input {
        font-size: 1em;
        height: 3.625rem;
        padding-right: 3rem;
        top: 50%;
        transform: translateY(-50%);
        transition: width 0.4s, box-shadow 0.2s, background-color 0.2s,
            border-color 0.2s, opacity 0.2s, border-radius 0.2s, transform 0.2s;
    }
}

.site-menu__search__form input::placeholder {
    color: transparent;
    transition: color 0.2s;
}

.site-menu__search.is-open .site-menu__search__form input,
.site-menu__search[focus-within] .site-menu__search__form input,
.site-menu__search__form input:focus {
    background-color: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 0;
    color: #44414e;
    display: block;
    height: 4.375rem;
    opacity: 1;
    width: 100%;
}

.site-menu__search.is-open .site-menu__search__form input,
.site-menu__search:focus-within .site-menu__search__form input,
.site-menu__search__form input:focus {
    background-color: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 0;
    color: #44414e;
    display: block;
    height: 4.375rem;
    opacity: 1;
    width: 100%;
}

@media (min-width: 62em) {

    .site-menu__search.is-open .site-menu__search__form input,
    .site-menu__search[focus-within] .site-menu__search__form input,
    .site-menu__search__form input:focus {
        background-color: #fafafa;
        border: 1px solid #e1eaf8;
        border-radius: 2em;
        box-shadow: 0 2px 8px 0 rgba(16, 7, 104, 0.07);
        margin-bottom: 1rem;
        max-width: 30rem;
        transform: translateY(-50%) translateX(0.5rem);
        width: 30rem;
    }

    .site-menu__search.is-open .site-menu__search__form input,
    .site-menu__search:focus-within .site-menu__search__form input,
    .site-menu__search__form input:focus {
        background-color: #fafafa;
        border: 1px solid #e1eaf8;
        border-radius: 2em;
        box-shadow: 0 2px 8px 0 rgba(16, 7, 104, 0.07);
        margin-bottom: 1rem;
        max-width: 30rem;
        transform: translateY(-50%) translateX(0.5rem);
        width: 30rem;
    }
}

.site-menu__search.is-open .site-menu__search__form input::placeholder,
.site-menu__search[focus-within] .site-menu__search__form input::placeholder,
.site-menu__search__form input:focus::placeholder {
    color: #000;
    color: initial;
}

.site-menu__search.is-open .site-menu__search__form input::placeholder,
.site-menu__search:focus-within .site-menu__search__form input::placeholder,
.site-menu__search__form input:focus::placeholder {
    color: #000;
    color: initial;
}

.site-menu__search.is-open .site-menu__search__form input+.site-menu__search__icon,
.site-menu__search[focus-within] .site-menu__search__form input+.site-menu__search__icon,
.site-menu__search__form input:focus+.site-menu__search__icon {
    color: #44414e;
}

.site-menu__search.is-open .site-menu__search__form input+.site-menu__search__icon,
.site-menu__search:focus-within .site-menu__search__form input+.site-menu__search__icon,
.site-menu__search__form input:focus+.site-menu__search__icon {
    color: #44414e;
}

.site-menu__search__icon {
    background: none;
    border: none;
    border-radius: 1rem;
    box-shadow: none;
    color: inherit;
    display: block;
    outline: none;
    padding: 0;
    position: relative;
    transition: color 0.2s, background-color 0.2s;
}

.site-menu__search__icon:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.site-menu__search.is-open .site-menu__search__icon,
.site-menu__search[focus-within] .site-menu__search__icon {
    color: #999;
    margin-top: 1.1875rem;
    position: absolute;
    right: 1rem;
    top: 50%;
}

.site-menu__search.is-open .site-menu__search__icon,
.site-menu__search:focus-within .site-menu__search__icon {
    color: #999;
    margin-top: 1.1875rem;
    position: absolute;
    right: 1rem;
    top: 50%;
}

@media (min-width: 62em) {

    .site-menu__search.is-open .site-menu__search__icon,
    .site-menu__search[focus-within] .site-menu__search__icon {
        background-color: transparent;
        margin-top: 0;
        position: relative;
        right: 0;
    }

    .site-menu__search.is-open .site-menu__search__icon,
    .site-menu__search:focus-within .site-menu__search__icon {
        background-color: transparent;
        margin-top: 0;
        position: relative;
        right: 0;
    }
}

.site-menu__search.is-open .site-menu__search__icon:focus,
.site-menu__search.is-open .site-menu__search__icon:hover,
.site-menu__search[focus-within] .site-menu__search__icon:focus,
.site-menu__search[focus-within] .site-menu__search__icon:hover {
    color: #44414e;
}

.site-menu__search.is-open .site-menu__search__icon:focus,
.site-menu__search.is-open .site-menu__search__icon:hover,
.site-menu__search:focus-within .site-menu__search__icon:focus,
.site-menu__search:focus-within .site-menu__search__icon:hover {
    color: #44414e;
}

.site-menu__search__icon svg {
    display: block;
    height: 2rem;
    padding: 0.5rem;
    width: 2rem;
}

.site-menu.is-entering .site-menu__extras,
.site-menu.is-entering .site-menu__nav {
    opacity: 0;
    transition: opacity 0.4s;
}

.site-menu.is-entering-active .site-menu__extras,
.site-menu.is-entering-active .site-menu__nav {
    opacity: 1;
}

.site-menu.is-leaving .site-menu__extras,
.site-menu.is-leaving .site-menu__nav {
    opacity: 1;
    transition: opacity 0.4s;
}

.site-menu.is-leaving-active .site-menu__extras,
.site-menu.is-leaving-active .site-menu__nav {
    opacity: 0;
}

.site-menu {
    transition: background-color 0.2s, color 0.2s, height 0.4s;
}

.site-menu.is-transition-enabled {
    transition: transform 0.2s, background-color 0.2s, color 0.2s, height 0.4s;
}

.icon {
    display: inline-block;
    flex-shrink: 0;
    height: 1em;
    transition: fill 0.3s, stroke 0.3s;
    width: 1em;
}

.icon--24 {
    font-size: 24px;
}

.icon--logo {
    width: 5.125em;
}

.icon--map-marker {
    color: #555;
}

.icon--help:not([class*="color"]) {
    color: #aaa;
}

.icon--reverse {
    transform: rotateY(180deg);
}

.opacity--10 {
    opacity: 0.1;
}

.opacity--20 {
    opacity: 0.2;
}

.opacity--30 {
    opacity: 0.3;
}

.opacity--40 {
    opacity: 0.4;
}

.opacity--50 {
    opacity: 0.5;
}

.opacity--60 {
    opacity: 0.6;
}

.opacity--70 {
    opacity: 0.7;
}

.opacity--80 {
    opacity: 0.8;
}

.opacity--90 {
    opacity: 0.9;
}

.opacity--100 {
    opacity: 1;
}

.border--right--gray {
    border-right: 1px solid #e4e4e4;
}

@media only screen and (max-width: 48em) {
    .border--right--gray--xs--none {
        border-right: 0;
    }

    .border--bottom--gray--xs--none {
        border-bottom: 0 !important;
    }

    .border--left--gray--xs--none {
        border-left: 0 !important;
    }
}

.border--left--gray {
    border-left: 1px solid #e4e4e4;
}

.border--top--gray {
    border-top: 1px solid #e4e4e4;
}

.border--bottom--gray {
    border-bottom: 1px solid #e4e4e4;
}

.border--bottom--gray.no--border--bottom--last:last-of-type {
    border-bottom: 0;
}

.border-radius--4,
.quote.quote--vertical .quote__screenshot img,
.quote__content,
.quote__screenshot img,
.swiper-slide-active .plans-carousel-content {
    border-radius: 4px;
}

:root {
    --footer-bgc: #fff;
    --footer-border-color: #e1eaf8;
    --footer-marketing-bg: url(/wp-content/themes/kinsta/images/footer/grid.svg),
        linear-gradient(to bottom right, #e1eaf8, #e1eaf8, #fff);
    --footer-color: #44414e;
    --footer-color--light: #999;
    --footer-link-color: #5333ed;
    --footer-language-bgc: #0c022f;
    --footer-language-color: #fff;
}

.site-footer {
    background-color: #fff;
    background-color: var(--footer-bgc);
    color: #44414e;
    color: var(--footer-color);
    position: relative;
    z-index: 9000;
}

.site-footer a {
    background-image: linear-gradient(transparent calc(100% - 2px),
            currentColor 2px);
    background-repeat: no-repeat;
    background-size: 0 100%;
    color: #5333ed;
    color: var(--footer-link-color);
    position: relative;
    text-decoration: none;
    transition: background-size 0.2s, color 0.2s;
}

.site-footer a:hover {
    background-size: 100% 100%;
}

.site-footer ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.site-footer h2,
.site-footer h3 {
    color: inherit;
}

.site-footer__marketing {
    background: url(/wp-content/themes/kinsta/images/footer/grid.svg),
        linear-gradient(to bottom right, #e1eaf8, #e1eaf8, #fff);
    background: var(--footer-marketing-bg);
    background-position: 100% 100%;
    background-size: cover;
    padding: 3rem 0;
}

@media (min-height: 40em) {
    .site-footer__marketing {
        padding: 5rem 0;
    }
}

.site-footer__marketing>.container {
    grid-gap: 2rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
}

.site-footer__marketing>.container:after,
.site-footer__marketing>.container:before {
    display: none;
}

@media (min-width: 48em) {
    .site-footer__marketing>.container {
        align-items: flex-start;
        flex-direction: row;
        justify-content: space-between;
    }

    .site-footer__newsletter {
        max-width: 36%;
    }
}

.site-footer__newsletter h3 {
    margin: 1rem 0;
}

.site-footer__newsletter .button {
    background-image: none;
    color: inherit;
}

.site-footer__newsletter .button:focus,
.site-footer__newsletter .button:hover {
    background-image: none;
}

.site-footer__marketing__illustration {
    display: none;
}

@media (min-width: 48em) {
    .site-footer__marketing__illustration {
        display: block;
        flex-shrink: 1;
    }
}

.site-footer__marketing .featured-g2-badges {
    background: none;
    max-width: 28rem;
}

.site-footer__language-bar {
    grid-gap: 2rem;
    border-bottom: 2px solid #e1eaf8;
    border-bottom: 2px solid var(--footer-border-color);
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem 0;
}

@media (min-width: 48em) {
    .site-footer__language-bar {
        align-items: center;
        flex-direction: row;
    }
}

.site-footer__language-aside {
    font-size: 0.875rem;
    font-weight: 400;
}

@media (min-width: 64em) {
    .site-footer__language-aside {
        font-size: 1rem;
    }
}

.site-footer__language-aside p {
    margin: 0;
}

.site-footer__language {
    background-color: #fff;
    background-color: var(--footer-bgc);
}

@media (min-width: 48em) {
    .site-footer__language {
        margin-left: auto;
        max-width: 10em;
    }
}

.site-footer__language svg {
    flex: 0 0 1em;
}

.language-select-label {
    align-items: center;
    background-color: inherit;
    border: 1px solid;
    border-radius: 1.5em;
    color: inherit;
    cursor: pointer;
    display: flex;
    height: 2.4em;
    min-width: 10rem;
    overflow: hidden;
    padding: 0;
    position: relative;
    transition: color 0.2s;
}

.language-select-label.focus-visible,
.language-select-label:hover {
    color: #5333ed;
    color: var(--footer-link-color);
}

.language-select-label:focus-visible,
.language-select-label:hover {
    color: #5333ed;
    color: var(--footer-link-color);
}

.language-select {
    -webkit-appearance: none;
    appearance: none;
    background: inherit;
    border: 0;
    color: inherit;
    cursor: pointer;
    font-size: 0.875rem;
    height: 100%;
    outline: none;
    padding: 0.5rem 3rem;
    width: 100%;
}

@media (min-width: 64em) {
    .language-select {
        font-size: 1rem;
    }
}

.language-select option {
    background-color: #fff;
    background-color: var(--footer-bgc);
    color: #44414e;
    color: var(--footer-color);
}

.language-select-label .icon {
    pointer-events: none;
    position: absolute;
}

.language-select-label .icon.icon--language {
    left: 1.2em;
}

.language-select-label .icon.icon--chevron {
    right: 1.2em;
}

.site-footer__menu {
    font-weight: 400;
    padding-bottom: 3rem;
    padding-top: 3rem;
}

@media (min-height: 40em) {
    .site-footer__menu {
        padding-bottom: 4rem;
        padding-top: 4rem;
    }
}

@media (min-width: 48em) {
    .site-footer__menu {
        margin-top: 0;
    }
}

.site-footer__menu>ul {
    list-style: none;
}

@media (min-width: 48em) {
    .site-footer__menu>ul {
        grid-column-gap: 1rem;
        column-count: 3;
        column-fill: balance;
        column-gap: 1rem;
    }
}

@media (min-width: 64em) {
    .site-footer__menu>ul {
        column-count: 4;
    }
}

@media (min-width: 75em) {
    .site-footer__menu>ul {
        grid-column-gap: 2rem;
        column-count: 5;
        column-gap: 2rem;
    }
}

.site-footer__menu>ul>li {
    display: block;
    margin-bottom: 1rem;
}

@media (min-width: 48em) {
    .site-footer__menu>ul>li {
        break-inside: avoid-column;
        margin-bottom: 2rem;
    }
}

.site-footer__menu>ul>li>h3 {
    color: inherit;
    font-size: 1.25rem;
    margin-bottom: 1rem;
    margin-top: 0;
}

@media (min-width: 64em) {
    .site-footer__menu>ul>li>h3 {
        font-size: 1.5rem;
    }
}

.site-footer__menu .sub-menu li {
    line-height: 1.2;
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
}

@media (min-height: 40em) {
    .site-footer__menu .sub-menu li {
        padding-bottom: 0.75rem;
        padding-top: 0.75rem;
    }
}

.site-footer__menu .sub-menu a {
    background-image: linear-gradient(transparent calc(100% - 2px),
            currentColor 2px);
    background-repeat: no-repeat;
    background-size: 0 100%;
    color: #999;
    color: var(--footer-color--light);
    display: inline;
    font-size: 0.875rem;
    position: relative;
    text-decoration: none;
    transition: background-size 0.2s, color 0.2s;
    transition: color 0.2s, background-size 0.2s;
}

.site-footer__menu .sub-menu a:hover {
    background-size: 100% 100%;
}

@media (min-width: 64em) {
    .site-footer__menu .sub-menu a {
        font-size: 1rem;
    }
}

.site-footer__menu .sub-menu a:focus,
.site-footer__menu .sub-menu a:hover {
    color: #5333ed;
    color: var(--footer-link-color);
}

.site-footer__company {
    border-top: 2px solid #e1eaf8;
    border-top: 2px solid var(--footer-border-color);
    font-weight: 400;
    padding-bottom: 2rem;
    padding-top: 2rem;
    text-align: center;
}

@media (min-width: 64em) {
    .site-footer__company {
        grid-gap: 2rem;
        align-items: center;
        display: flex;
        flex-direction: row;
        gap: 2rem;
        width: 100%;
    }
}

.site-footer__language-bar+.site-footer__company {
    border-top: none;
}

.site-footer__logo .icon {
    color: inherit;
}

.site-footer__legal {
    color: #999;
    color: var(--footer-color--light);
    flex-grow: 1;
    font-size: 0.875rem;
    margin: 0.5rem 0;
}

@media (min-width: 64em) {
    .site-footer__legal {
        font-size: 1rem;
    }
}

.site-footer__legal>*,
.site-footer__legal>small {
    display: inline;
    font-size: inherit;
    margin: 0 0.25em;
}

@media (min-width: 64em) {
    .site-footer__legal {
        font-size: 0.75rem;
        margin: 0;
        text-align: center;
    }
}

@media (min-width: 64em) and (min-width: 64em) {
    .site-footer__legal {
        font-size: 0.875rem;
    }
}

.site-footer__social {
    grid-gap: 0.25rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    justify-content: center;
}

@media (min-width: 64em) {
    .site-footer__social {
        flex-wrap: nowrap;
    }
}

.site-footer__social__link {
    border-radius: 50%;
    color: inherit !important;
    display: block;
    height: 2rem;
    padding: 0.3333333333rem;
    transition: color 0.2s;
    width: 2rem;
}

.site-footer__social__link:focus,
.site-footer__social__link:hover {
    background: none !important;
    color: #5333ed !important;
    color: var(--footer-link-color) !important;
}

.site-footer__social__link .icon {
    display: block;
    height: 1.3333333333rem;
    width: 1.3333333333rem;
}

.site-footer__menu.is-accordion .sub-menu {
    height: 0;
    overflow: hidden;
}

@media (min-width: 48em) {
    .site-footer__menu.is-accordion .sub-menu {
        height: auto;
    }
}

.site-footer__menu.is-accordion .sub-menu.is-open {
    height: auto;
}

.site-footer__menu.is-accordion>ul>li>h3 {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.site-footer__menu.is-accordion>ul>li>h3:after {
    background-color: currentColor;
    content: "";
    display: block;
    height: 1em;
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#chevron-right-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#chevron-right-usage);
    transition: transform 0.2s;
    width: 1em;
}

@media (min-width: 48em) {
    .site-footer__menu.is-accordion>ul>li>h3:after {
        display: none;
    }
}

.site-footer__menu.is-accordion>ul>li>h3.is-open:after {
    transform: rotate(90deg);
}

.article-title {
    margin-bottom: 3rem;
    margin-top: 2rem;
}

.article-title__title {
    margin: 0;
}

.article-title__meta {
    color: #999;
    font-size: 0.75rem;
    font-weight: 300;
    margin-top: 1rem;
}

@media (min-width: 64em) {
    .article-title__meta {
        font-size: 0.875rem;
    }
}

.article-title__meta a {
    color: inherit;
    text-decoration: none;
}

.article-title__meta a:focus,
.article-title__meta a:hover {
    text-decoration: underline;
}

.article-title__featured-image {
    border-radius: 0.25rem;
    box-shadow: 0 4px 8px 0 rgba(67, 65, 78, 0.08);
    display: block;
    margin-top: 2rem;
    width: 100%;
}

.logos {
    grid-gap: 1rem;
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    margin-bottom: 3rem;
    margin-top: 3rem;
}

@media (min-width: 64em) {
    .logos {
        grid-gap: 2rem;
        gap: 2rem;
    }
}

.logos img {
    display: block;
    filter: grayscale(100%);
    margin: auto;
    max-height: 3rem;
    max-width: 48%;
    max-width: calc(50% - 0.5rem);
    opacity: 0.7;
    transition: filter 0.2s, opacity 0.2s;
}

@media (min-width: 64em) {
    .logos img {
        height: auto;
        max-width: calc(50% - 1rem);
        min-width: calc(16.666% - 1rem);
        -o-object-fit: contain;
        object-fit: contain;
        width: auto;
    }
}

@media (min-width: 75em) {
    .logos img {
        max-width: 12rem;
    }
}

.logos img.is-white {
    filter: brightness(0) invert(1);
}

.logos img:hover {
    filter: grayscale(0);
    opacity: 1;
}

.bg--purple .logos img,
.has-purple-background-color .logos img {
    filter: brightness(0) invert(1);
    opacity: 0.4;
}

.bg--purple .logos img:hover,
.has-purple-background-color .logos img:hover {
    opacity: 1;
}

.kinsta-form {
    opacity: 1;
    transition: all 0.3s linear;
}

.kinsta-form .form-error {
    color: #ed1c24;
}

.kinsta-form .form-error a {
    color: inherit;
}

.kinsta-form .chosen-container-single .chosen-single,
.kinsta-form input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]),
.kinsta-form select,
.kinsta-form textarea {
    -webkit-appearance: none;
    appearance: none;
    border: 2px solid transparent;
    border-radius: 0;
    display: block;
    font-family: Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen-Sans,
        Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 14px;
    font-weight: 400;
    outline: none;
    padding: 11px 16px;
    width: 100%;
}

.kinsta-form .chosen-container-single .chosen-single.round,
.kinsta-form input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]).round,
.kinsta-form select.round,
.kinsta-form textarea.round {
    border-radius: 80px;
}

.kinsta-form .chosen-container-single .chosen-single[disabled],
.kinsta-form input:not([type="submit"]):not([type="checkbox"]):not([type="radio"])[disabled],
.kinsta-form select[disabled],
.kinsta-form textarea[disabled] {
    background: #e6e5f0;
}

.kinsta-form label .chosen-container,
.kinsta-form label input,
.kinsta-form label select,
.kinsta-form label textarea {
    margin-top: 6px;
}

.kinsta-form .checkbox-label,
.kinsta-form .radio-label {
    cursor: pointer;
}

.kinsta-form label:not(.radio-label):not(.checkbox-label) {
    display: block;
}

.kinsta-form.disabled {
    opacity: 0.2;
}

.kinsta-form .control-label {
    align-items: center;
    display: flex;
    margin-bottom: 6px;
}

.kinsta-form .form-control[data-state="invalid"] .control-message--error {
    color: #ed1c24;
}

.kinsta-form .form-control[data-state="invalid"] .control-message--error a {
    color: inherit;
}

.kinsta-form .form-control .control-label:after {
    content: " ";
    margin-left: 6px;
    opacity: 0;
    transition: opacity 0.2s linear;
}

.kinsta-form .form-control[data-state="valid"] .control-label:after {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g data-name="figures and interactions"><polyline points="12.64 4.91 6.46 11.09 3.36 7.99" style="fill: none;stroke: #2cd4d9;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2px"/></g></svg>');
    display: block;
    height: 16px;
    opacity: 1;
    width: 16px;
}

.kinsta-form .form-control[data-state="valid"] .control-message--hint {
    opacity: 0.5;
}

.kinsta-form textarea {
    resize: none;
}

.kinsta-form ul {
    list-style: inherit;
    padding-left: 1.2em;
}

.kinsta-form--fade-out * {
    opacity: 0;
    transition: opacity 0.3s;
}

.kinsta-form--fade-in * {
    opacity: 1;
    transition: opacity 0.3s;
}

.kinsta-form .control-label__icon {
    opacity: 0;
    transition: all 0.2s linear;
}

.kinsta-form .form-control.state-valid .control-label__icon {
    opacity: 1;
}

.state-hint-error {
    opacity: 1;
    transition: all 0.2s linear;
}

.kinsta-form .isValid .state-hint-error {
    opacity: 0.5;
}

.radio {
    background: #fff;
    border: 2px solid #e6e5f0;
    border-radius: 9px;
    display: block;
    height: 18px;
    position: relative;
    width: 18px;
}

.radio .indicator {
    background: #5333ed;
    border-radius: 5px;
    height: 10px;
    left: 2px;
    opacity: 0;
    position: absolute;
    top: 2px;
    transition: all 0.2s linear;
    width: 10px;
}

.radio input[type="radio"] {
    display: none;
}

.radio input[type="radio"]:checked+.indicator {
    opacity: 1;
}

.checkbox {
    background: #fff;
    cursor: pointer;
    flex: 1 0 auto;
    margin-top: 3px;
    overflow: hidden;
    position: relative;
}

.checkbox,
.checkbox .indicator {
    display: block;
    height: 17px;
    width: 17px;
}

.checkbox .indicator {
    background-image: url(/wp-content/themes/kinsta/images/icon-check-s.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 0 0;
    border: 2px solid #e6e5f0;
    left: 0;
    position: absolute;
    top: 0;
    transition: background-size 0.2s linear;
}

.checkbox:hover .indicator {
    border-color: #c7c5dd;
}

.checkbox input[type="checkbox"]:focus+.indicator {
    border-color: #5333ed;
}

.checkbox input[type="checkbox"]:checked+.indicator {
    background-size: 100% 100%;
}

.checkbox input[type="checkbox"] {
    display: block;
    height: 17px;
    left: 0;
    margin: 0;
    opacity: 0;
    padding: 0;
    position: absolute;
    top: 0;
    width: 17px;
    z-index: 1;
}

.kinsta-form--round input:not([type="submit"]):not([type="checkbox"]):not([type="checkbox"]),
.kinsta-form--round textarea {
    border-radius: 80px;
}

.kinsta-form--darkbg .chosen-container-single .chosen-single,
.kinsta-form--darkbg select {
    background-image: url("data:image/svg+xml;utf8,  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'><g id='7a2dbd94-ac60-4821-a8f1-ff0239918912' data-name='figures and interactions'><polyline points='3.85 6 8 10 12.15 6' style='fill: none;stroke: transparent;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2px'/></g></svg>");
    background-position: calc(100% - 10px);
    background-repeat: no-repeat;
}

.kinsta-form--darkbg input:not([type="submit"]),
.kinsta-form--darkbg select,
.kinsta-form--darkbg textarea {
    background-color: #fff;
    border: 2px solid transparent;
}

.kinsta-form--darkbg input:not([type="submit"]):hover,
.kinsta-form--darkbg select:hover,
.kinsta-form--darkbg textarea:hover {
    border-color: #dedede;
}

.kinsta-form--darkbg input:not([type="submit"]):focus,
.kinsta-form--darkbg select:focus,
.kinsta-form--darkbg textarea:focus {
    border-color: #c5c5c5;
}

.kinsta-form--darkbg .chosen-container .chosen-drop {
    border: 1px solid #c5c5c5;
    border-top: 0;
}

.kinsta-form--whitebg .chosen-container-single .chosen-single,
.kinsta-form--whitebg input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]),
.kinsta-form--whitebg select,
.kinsta-form--whitebg textarea {
    background-color: #fff;
    border-color: #e6e5f0;
}

.kinsta-form--whitebg .chosen-container-single .chosen-single:hover,
.kinsta-form--whitebg input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]):hover,
.kinsta-form--whitebg select:hover,
.kinsta-form--whitebg textarea:hover {
    border-color: #c7c5dd;
}

.kinsta-form--whitebg .chosen-container-single .chosen-single:focus,
.kinsta-form--whitebg input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]):focus,
.kinsta-form--whitebg select:focus,
.kinsta-form--whitebg textarea:focus {
    border-color: #5333ed;
}

.kinsta-form--whitebg .chosen-container .chosen-drop {
    border: 1px solid #c7c5dd;
    border-top: 0;
}

.kinsta-form--whitebg .chosen-container-single .chosen-single,
.kinsta-form--whitebg select {
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'><g id='7a2dbd94-ac60-4821-a8f1-ff0239918912' data-name='figures and interactions'><polyline points='3.85 6 8 10 12.15 6' style='fill:%23e6e5f0; stroke:none; stroke-linecap:round; stroke-linejoin:round; stroke-width:2px;'/></g></svg>");
    background-position: calc(100% - 10px);
    background-repeat: no-repeat;
}

#contact-forms-container {
    min-height: 250px;
    overflow: hidden;
    position: relative;
    transition: height 0.32s cubic-bezier(0.645, 0.045, 0.355, 1);
    will-change: transform;
}

#kinsta-form-4 ul {
    line-height: 2.8;
    margin-bottom: 1em;
    margin-top: 1em;
}

.kinsta-form[data-form="newsletter-subscribe"] .control-message {
    margin-top: 1em;
    text-align: left;
}

.kinsta-form--darkbg .form-control[data-state="invalid"] .control-message--error {
    color: #fff;
}

.kinsta-form .control-container.with-state-us {
    display: flex;
}

.kinsta-form .control-container.with-state-us #state {
    flex: 0 0 20%;
    text-align: center;
}

.kinsta-form .control-container.with-state-us #state[readonly] {
    background-color: #e6e5f0;
    color: #6e7076;
    cursor: default;
    font-weight: 700;
    margin-right: 10px;
    padding: 0;
}

.kinsta-form .control-container.with-state-us #state[readonly]:focus,
.kinsta-form .control-container.with-state-us #state[readonly]:hover {
    border-color: #e6e5f0;
}

.kinsta-form .control-container.with-state-us #state-usa {
    flex: 1 1 80%;
}

.kinsta-form .chosen-container .chosen-results {
    padding-left: 0 !important;
}

.avatar--small {
    height: 32px;
    width: 32px;
}

.avatar--medium {
    height: 60px;
    width: 60px;
}

.avatar--large {
    height: 82px;
    width: 82px;
}

.avatar--round,
.avatar--round img {
    border-radius: 164px;
}

@keyframes blink {
    0% {
        height: 2px;
        margin-left: 0;
        margin-top: 0;
        opacity: 0.2;
        width: 2px;
    }

    20% {
        height: 3px;
        margin-left: -1px;
        margin-top: -1px;
        opacity: 1;
        width: 3px;
    }

    to {
        height: 2px;
        margin-left: 0;
        margin-top: 0;
        opacity: 0.2;
        width: 2px;
    }
}

.button--huge .loading-dots {
    bottom: 26px;
}

.loading-dots {
    bottom: 14px;
    height: 2px;
    line-height: 2px;
    position: absolute;
    right: 28px;
    width: 18px;
}

.loading-dots span {
    animation-duration: 1.4s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-name: blink;
    background: #fff;
    display: block;
    height: 2px;
    left: 0;
    position: absolute;
    top: 0;
    width: 2px;
}

.loading-dots span:nth-of-type(2) {
    animation-delay: 0.2s;
    left: 8px;
}

.loading-dots span:nth-of-type(3) {
    animation-delay: 0.4s;
    left: 16px;
}

.autocomplete-suggestions {
    background: #fff;
    border: 1px solid #ccc;
    border-top: 0;
    box-shadow: -1px 1px 3px rgba(0, 0, 0, 0.1);
    cursor: default;
    display: none;
    max-height: 254px;
    overflow: hidden;
    overflow-y: auto;
    position: absolute;
    text-align: left;
    z-index: 9999;
}

.autocomplete-suggestion {
    color: #333;
    font-size: 1.02em;
    line-height: 23px;
    overflow: hidden;
    padding: 0 0.6em;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.autocomplete-suggestion b {
    color: #1f8dd6;
    font-weight: 400;
}

.autocomplete-suggestion.selected {
    background: #f0f0f0;
}

.plan-interval-switcher {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.plan-interval-switcher__indicator {
    border: 2px solid;
    border-radius: 14px;
    cursor: pointer;
    display: block;
    height: 28px;
    margin: 0 1rem;
    padding: 2px;
    width: 61.6px;
}

.plan-interval-switcher__indicator:before {
    background-color: currentColor;
    border-radius: 50%;
    content: "";
    display: block;
    height: 20px;
    transition: transform 0.2s;
    width: 20px;
}

.plan-interval-switcher__indicator[data-interval-val="year"]:before {
    transform: translateX(33.6px);
}

.plan-interval-switcher__indicator[data-interval-val="month"]:hover:before {
    transform: translateX(5px);
}

.plan-interval-switcher__indicator[data-interval-val="year"]:hover:before {
    transform: translateX(28.6px);
}

.widget-share {
    align-items: center;
    color: #999;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    overflow: auto;
    padding: 1rem;
    width: 100%;
}

@media (min-width: 64em) {
    .widget-share {
        align-items: flex-start;
        flex-direction: column;
        float: left;
        justify-content: flex-end;
        margin-left: calc(50vw - 35.5rem);
        overflow: visible;
        padding: 0;
        position: sticky;
        top: 1rem;
        width: auto;
        z-index: 1;
    }

    .widget-share:after,
    .widget-share:before {
        display: none;
    }
}

.widget-share__title {
    align-items: center;
    display: inline-flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 500;
    margin-right: 1em;
}

@media (min-width: 64em) {
    .widget-share__title {
        font-size: 14px;
        margin: 0 0 1em;
    }
}

.widget-share--vertical {
    align-items: flex-end;
    flex-direction: row;
    margin-left: 0;
    position: relative;
}

.widget-share--vertical .novashare-buttons-wrapper {
    flex-direction: row;
}

.widget-share--vertical .widget-share__title {
    margin-right: 0;
}

@media (min-width: 64em) {
    .widget-share--vertical .widget-share__title {
        margin-right: 2em;
    }
}

.widget-share .icon--share,
.widget-share__total-count {
    margin-right: 6px;
}

.novashare-buttons-wrapper {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

@media (min-width: 64em) {
    .novashare-buttons-wrapper {
        flex-direction: column;
    }
}

.novashare-hide {
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

a.novashare-button {
    align-items: center;
    color: #999;
    display: flex;
    height: 3rem;
    justify-content: center;
    padding: 0.75rem;
    transition: color 0.2s;
    width: 3rem;
}

a.novashare-button:focus,
a.novashare-button:hover {
    color: #44414e;
}

a.novashare-button svg {
    height: 1.5rem;
    width: 1.5rem;
}

.share-static {
    background-color: #f9f9fb;
    border-radius: 0.25rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 1rem auto;
    max-width: 41rem;
    padding: 1rem;
}

@media (min-width: 64em) {
    .share-static {
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
    }
}

.share-static__text {
    margin: 0 0 1rem;
    text-align: center;
}

@media (min-width: 64em) {
    .share-static__text {
        margin-bottom: 0;
        text-align: left;
    }
}

.share-static .novashare-buttons-wrapper {
    grid-gap: 0.5rem;
    align-items: center;
    display: grid;
    flex-direction: row;
    grid-auto-columns: auto;
    grid-auto-flow: column;
    justify-content: center;
}

.share-static a.novashare-button {
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 4px 8px 0 rgba(67, 65, 78, 0.08);
    color: #5333ed;
    height: 2rem;
    padding: 0.5rem;
    transition: color 0.2s, background-color 0.2s, box-shadow 0.2s;
    width: 2rem;
}

.share-static a.novashare-button:focus,
.share-static a.novashare-button:hover {
    background-color: #fbfdff;
    box-shadow: 0 4px 8px 0 rgba(67, 65, 78, 0.2);
    color: #2cd4d9;
}

.share-static a.novashare-button svg {
    height: 1rem;
    width: 1rem;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(1turn);
    }
}

@keyframes fade-in {
    0% {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

#kinsta-toc {
    background: #fff;
    border-right: 1px solid rgba(0, 0, 0, 0.05);
    height: 100%;
    height: 100vh;
    margin-bottom: -100vh;
    overflow: auto;
    position: sticky;
    scrollbar-color: #fff;
    scrollbar-width: thin;
    top: 0;
    transition: scrollbar-color 0.3s;
    visibility: hidden;
    z-index: 1;
}

#kinsta-toc .kinsta-toc-heading {
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
}

@media only screen and (max-width: 64em) {
    #kinsta-toc {
        margin-bottom: 0;
        visibility: hidden !important;
    }
}

#kinsta-toc li {
    margin: 11px 0;
}

#kinsta-toc ul a {
    color: #3108c2;
    text-decoration: none;
}

#kinsta-toc ul li.current a {
    color: #0c022f;
}

#kinsta-toc ul li.current a:before {
    content: "→";
    padding-right: 6px;
}

#kinsta-toc:hover {
    scrollbar-color: #666;
}

#kinsta-toc::-webkit-scrollbar {
    width: 6px;
}

#kinsta-toc::-webkit-scrollbar-thumb {
    background-color: #fff;
    border-radius: 3px;
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
}

#kinsta-toc:hover::-webkit-scrollbar-thumb {
    background-color: #666;
}

#kinsta-toc::-webkit-scrollbar-track {
    background: none;
}

.landing-illustration {
    position: relative;
    width: 100%;
    z-index: 0;
}

.landing-illustration#peace-of-mind-group {
    left: 40%;
    transform: scaleX(-1);
}

.landing-illustration#features-group {
    right: -51%;
    transform: scaleX(-1);
}

@media (min-width: 48em) {
    .landing-illustration {
        position: absolute;
    }

    .landing-illustration#peace-of-mind-group {
        bottom: -42%;
        left: auto;
        right: -80px;
        transform: scaleX(1);
    }

    .landing-illustration#support-that-cares-group {
        bottom: -80px;
        left: 0;
        right: auto;
    }

    .landing-illustration#features-group {
        bottom: -35%;
        left: auto;
        right: 0;
        transform: scaleX(1);
    }
}

.landing-illustration .bodymovin {
    width: 100%;
}

.landing-illustration .lottie-animation,
.landing-illustration img,
.landing-illustration svg {
    display: block;
    height: auto;
    margin: 0;
    max-width: 50rem;
    width: 100%;
}

.landing-illustration--reverse-xs {
    transform: scaleX(-1) translateX(-40%);
}

@media (min-width: 48em) {
    .landing-illustration--reverse-xs {
        transform: scaleX(1);
    }
}

.landing-illustration__inner {
    display: flex;
    width: 150%;
}

@media (min-width: 48em) {
    .landing-illustration__inner {
        width: 100%;
    }

    #peace-of-mind-group .landing-illustration__inner {
        justify-content: flex-end;
    }

    #support-that-cares-group .landing-illustration__inner {
        justify-content: flex-start;
    }

    #features-group .landing-illustration__inner {
        justify-content: flex-end;
    }

    .landing-illustration__inner--start {
        justify-content: flex-start;
    }

    .landing-illustration__inner--end {
        justify-content: flex-end;
    }
}

.landing-illustration+div {
    position: relative;
}

.support-that-cares-group__flag {
    display: none !important;
}

@media (min-width: 75em) {
    .support-that-cares-group__flag {
        display: block !important;
    }
}

.widget-kinsta-promo {
    border: 1px solid #eee;
    padding: 20px;
}

#kinsta-promo-widget__collapsable {
    overflow: hidden;
}

.color--white .terms-checkbox .unslidelink--text,
.color--white .terms-checkbox a {
    background-image: linear-gradient(transparent calc(100% - 1px),
            #fff 1px) !important;
    border-bottom: 0 !important;
    color: #fff !important;
}

.simple-table {
    width: 100%;
}

.simple-table td,
.simple-table th {
    padding: 4px 10px;
}

.simple-table thead td,
.simple-table thead th {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 10px;
    text-align: left;
}

.simple-table tbody tr:first-child td {
    padding-top: 10px;
}

.simple-table th {
    font-weight: 600;
}

.circle-chart {
    margin-left: auto;
    margin-right: auto;
    max-width: 14rem;
}

.circle-chart__circle {
    display: none;
    transform: rotate(-90deg);
    transform-origin: center;
}

.circle-chart__info {
    opacity: 0;
    transform: translateY(0.3em);
}

.circle-chart--in-view .circle-chart__circle {
    animation: circle-chart-fill 2s reverse;
    display: block;
}

.circle-chart--in-view .circle-chart__info {
    animation: circle-chart-appear 2s forwards;
}

@keyframes circle-chart-fill {
    to {
        stroke-dasharray: 0 100;
    }
}

@keyframes circle-chart-appear {
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.button,
.button--darkGray,
.button--ghost,
.button--ghost--gold,
.button--ghost--gray,
.button--ghost--green,
.button--ghost--purple,
.button--ghost--white,
.button--green,
.button--purple,
.button--text--green,
.button--text--purple,
.button--text--white,
.button--white,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple,
.has-blue-background-color .featured-plans .button,
.has-blue-background-color .featured-plans__more .button,
.has-dark-blue-background-color .featured-plans .button,
.has-dark-blue-background-color .featured-plans__more .button,
.kinsta-pagination a.next,
.kinsta-pagination a.page-numbers:not(.next):not(.prev),
.kinsta-pagination a.prev,
.kinsta-pagination span.current,
.plan-col:hover .plan-col__choose a,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white,
.swiper-slide-active .plan-box .plan-box__button--active--green,
.swiper-slide-active .plan-box .plan-box__button--active--purple {
    background-color: #5333ed;
    border: 2px solid transparent;
    border-radius: 80px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 16px;
    font-weight: 600;
    padding: 11px 33px;
    text-decoration: none;
    text-transform: none;
    transition: all 0.12s linear;
    white-space: nowrap;
}

.button.loading,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--ghost--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--ghost--purple,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--purple,
.has-blue-background-color .featured-plans .loading.button,
.has-blue-background-color .featured-plans__more .loading.button,
.has-dark-blue-background-color .featured-plans .loading.button,
.has-dark-blue-background-color .featured-plans__more .loading.button,
.kinsta-pagination a.loading.next,
.kinsta-pagination a.loading.page-numbers:not(.next):not(.prev),
.kinsta-pagination a.loading.prev,
.kinsta-pagination span.loading.current,
.loading.button--darkGray,
.loading.button--ghost,
.loading.button--ghost--gold,
.loading.button--ghost--gray,
.loading.button--ghost--green,
.loading.button--ghost--purple,
.loading.button--ghost--white,
.loading.button--green,
.loading.button--purple,
.loading.button--text--green,
.loading.button--text--purple,
.loading.button--text--white,
.loading.button--white,
.plan-col:hover .plan-col__choose a.loading,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--gray,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--green,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--purple,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--white,
.swiper-slide-active .plan-box .loading.plan-box__button--active--green,
.swiper-slide-active .plan-box .loading.plan-box__button--active--purple {
    cursor: progress;
    padding-right: 52px;
    position: relative;
}

.button--darkGray>.icon,
.button--ghost--gold>.icon,
.button--ghost--gray>.icon,
.button--ghost--green>.icon,
.button--ghost--purple>.icon,
.button--ghost--white>.icon,
.button--ghost>.icon,
.button--green>.icon,
.button--purple>.icon,
.button--text--green>.icon,
.button--text--purple>.icon,
.button--text--white>.icon,
.button--white>.icon,
.button>.icon,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green>.icon,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple>.icon,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green>.icon,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple>.icon,
.has-blue-background-color .featured-plans .button>.icon,
.has-blue-background-color .featured-plans__more .button>.icon,
.has-dark-blue-background-color .featured-plans .button>.icon,
.has-dark-blue-background-color .featured-plans__more .button>.icon,
.kinsta-pagination a.next>.icon,
.kinsta-pagination a.page-numbers:not(.next):not(.prev)>.icon,
.kinsta-pagination a.prev>.icon,
.kinsta-pagination span.current>.icon,
.plan-col:hover .plan-col__choose a>.icon,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray>.icon,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green>.icon,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple>.icon,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white>.icon,
.swiper-slide-active .plan-box .plan-box__button--active--green>.icon,
.swiper-slide-active .plan-box .plan-box__button--active--purple>.icon {
    vertical-align: -0.15em;
}

.button--darkGray>*+.icon,
.button--darkGray>.icon+*,
.button--ghost--gold>*+.icon,
.button--ghost--gold>.icon+*,
.button--ghost--gray>*+.icon,
.button--ghost--gray>.icon+*,
.button--ghost--green>*+.icon,
.button--ghost--green>.icon+*,
.button--ghost--purple>*+.icon,
.button--ghost--purple>.icon+*,
.button--ghost--white>*+.icon,
.button--ghost--white>.icon+*,
.button--ghost>*+.icon,
.button--ghost>.icon+*,
.button--green>*+.icon,
.button--green>.icon+*,
.button--purple>*+.icon,
.button--purple>.icon+*,
.button--text--green>*+.icon,
.button--text--green>.icon+*,
.button--text--purple>*+.icon,
.button--text--purple>.icon+*,
.button--text--white>*+.icon,
.button--text--white>.icon+*,
.button--white>*+.icon,
.button--white>.icon+*,
.button>*+.icon,
.button>.icon+*,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green>*+.icon,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green>.icon+*,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple>*+.icon,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple>.icon+*,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green>*+.icon,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green>.icon+*,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple>*+.icon,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple>.icon+*,
.has-blue-background-color .featured-plans .button>*+.icon,
.has-blue-background-color .featured-plans .button>.icon+*,
.has-blue-background-color .featured-plans__more .button>*+.icon,
.has-blue-background-color .featured-plans__more .button>.icon+*,
.has-dark-blue-background-color .featured-plans .button>*+.icon,
.has-dark-blue-background-color .featured-plans .button>.icon+*,
.has-dark-blue-background-color .featured-plans__more .button>*+.icon,
.has-dark-blue-background-color .featured-plans__more .button>.icon+*,
.kinsta-pagination a.next>*+.icon,
.kinsta-pagination a.next>.icon+*,
.kinsta-pagination a.page-numbers:not(.next):not(.prev)>*+.icon,
.kinsta-pagination a.page-numbers:not(.next):not(.prev)>.icon+*,
.kinsta-pagination a.prev>*+.icon,
.kinsta-pagination a.prev>.icon+*,
.kinsta-pagination span.current>*+.icon,
.kinsta-pagination span.current>.icon+*,
.plan-col:hover .plan-col__choose a>*+.icon,
.plan-col:hover .plan-col__choose a>.icon+*,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray>*+.icon,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray>.icon+*,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green>*+.icon,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green>.icon+*,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple>*+.icon,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple>.icon+*,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white>*+.icon,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white>.icon+*,
.swiper-slide-active .plan-box .plan-box__button--active--green>*+.icon,
.swiper-slide-active .plan-box .plan-box__button--active--green>.icon+*,
.swiper-slide-active .plan-box .plan-box__button--active--purple>*+.icon,
.swiper-slide-active .plan-box .plan-box__button--active--purple>.icon+* {
    margin-left: 1em;
}

.button--darkGray:focus,
.button--darkGray:hover,
.button--ghost--gold:focus,
.button--ghost--gold:hover,
.button--ghost--gray:focus,
.button--ghost--gray:hover,
.button--ghost--green:focus,
.button--ghost--green:hover,
.button--ghost--purple:focus,
.button--ghost--purple:hover,
.button--ghost--white:focus,
.button--ghost--white:hover,
.button--ghost:focus,
.button--ghost:hover,
.button--green:focus,
.button--green:hover,
.button--purple:focus,
.button--purple:hover,
.button--text--green:focus,
.button--text--green:hover,
.button--text--purple:focus,
.button--text--purple:hover,
.button--text--white:focus,
.button--text--white:hover,
.button--white:focus,
.button--white:hover,
.button:focus,
.button:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple:hover,
.has-blue-background-color .featured-plans .button:focus,
.has-blue-background-color .featured-plans .button:hover,
.has-blue-background-color .featured-plans__more .button:focus,
.has-blue-background-color .featured-plans__more .button:hover,
.has-dark-blue-background-color .featured-plans .button:focus,
.has-dark-blue-background-color .featured-plans .button:hover,
.has-dark-blue-background-color .featured-plans__more .button:focus,
.has-dark-blue-background-color .featured-plans__more .button:hover,
.kinsta-pagination a.next:focus,
.kinsta-pagination a.next:hover,
.kinsta-pagination a.page-numbers:focus:not(.next):not(.prev),
.kinsta-pagination a.page-numbers:hover:not(.next):not(.prev),
.kinsta-pagination a.prev:focus,
.kinsta-pagination a.prev:hover,
.kinsta-pagination span.current:focus,
.kinsta-pagination span.current:hover,
.plan-col:hover .plan-col__choose a:focus,
.plan-col:hover .plan-col__choose a:hover,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray:focus,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray:hover,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green:focus,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green:hover,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple:focus,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple:hover,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white:focus,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white:hover,
.swiper-slide-active .plan-box .plan-box__button--active--green:focus,
.swiper-slide-active .plan-box .plan-box__button--active--green:hover,
.swiper-slide-active .plan-box .plan-box__button--active--purple:focus,
.swiper-slide-active .plan-box .plan-box__button--active--purple:hover {
    background-color: transparent;
    border-color: #5333ed;
    color: #5333ed;
}

.button.loading,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--ghost--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--ghost--purple,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--purple,
.has-blue-background-color .featured-plans .loading.button,
.has-blue-background-color .featured-plans__more .loading.button,
.has-dark-blue-background-color .featured-plans .loading.button,
.has-dark-blue-background-color .featured-plans__more .loading.button,
.kinsta-pagination a.loading.next,
.kinsta-pagination a.loading.page-numbers:not(.next):not(.prev),
.kinsta-pagination a.loading.prev,
.kinsta-pagination span.loading.current,
.loading.button--darkGray,
.loading.button--ghost,
.loading.button--ghost--gold,
.loading.button--ghost--gray,
.loading.button--ghost--green,
.loading.button--ghost--purple,
.loading.button--ghost--white,
.loading.button--green,
.loading.button--purple,
.loading.button--text--green,
.loading.button--text--purple,
.loading.button--text--white,
.loading.button--white,
.plan-col:hover .plan-col__choose a.loading,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--gray,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--green,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--purple,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--white,
.swiper-slide-active .plan-box .loading.plan-box__button--active--green,
.swiper-slide-active .plan-box .loading.plan-box__button--active--purple {
    background-color: #5333ed;
    color: #fff;
}

.button--circle--50,
.kinsta-pagination a.page-numbers:not(.next):not(.prev),
.kinsta-pagination span.current {
    border-radius: 100px;
    height: 50px;
    line-height: 50px;
    padding: 0;
    text-align: center;
    width: 50px;
}

.button--full {
    width: 100%;
}

@media only screen and (max-width: 47.999em) {
    .button--xs--full {
        width: 100%;
    }
}

.button--small {
    font-size: 12px;
    padding: 6px 22px;
}

.button--tiny,
.plan-col:hover .plan-col__choose a {
    font-size: 10px;
    padding: 4px 16px;
}

.button--huge {
    padding: 24px 40px;
}

.button--text--purple {
    border: 0;
    color: #5333ed;
    padding: 0;
}

.button--text--purple:focus,
.button--text--purple:hover {
    color: #2cd4d9;
}

.button--text--purple:focus svg [stroke]:not([stroke=""]),
.button--text--purple:hover svg [stroke]:not([stroke=""]) {
    stroke: #2cd4d9;
}

.button--text--purple:focus svg [fill]:not([fill="none"]),
.button--text--purple:hover svg [fill]:not([fill="none"]) {
    fill: #2cd4d9;
}

.button--white--text--hover:hover {
    color: #fff !important;
}

.button--text--green {
    border: 0;
    color: #2cd4d9;
    padding: 0;
}

.button--text--white {
    border: 0;
    color: #fff;
    padding: 0;
}

.button--ghost {
    background-color: transparent;
    border-color: inherit;
    color: inherit;
}

.button--ghost:focus,
.button--ghost:hover {
    background-color: #5333ed;
    border-color: #5333ed;
    color: #fff;
}

.button--ghost--white,
.has-blue-background-color .featured-plans .button,
.has-blue-background-color .featured-plans__more .button,
.has-dark-blue-background-color .featured-plans .button,
.has-dark-blue-background-color .featured-plans__more .button,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white {
    background-color: transparent;
    border-color: #fff;
    color: #fff;
}

.button--ghost--white:focus,
.button--ghost--white:hover,
.has-blue-background-color .featured-plans .button:focus,
.has-blue-background-color .featured-plans .button:hover,
.has-blue-background-color .featured-plans__more .button:focus,
.has-blue-background-color .featured-plans__more .button:hover,
.has-dark-blue-background-color .featured-plans .button:focus,
.has-dark-blue-background-color .featured-plans .button:hover,
.has-dark-blue-background-color .featured-plans__more .button:focus,
.has-dark-blue-background-color .featured-plans__more .button:hover,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white:focus,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--white:hover {
    background-color: #2cd4d9;
    border-color: #2cd4d9;
    color: #150773;
}

.button--ghost--gray,
.kinsta-pagination a.page-numbers:not(.next):not(.prev),
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray {
    background-color: transparent;
    border-color: #e1eaf8;
    color: inherit;
}

.button--ghost--gray:focus,
.button--ghost--gray:hover,
.kinsta-pagination a.page-numbers:focus:not(.next):not(.prev),
.kinsta-pagination a.page-numbers:hover:not(.next):not(.prev),
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray:focus,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--gray:hover {
    background-color: #5333ed;
    border-color: #5333ed;
    color: #fff;
}

.button--ghost--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green {
    background-color: transparent;
    border-color: #2cd4d9;
    color: #2cd4d9;
}

.button--ghost--green:focus,
.button--ghost--green:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--green:hover,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green:focus,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--green:hover {
    background-color: #2cd4d9;
    border-color: #2cd4d9;
    color: #150773;
}

.button--ghost--purple,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple,
.kinsta-pagination a.next,
.kinsta-pagination a.prev,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple {
    background-color: transparent;
    border-color: #5333ed;
    color: #5333ed;
}

.button--ghost--purple:focus,
.button--ghost--purple:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--ghost--purple:hover,
.kinsta-pagination a.next:focus,
.kinsta-pagination a.next:hover,
.kinsta-pagination a.prev:focus,
.kinsta-pagination a.prev:hover,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple:focus,
.swiper-slide-active .plan-box .plan-box__button--active--ghost--purple:hover {
    background-color: #5333ed;
    border-color: #5333ed;
    color: #fff;
}

.button--ghost--purple.active,
.button--ghost--purple.active:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .active.plan-box__hover__button--ghost--purple,
.kinsta-pagination a.active.next,
.kinsta-pagination a.active.next:hover,
.kinsta-pagination a.active.prev,
.kinsta-pagination a.active.prev:hover,
.swiper-slide-active .plan-box .active.plan-box__button--active--ghost--purple {
    background-color: transparent;
    border-color: #5333ed;
    color: #5333ed;
}

.button--ghost--purple.active svg [stroke]:not([stroke=""]),
.button--ghost--purple.active:hover svg [stroke]:not([stroke=""]),
.carousel-item:not(.swiper-slide-active) .plan-box:hover .active.plan-box__hover__button--ghost--purple svg [stroke]:not([stroke=""]),
.kinsta-pagination a.active.next svg [stroke]:not([stroke=""]),
.kinsta-pagination a.active.prev svg [stroke]:not([stroke=""]),
.swiper-slide-active .plan-box .active.plan-box__button--active--ghost--purple svg [stroke]:not([stroke=""]) {
    stroke: #5333ed;
}

.button--ghost--purple.active svg [fill]:not([fill="none"]),
.button--ghost--purple.active:hover svg [fill]:not([fill="none"]),
.carousel-item:not(.swiper-slide-active) .plan-box:hover .active.plan-box__hover__button--ghost--purple svg [fill]:not([fill="none"]),
.kinsta-pagination a.active.next svg [fill]:not([fill="none"]),
.kinsta-pagination a.active.prev svg [fill]:not([fill="none"]),
.swiper-slide-active .plan-box .active.plan-box__button--active--ghost--purple svg [fill]:not([fill="none"]) {
    fill: #5333ed;
}

.button--ghost--purple.loading,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--ghost--purple,
.kinsta-pagination a.loading.next,
.kinsta-pagination a.loading.prev,
.swiper-slide-active .plan-box .loading.plan-box__button--active--ghost--purple {
    background-color: #5333ed;
    color: #fff;
    padding-right: 52px;
    position: relative;
}

.button--ghost--gold {
    background-color: transparent;
    border-color: rgba(255, 150, 31, 0.1);
    color: #ff961f;
}

.button--ghost--gold:focus,
.button--ghost--gold:hover {
    background-color: #ff961f;
    border-color: #ff961f;
    color: #fff;
}

.button--ghost--gold.active,
.button--ghost--gold.active:hover {
    background-color: transparent;
    border-color: #ff961f;
    color: #ff961f;
}

.button--ghost--gold.active svg [stroke]:not([stroke=""]),
.button--ghost--gold.active:hover svg [stroke]:not([stroke=""]) {
    stroke: #ff961f;
}

.button--ghost--gold.active svg [fill]:not([fill="none"]),
.button--ghost--gold.active:hover svg [fill]:not([fill="none"]) {
    fill: #ff961f;
}

.button--ghost--gold.loading {
    background-color: #ff961f;
    color: #fff;
    padding-right: 52px;
    position: relative;
}

@media only screen and (max-width: 48em) {
    .xs--button--ghost--purple {
        background-color: transparent;
        border: 2px solid #5333ed;
        border-radius: 80px;
        color: #5333ed;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        padding: 11px 33px;
        text-decoration: none;
        text-transform: uppercase;
        transition: all 0.12s linear;
        white-space: nowrap;
        width: min-content;
        width: -moz-min-content;
    }

    .xs--button--ghost--purple:not(.row) {
        display: inline-block;
    }

    .xs--button--ghost--purple.loading {
        cursor: progress;
    }

    .xs--button--ghost--purple:focus,
    .xs--button--ghost--purple:hover {
        background-color: #5333ed;
        border-color: #5333ed;
        color: #fff;
    }

    .xs--button--ghost--purple.active,
    .xs--button--ghost--purple.active:hover {
        background-color: transparent;
        border-color: #5333ed;
        color: #5333ed;
    }

    .xs--button--ghost--purple.active svg [stroke]:not([stroke=""]),
    .xs--button--ghost--purple.active:hover svg [stroke]:not([stroke=""]) {
        stroke: #5333ed;
    }

    .xs--button--ghost--purple.active svg [fill]:not([fill="none"]),
    .xs--button--ghost--purple.active:hover svg [fill]:not([fill="none"]) {
        fill: #5333ed;
    }

    .xs--button--ghost--purple.loading {
        background-color: #5333ed;
        color: #fff;
        padding-right: 52px;
        position: relative;
    }
}

.button--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green,
.swiper-slide-active .plan-box .plan-box__button--active--green {
    background-color: #2cd4d9;
    border-color: #2cd4d9;
    color: #150773;
}

.button--green:focus,
.button--green:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--green:hover,
.swiper-slide-active .plan-box .plan-box__button--active--green:focus,
.swiper-slide-active .plan-box .plan-box__button--active--green:hover {
    background-color: transparent;
    border-color: #2cd4d9;
    color: inherit;
}

.button--green.button--hoverghost:focus,
.button--green.button--hoverghost:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .button--hoverghost.plan-box__hover__button--green:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .button--hoverghost.plan-box__hover__button--green:hover,
.swiper-slide-active .plan-box .button--hoverghost.plan-box__button--active--green:focus,
.swiper-slide-active .plan-box .button--hoverghost.plan-box__button--active--green:hover {
    background-color: transparent !important;
    border-color: #fff !important;
    color: #fff !important;
}

.button--white {
    background-color: #fff;
    border-color: #fff;
    color: #44414e;
}

.button--white:focus,
.button--white:hover {
    background-color: transparent;
    border-color: #fff;
    color: #fff;
}

.button--white:focus svg [fill]:not([fill="none"]),
.button--white:hover svg [fill]:not([fill="none"]) {
    fill: #fff;
}

.button--white.loading {
    background-color: #fff;
    color: #fff;
    padding-right: 52px;
    position: relative;
}

.button--white.button--hoverghost:focus,
.button--white.button--hoverghost:hover {
    background-color: transparent !important;
    border-color: #fff !important;
    color: #fff !important;
}

.button--purple,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple,
.plan-col:hover .plan-col__choose a,
.swiper-slide-active .plan-box .plan-box__button--active--purple {
    background-color: #5333ed;
    border-color: #5333ed;
    color: #fff;
}

.button--purple:focus,
.button--purple:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .plan-box__hover__button--purple:hover,
.plan-col:hover .plan-col__choose a:focus,
.plan-col:hover .plan-col__choose a:hover,
.swiper-slide-active .plan-box .plan-box__button--active--purple:focus,
.swiper-slide-active .plan-box .plan-box__button--active--purple:hover {
    background-color: transparent;
    border-color: #5333ed;
    color: #5333ed;
}

.button--purple.loading,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .loading.plan-box__hover__button--purple,
.plan-col:hover .plan-col__choose a.loading,
.swiper-slide-active .plan-box .loading.plan-box__button--active--purple {
    background-color: #5333ed;
    color: #fff;
    padding-right: 52px;
    position: relative;
}

.button--purple.button--hoverghost:focus,
.button--purple.button--hoverghost:hover,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .button--hoverghost.plan-box__hover__button--purple:focus,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .button--hoverghost.plan-box__hover__button--purple:hover,
.plan-col:hover .plan-col__choose a.button--hoverghost:focus,
.plan-col:hover .plan-col__choose a.button--hoverghost:hover,
.swiper-slide-active .plan-box .button--hoverghost.plan-box__button--active--purple:focus,
.swiper-slide-active .plan-box .button--hoverghost.plan-box__button--active--purple:hover {
    background-color: transparent !important;
    border-color: #5333ed !important;
    color: #fff !important;
}

.button--darkGray {
    background-color: #3b3a43;
    border-color: #3b3a43;
    color: #fff;
}

.button--darkGray:focus,
.button--darkGray:hover {
    background-color: transparent;
    border-color: #3b3a43;
    color: #3b3a43;
}

.button--darkGray.loading {
    background-color: #3b3a43;
    color: #fff;
    padding-right: 52px;
    position: relative;
}

.button--darkGray.button--hoverghost:focus,
.button--darkGray.button--hoverghost:hover {
    background-color: transparent !important;
    border-color: #fff !important;
    color: #fff !important;
}

.button-group {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: -0.5rem;
}

.button-group>.button,
.button-group>.button--darkGray,
.button-group>.button--ghost,
.button-group>.button--ghost--gold,
.button-group>.button--ghost--gray,
.button-group>.button--ghost--green,
.button-group>.button--ghost--purple,
.button-group>.button--ghost--white,
.button-group>.button--green,
.button-group>.button--purple,
.button-group>.button--text--green,
.button-group>.button--text--purple,
.button-group>.button--text--white,
.button-group>.button--white,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .button-group>.plan-box__hover__button--ghost--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .button-group>.plan-box__hover__button--ghost--purple,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .button-group>.plan-box__hover__button--green,
.carousel-item:not(.swiper-slide-active) .plan-box:hover .button-group>.plan-box__hover__button--purple,
.has-blue-background-color .featured-plans .button-group>.button,
.has-blue-background-color .featured-plans__more .button-group>.button,
.has-dark-blue-background-color .featured-plans .button-group>.button,
.has-dark-blue-background-color .featured-plans__more .button-group>.button,
.kinsta-pagination .button-group>a.next,
.kinsta-pagination .button-group>a.page-numbers:not(.next):not(.prev),
.kinsta-pagination .button-group>a.prev,
.kinsta-pagination .button-group>span.current,
.plan-col:hover .plan-col__choose .button-group>a,
.swiper-slide-active .plan-box .button-group>.plan-box__button--active--ghost--gray,
.swiper-slide-active .plan-box .button-group>.plan-box__button--active--ghost--green,
.swiper-slide-active .plan-box .button-group>.plan-box__button--active--ghost--purple,
.swiper-slide-active .plan-box .button-group>.plan-box__button--active--ghost--white,
.swiper-slide-active .plan-box .button-group>.plan-box__button--active--green,
.swiper-slide-active .plan-box .button-group>.plan-box__button--active--purple {
    margin: 0.5rem;
}

.box {
    background: #fff;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0.25rem;
    box-shadow: 0 10px 40px 0 rgba(47, 47, 47, 0.1);
    display: block;
    padding: 2rem;
    position: relative;
    transition: all 0.2s linear;
}

@media (min-width: 75em) {
    .box {
        padding: 2.5rem;
    }
}

.box:link {
    color: inherit;
    text-decoration: none;
}

.box:link:focus,
.box:link:hover {
    box-shadow: 0 10px 40px 0 rgba(47, 47, 47, 0.21);
}

.box-radius--12 {
    border-radius: 12px;
}

.box--noshadow {
    box-shadow: none;
}

.box--padding--60 {
    padding: 3.75rem;
}

.box--padding--20 {
    padding: 1.25rem;
}

.box--padding--20-40 {
    padding: 20px 40px;
}

@media only screen and (max-width: 47em) {
    .box--padding-xs-20 {
        padding-left: 20px;
        padding-right: 20px;
    }

    .box--vpadding-xs-20 {
        padding-bottom: 20px;
        padding-top: 20px;
    }
}

.box--padding--0 {
    padding: 0;
}

.box--padding--top--20 {
    padding-top: 20px;
}

.box--inline {
    display: inline-block;
}

.boxes--alternating .box {
    margin-top: -35px;
    transform: translateY(-10px);
    width: 58%;
}

.boxes--alternating .box:last-of-type {
    margin-top: 0;
}

.boxes--alternating .box:nth-of-type(odd) {
    margin-left: 42%;
}

@media only screen and (min-width: 47.9999em) and (max-width: 71.999em) {
    .boxes--alternating .box {
        margin-left: -20px;
        margin-top: 20px;
        width: 80%;
    }

    .boxes--alternating .box:last-of-type {
        margin-top: 0;
    }

    .boxes--alternating .box:nth-of-type(odd) {
        margin-left: calc(20% + 20px);
    }
}

@media only screen and (max-width: 47.9999em) {
    .boxes--alternating .box {
        margin-left: 0;
        margin-top: 20px;
        width: 100%;
    }

    .boxes--alternating .box:last-of-type {
        margin-top: 0;
    }

    .boxes--alternating .box:nth-of-type(odd) {
        margin-left: 0;
    }
}

.boxes--pair .box {
    flex: 1;
    position: relative;
}

.boxes--pair .box:last-child {
    top: 17px;
}

.box--hoverfocus:hover {
    box-shadow: 0 10px 40px 0 rgba(47, 47, 47, 0.21);
}

.accordion {
    padding-left: 22px;
    position: relative;
}

.accordion:first-child {
    margin-top: 0;
}

.accordion input {
    display: none;
}

.accordion__title label {
    cursor: pointer;
    display: block;
}

.accordion__title label:focus {
    outline: 1px dotted #5333ed;
    outline-offset: 2px;
}

.accordion__title:hover,
input:checked~.accordion__title {
    color: #5333ed;
}

.accordion--dark input:checked~.accordion__title {
    color: #fff;
}

.accordion label {
    outline: 0;
    position: relative;
}

.accordion__content {
    padding-top: 22px;
}

.accordion label:before {
    background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 7 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><polyline stroke-width="2" stroke="%235333ED" id="Shape" points="0.652 8.702 4.572 4.849 0.652 0.996"></polyline></g></svg>');
    background-repeat: no-repeat;
    content: "";
    display: block;
    height: 10px;
    left: -22px;
    position: absolute;
    top: 7px;
    width: 10px;
}

.accordion__title label:before {
    transition: all 0.2s linear;
}

input:checked~.accordion__title label:before {
    transform: rotate(90deg);
}

.accordion.accordion--arrow-right {
    padding-left: 0;
}

.accordion.accordion--arrow-right label:before {
    left: auto;
    right: 0;
}

.accordion.accordion--dark label:before {
    background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 7 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><polyline stroke-width="2" stroke="%23fff" id="Shape" points="0.652 8.702 4.572 4.849 0.652 0.996"></polyline></g></svg>');
}

.accordion--sm-only .accordion__content {
    display: block;
}

.accordion--sm-only label:before {
    display: none;
}

@media only screen and (max-width: 48em) {
    .accordion--sm-only label:before {
        display: block;
    }

    .accordion--sm-only .accordion__content {
        display: none;
    }

    .accordion--sm-only input:checked~.accordion__content {
        display: block;
    }
}

.details-accordion>details,
.details-accordion__details {
    display: block;
    padding-left: 22px;
    position: relative;
    transition: height 0.3s;
}

.details-accordion>details+.details-accordion__details:not([class*="col-"]),
.details-accordion>details+details:not([class*="col-"]),
.details-accordion>details>summary+*,
.details-accordion__details+.details-accordion__details:not([class*="col-"]),
.details-accordion__details+details:not([class*="col-"]),
.details-accordion__details>summary+* {
    margin-top: 30px;
}

.details-accordion>details>summary,
.details-accordion__details>summary {
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
    display: block;
    line-height: 1.1;
    list-style: none;
    outline: none;
    padding: 0;
    transition: color 0.2s;
}

.details-accordion>details>summary::-webkit-details-marker,
.details-accordion>details>summary::marker,
.details-accordion__details>summary::-webkit-details-marker,
.details-accordion__details>summary::marker {
    content: "";
    display: none;
}

.details-accordion>details>summary:focus,
.details-accordion>details>summary:hover,
.details-accordion__details>summary:focus,
.details-accordion__details>summary:hover {
    color: #5333ed;
}

.details-accordion>details>summary:before,
.details-accordion__details>summary:before {
    background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 7 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round"><polyline stroke-width="2" stroke="%235333ED" id="Shape" points="0.652 8.702 4.572 4.849 0.652 0.996"></polyline></g></svg>');
    background-position: 0;
    background-repeat: no-repeat;
    content: "";
    display: block;
    height: 0.6rem;
    left: 0;
    margin-top: -0.3rem;
    position: absolute;
    top: 0.6em;
    transform: rotate(0deg);
    transition: transform 0.2s;
    width: 0.6rem;
}

.details-accordion>details[open]>summary:before,
.details-accordion__details[open]>summary:before {
    transform: rotate(90deg);
}

.screen {
    background: #fff;
    background-image: url('data:image/svg+xml;utf8, <svg width="50px" height="12px" viewBox="0 0 50 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Group" fill="#F3F3F4"> <circle id="Oval" cx="6" cy="6" r="6"></circle> <circle id="Oval" cx="25" cy="6" r="6"></circle> <circle id="Oval" cx="44" cy="6" r="6"></circle> </g> </g> </svg>');
    background-position: 20px 12px;
    background-repeat: no-repeat;
    border-radius: 20px;
    box-shadow: 0 5px 80px 0 rgba(0, 0, 0, 0.1);
    padding: 36px 20px 20px;
}

.screen>img {
    display: block;
    width: 100%;
}

.screen--blue-shadow {
    box-shadow: 0 5px 80px 30px rgba(204, 219, 238, 0.4);
}

.screen--small-bezel {
    border: 10px solid #fff;
    padding: 0;
}

@media only screen and (max-width: 48em) {
    .screen--small-bezel.screen {
        background: #fff;
        border: 8px solid #fff;
        border-radius: 16px;
        padding: 0;
    }

    .screen--small-bezel.screen>img {
        border-radius: 8px;
    }
}

.screen--small-bezel>img {
    border-radius: 10px;
}

@media only screen and (max-width: 48em) {
    .screen {
        background-image: url('data:image/svg+xml;utf8, <svg width="34px" viewBox="0 0 50 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Group" fill="#F3F3F4"> <circle id="Oval" cx="6" cy="6" r="6"></circle> <circle id="Oval" cx="25" cy="6" r="6"></circle> <circle id="Oval" cx="44" cy="6" r="6"></circle> </g> </g> </svg>');
        background-position: 16px 9px;
        background-repeat: no-repeat;
        border-radius: 11px;
        padding: 24px 11px 11px;
    }
}

.featured-plans[data-interval="month"] [data-interval="year"],
.featured-plans[data-interval="year"] [data-interval="month"] {
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.featured-plans {
    overflow: hidden;
}

@media (min-width: 64em) {
    .featured-plans .plan-box-container+.plan-box-container>.plan-box {
        border-left: 1px solid;
    }
}

.featured-plans .plan-box {
    transition: background-color 0.3s;
}

.featured-plans .plan-box:hover,
.featured-plans .plan-box[focus-within] {
    background-color: rgba(225, 234, 248, 0.1);
}

.featured-plans .plan-box:focus-within,
.featured-plans .plan-box:hover {
    background-color: rgba(225, 234, 248, 0.1);
}

.featured-plans__more {
    background-color: transparent;
    border: 1px solid;
    border-color: inherit;
    box-shadow: none;
    color: inherit;
    text-align: center;
}

@media (min-width: 48em) {
    .featured-plans__more {
        align-items: center;
        display: flex;
        flex-direction: row;
        text-align: left;
    }
}

.featured-plans__more h3 {
    color: inherit;
}

.featured-plans__more__content {
    flex-grow: 1;
    margin-bottom: 1rem;
}

@media (min-width: 48em) {
    .featured-plans__more__content {
        margin-bottom: 0;
        padding: 0 1rem;
    }
}

@media (min-width: 75em) {
    .featured-plans__more__content {
        padding: 0 2rem;
    }
}

.featured-plans__more__content> :first-child {
    margin-top: 0;
}

.featured-plans__more__content> :last-child {
    margin-bottom: 0;
}

.featured-plans__more__image {
    max-width: 8rem;
}

.has-blue-background-color .featured-plans .plan-box,
.has-blue-background-color .featured-plans__more,
.has-dark-blue-background-color .featured-plans .plan-box,
.has-dark-blue-background-color .featured-plans__more {
    border-color: #5333ed !important;
}

.plans {
    margin-left: 0;
    margin-right: 0;
}

.plan-box {
    overflow: hidden;
    padding: 2rem 1rem;
    text-align: center;
}

.plan-box .buy-button {
    height: 50px;
    line-height: 27px;
}

.plan-box__flag {
    word-wrap: break-word;
    background: #33a3d7;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    height: auto;
    left: 100px;
    opacity: 0;
    padding: 6px 32%;
    pointer-events: none;
    position: absolute;
    text-align: center;
    top: 35px;
    transform: rotate(45deg);
    transition: opacity 0.5s;
    width: 100%;
}

.swiper-slide-active .plan-box__flag {
    opacity: 1;
}

.plan-box__interval,
.plan-box__name {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

@media (min-width: 64em) {

    .plan-box__interval,
    .plan-box__name {
        font-size: 0.875rem;
    }
}

.plan-box__name__subtitle {
    display: block;
}

.plan-box__interval {
    opacity: 0.6;
}

.plan-box__amount,
.plan-box__name {
    margin-bottom: 1rem;
}

.plan-box__amount,
.plan-box__interval {
    display: block;
    line-height: 1;
}

.plan-box__amount {
    font-size: 56px;
    font-weight: 900;
    letter-spacing: -2px;
}

body[data-interval="year"] .plan-box__amount {
    font-size: 46px;
}

@media only screen and (max-width: 72em) {
    body[data-interval="year"] .plan-box__amount {
        font-size: 36px;
    }
}

.price--year {
    display: none;
}

.interval-year .price--year {
    display: block;
}

.interval-year .price--month {
    display: none;
}

.plan-box--up-to {
    bottom: -20px;
    position: relative;
}

.plan-box__price {
    margin-bottom: 30px;
}

.plan-box__price--more {
    align-items: center;
    display: flex;
    flex-direction: column;
    font-size: 32px;
    font-weight: 600;
    justify-content: flex-start;
    line-height: 1;
    position: relative;
    top: 10px;
}

.plan-box__price--more small {
    font-size: 17px;
    font-weight: 400;
}

.plan-box__details {
    list-style: none !important;
    margin: 0 0 2rem;
    padding: 0 !important;
}

.plan-box__details li {
    margin: 9px 0;
}

.plan-box__details li:first-child {
    margin-top: 0;
}

.plan-box__details li:last-child {
    margin-bottom: 0;
}

.has-blue-background-color .plan-box .color--purple,
.has-blue-background-color .plan-box .plan-box__name__subtitle,
.has-dark-blue-background-color .plan-box .color--purple,
.has-dark-blue-background-color .plan-box .plan-box__name__subtitle,
.has-purple-background-color .plan-box .color--purple,
.has-purple-background-color .plan-box .plan-box__name__subtitle {
    color: #2cd4d9;
}

.has-blue-background-color .plan-box .plan-box__name,
.has-dark-blue-background-color .plan-box .plan-box__name,
.has-purple-background-color .plan-box .plan-box__name {
    color: inherit;
}

.plan-box--bordered {
    border-left: 1px solid #fbfbfb;
    border-right: 1px solid #f4f4f4;
}

.plan-box--hover--bg--green,
.plan-box--hover--bg--purple {
    transition: all 0.2s linear;
}

.plan-box--hover--bg--purple:hover {
    background: #5333ed;
}

.plan-box--hover--bg--green:hover {
    background: #2cd4d9;
}

.swiper-slide-active .plan-box .plan-box__details {
    opacity: 1;
}

.swiper-slide-active .plan-box.plan-box--active--bg--gray {
    background-color: #e1eaf8;
    position: relative;
}

.swiper-slide-active .plan-box.plan-box--active--bg--blue {
    background-color: #150773;
    position: relative;
}

.swiper-slide-active .plan-box.plan-box--active--bg--darkblue {
    background-color: #0c022f;
    position: relative;
}

.swiper-slide-active .plan-box.plan-box--active--bg--purple {
    background-color: #5333ed;
    position: relative;
}

.plans-carousel-content {
    overflow: hidden;
    position: relative;
}

.swiper-slide-active .plans-carousel-content {
    background: #fff;
    box-shadow: 0 10px 40px 0 rgba(57, 11, 126, 0.2);
    z-index: 3000;
}

.home .plan-box-container .plan-box {
    align-items: center;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
}

.home .plans-footnote>.flex:nth-child(2) {
    flex-direction: column;
}

@media screen and (min-width: 840px) {
    .home .plans-footnote>.flex {
        justify-content: center;
        text-align: center;
    }

    .home .plans-footnote>.flex:nth-child(2) {
        flex-direction: row;
    }
}

.plan-table {
    display: flex;
    overflow: auto;
}

.plan-col {
    padding-top: 20px;
}

.plan-col:not(.plan-col_labels) {
    position: relative;
    text-align: center;
    width: 120px;
}

.plan-col:not(.plan-col_labels):hover {
    box-shadow: 0 10px 40px 0 rgba(93, 53, 26, 0.1);
    z-index: 7777;
}

.plan-col__name {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 8px;
    text-transform: uppercase;
}

.plan-col__price {
    align-items: center;
    color: #5333ed;
    display: flex;
    font-size: 24px;
    font-weight: 600;
    height: 24px;
    justify-content: center;
    margin-bottom: 11px;
}

.plan-col__price .interval {
    font-size: 14px;
    line-height: 24px;
}

.plan-col__price .plan-box__price--year {
    font-size: 20px;
    line-height: 24px;
}

.plan-col__header {
    margin-bottom: 40px;
}

.plan-col__blocker {
    background: #fff;
    box-shadow: 0 14px 40px -14px rgba(47, 47, 47, 0.1);
    display: none;
    height: 116px;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 7776;
}

.plan-col__blocker.stuck {
    display: block;
}

.plan-col_labels .plan-col__body {
    text-align: left;
    white-space: nowrap;
}

.plan-col_labels .plan-col__body>div {
    justify-content: flex-start;
    padding-left: 20px;
    padding-right: 44px;
}

.plan-col__migrations svg {
    display: none;
    position: absolute;
    right: -26px;
    top: 5px;
}

.plan-col__migrations.hover svg {
    display: block;
}

.plan-col__body>div {
    align-items: center;
    display: flex;
    height: 32px;
    justify-content: center;
    padding: 9px 0;
}

.plan-col__body>div span {
    position: relative;
}

.plan-col__body>div:hover {
    background: hsla(19, 42%, 91%, 0.2);
}

.plan-col__body.text--left>div {
    justify-content: flex-start;
    text-align: left;
}

.plan-col.selected {
    background-image: linear-gradient(-90deg, #fefaf3, #fef8eb);
}

@media only screen and (max-width: 48em) {
    .plan-col_labels {
        font-size: 12px;
    }

    .plan-col:not(.plan-col_labels) {
        flex-shrink: 0;
    }

    .plan-col_labels .plan-col__body>div {
        padding-left: 0;
        padding-right: 20px;
    }
}

.plan-col__header.stuck {
    background: #fff;
    box-shadow: 0 14px 40px -14px rgba(47, 47, 47, 0.1);
    padding-bottom: 20px;
    padding-top: 5px;
    position: fixed;
    z-index: 99999;
}

.plan-col.selected .plan-col__header.stuck {
    background: linear-gradient(-90deg, #fefaf3, #fef8eb);
}

.icon-left-block {
    display: flex;
}

.icon-left-block__icon {
    margin-right: 22px;
}

.card {
    background: #fff;
    box-shadow: 0 10px 40px 0 rgba(47, 47, 47, 0.05);
    padding: 66px;
    position: relative;
}

.cards--alternating .box,
.cards--alternating .card {
    margin-top: -35px;
    width: 58%;
}

.cards--alternating .box:last-of-type,
.cards--alternating .card:last-of-type {
    margin-top: 0;
}

.cards--alternating .box:nth-of-type(odd),
.cards--alternating .card:nth-of-type(odd) {
    margin-left: 42%;
}

.cards--pair {
    flex-direction: row;
}

.cards--pair .box,
.cards--pair .card {
    flex: 1;
    position: relative;
}

.cards--pair .box:last-child,
.cards--pair .card:last-child {
    top: 17px;
}

.quote {
    display: flex;
    position: relative;
}

.quote__screenshot {
    align-items: center;
    display: flex;
    height: 100%;
    position: absolute;
    width: 51%;
    z-index: 3000;
}

.quote__screenshot img {
    box-shadow: 0 0 23px 4px rgba(0, 0, 0, 0.1);
    display: block;
    max-height: 281px;
    width: auto;
}

.quote__content {
    background: #f6f8fa;
    flex: 1;
    margin-left: 45%;
    padding: 66px 66px 66px 112px;
    position: relative;
    width: 55%;
}

.quote.quote--vertical {
    display: block;
}

.quote.quote--vertical .quote__screenshot {
    display: block;
    height: auto;
    position: relative;
    top: 40px;
    width: auto;
}

.quote.quote--vertical .quote__screenshot img {
    margin: 0 auto;
}

.quote.quote--vertical .quote__content {
    margin: auto;
    padding: 66px;
    width: auto;
}

.quote__text {
    position: relative;
    text-align: left;
    z-index: 1100;
}

.quote__text:before {
    background-image: url("data:image/svg+xml;utf8,<svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'><g fill='#fff'><path d='M12,17H4v-2c0-4.098,2.188-8.188,6-9.562V1C3.812,2.688,0,8.66,0,15v4v10c0,1.105,0.895,2,2,2h10c1.105,0,2-0.895,2-2V19   C14,17.896,13.105,17,12,17z'/><path d='M30,17h-8v-2c0-4.098,2.188-8.188,6-9.562V1c-6.188,1.688-10,7.66-10,14v4v10c0,1.105,0.895,2,2,2h10c1.105,0,2-0.895,2-2   V19C32,17.896,31.105,17,30,17z'/></g></svg>");
    background-repeat: no-repeat;
    content: " ";
    height: 66px;
    left: -44px;
    position: absolute;
    top: -33px;
    width: 66px;
    z-index: -1;
}

@media only screen and (max-width: 47.999em) {
    .quote__screenshot {
        display: none;
    }

    .quote__content {
        margin-left: 0;
        padding: 24px 24px 42px;
        width: 100%;
    }

    .quote__text:before {
        display: none;
    }
}

@media only screen and (min-width: 48em) and (max-width: 64em) {
    .quote__screenshot {
        height: auto;
        margin-top: -42px;
        position: relative;
        top: 42px;
        width: 100%;
    }

    .quote__screenshot img {
        margin: 0 auto;
        max-height: auto;
    }

    .quote__content {
        margin-left: 0;
        padding: 66px 66px 42px;
        width: 100%;
    }
}

body {
    --swiper-navigation-size: 34px;
    --swiper-theme-color: #5333ed;
}

.carousel .swiper-button-next,
.carousel .swiper-button-prev {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    display: block;
    height: 34px;
    outline: none;
    width: 34px;
}

.carousel .swiper-button-next:after,
.carousel .swiper-button-prev:after {
    background-image: url(/wp-content/themes/kinsta/images/icon-chevron-l.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    display: block;
    font-weight: 900;
    height: 34px;
    width: 34px;
}

.carousel .swiper-button-next {
    right: 0;
}

.carousel .swiper-button-prev {
    left: 0;
}

.carousel .swiper-button-prev:after {
    transform: rotate(180deg);
}

.carousel .swiper-button-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    z-index: 1;
}

.carousel .swiper-button-container .swiper-button-next,
.carousel .swiper-button-container .swiper-button-prev {
    left: 0;
    position: relative;
    top: 0;
    transform: none;
}

.carousel {
    max-width: 100%;
}

.carousel.swiper-container {
    overflow: hidden;
    position: relative;
}

.carousel .swiper-slide {
    padding-left: 34px;
    padding-right: 34px;
}

.carousel .swiper-wrapper {
    align-items: center;
}

.breadcrumbs {
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
}

.breadcrumbs__link {
    color: inherit;
    font-size: 0.625rem;
    font-weight: 500;
    opacity: 0.7;
    text-decoration: none;
    text-transform: uppercase;
}

@media (min-width: 64em) {
    .breadcrumbs__link {
        font-size: 0.75rem;
    }
}

.breadcrumbs__link:link {
    background-image: linear-gradient(transparent calc(100% - 2px),
            currentColor 2px);
}

.bg--body {
    height: 100vh;
    position: absolute;
    width: 100%;
}

.bg--skewed {
    overflow: hidden;
    transform: skewY(-30deg);
    transform-origin: 0;
}

.bg--mask {
    background-image: linear-gradient(-30deg,
            rgba(0, 0, 77, 0.8),
            rgba(83, 51, 237, 0.8) 49%,
            rgba(44, 212, 217, 0.8));
}

.bg--gradient--dark-light-blue,
.has-hero-gradient-background {
    background-image: linear-gradient(-30deg, #00004d, #5333ed 49%, #2cd4d9);
}

.bg--gradient--purple-light-blue {
    background-image: linear-gradient(-30deg, #24035b, #7533ed 49%, #2ca2d9);
}

.bg--white {
    background-color: #fff;
    position: relative;
}

.bg--light-blue {
    background-color: #fbfdff;
}

.bg--light-gray {
    background-color: #f9f9fb;
}

.bg--gray,
.kinsta-pagination span.current {
    background-color: #e1eaf8;
    position: relative;
}

.bg--blue {
    background-color: #150773;
    position: relative;
}

.bg--darkblue {
    background-color: #0c022f;
    position: relative;
}

.bg--purple {
    background-color: #5333ed;
    position: relative;
}

.bg--green {
    background-color: #2cd4d9;
    position: relative;
}

.bg--text {
    background-color: #6e7076;
}

.bg--image--tech,
.bg--text {
    position: relative;
}

.bg--image--tech:before {
    background-image: url("data:image/svg+xml;utf8,<svg viewBox='0 0 2052 1016' xmlns='http://www.w3.org/2000/svg'><g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round' opacity='0.094913949' stroke-linejoin='round'><g id='plans-bg' style='mix-blend-mode: screen;' transform='translate(1.000000, 1.000000)' stroke='#FFFFFF' stroke-width='3'><path d='M2049.2385,1012.8799 L1702.0455,810.7509 C1649.3365,780.0639 1616.9125,723.6699 1616.9125,662.6769 L1616.9125,395.4219' id='Stroke-1'></path><path d='M1891.6432,1012.8799 L1597.8652,810.7509 C1553.2642,780.0639 1525.8292,723.6699 1525.8292,662.6769 L1525.8292,475.4219' id='Stroke-3'></path><path d='M1734.048,1012.8799 L1493.684,810.7509 C1457.192,780.0639 1434.745,723.6699 1434.745,662.6769 L1434.745,305.4219' id='Stroke-5'></path><path d='M1576.4528,1012.8799 L1389.5028,810.7509 C1361.1198,780.0639 1343.6618,723.6699 1343.6618,662.6769 L1343.6618,365.4219' id='Stroke-7'></path><path d='M1418.8575,1012.8799 L1285.3215,810.7509 C1265.0485,780.0639 1252.5785,723.6699 1252.5785,662.6769 L1252.5785,495.4219' id='Stroke-9'></path><path d='M1261.2623,1012.8799 L1181.1403,810.7509 C1168.9763,780.0639 1161.4943,723.6699 1161.4943,662.6769 L1161.4943,435.4219 L1182.8973,414.0189 L1182.8973,377.1679 L1174.5983,368.8699 L1174.5983,105.1679' id='Stroke-11'></path><path d='M1103.6666,1012.8799 L1076.9596,810.7509 C1072.9046,780.0639 1070.4106,723.6699 1070.4106,662.6769 L1070.4106,551.1679 L1070.4106,249.1679 L1087.0386,232.5399 L1087.0386,131.1679' id='Stroke-13'></path><path d='M946.0715,1012.8799 L972.7795,810.7509 C976.8335,780.0639 979.3275,723.6699 979.3275,662.6769 L979.3275,525.4219' id='Stroke-15'></path><path d='M788.4763,1012.8799 L868.5983,810.7509 C880.7613,780.0639 888.2443,723.6699 888.2443,662.6769 L888.2443,395.4219 L918.2443,365.4219 L918.2443,71.1679' id='Stroke-17'></path><path d='M630.881,1012.8799 L764.417,810.7509 C784.69,780.0639 797.16,723.6699 797.16,662.6769 L797.16,435.4219' id='Stroke-19'></path><path d='M473.2858,1012.8799 L660.2358,810.7509 C688.6178,780.0639 706.0768,723.6699 706.0768,662.6769 L706.0768,325.4219' id='Stroke-21'></path><path d='M315.6906,1012.8799 L556.0546,810.7509 C592.5456,780.0639 614.9936,723.6699 614.9936,662.6769 L614.9936,285.4219' id='Stroke-23'></path><path d='M158.0954,1012.8799 L451.8734,810.7509 C496.4744,780.0639 523.9094,723.6699 523.9094,662.6769 L523.9094,335.4219' id='Stroke-25'></path><path d='M0.5002,1012.8799 L347.6922,810.7509 C400.4022,780.0639 432.8262,723.6699 432.8262,662.6769 L432.8262,435.4219' id='Stroke-27'></path><polyline id='Stroke-29' points='1166.7125 407.1682 1166.7125 387.1682 1119.7125 340.1682 1119.7125 0.5012'></polyline><path d='M1194.9288,288.9429 C1194.9288,291.0279 1193.2388,292.7179 1191.1538,292.7179 C1189.0698,292.7179 1187.3798,291.0279 1187.3798,288.9429 C1187.3798,286.8579 1189.0698,285.1679 1191.1538,285.1679 C1193.2388,285.1679 1194.9288,286.8579 1194.9288,288.9429 Z' id='Stroke-31'></path><path d='M1194.9288,308.9429 C1194.9288,311.0279 1193.2388,312.7179 1191.1538,312.7179 C1189.0698,312.7179 1187.3798,311.0279 1187.3798,308.9429 C1187.3798,306.8579 1189.0698,305.1679 1191.1538,305.1679 C1193.2388,305.1679 1194.9288,306.8579 1194.9288,308.9429 Z' id='Stroke-33'></path><path d='M1194.9288,328.9429 C1194.9288,331.0279 1193.2388,332.7179 1191.1538,332.7179 C1189.0698,332.7179 1187.3798,331.0279 1187.3798,328.9429 C1187.3798,326.8579 1189.0698,325.1679 1191.1538,325.1679 C1193.2388,325.1679 1194.9288,326.8579 1194.9288,328.9429 Z' id='Stroke-35'></path><path d='M983.1022,502.5015 C983.1022,504.5865 981.4122,506.2765 979.3272,506.2765 C977.2432,506.2765 975.5532,504.5865 975.5532,502.5015 C975.5532,500.4165 977.2432,498.7265 979.3272,498.7265 C981.4122,498.7265 983.1022,500.4165 983.1022,502.5015 Z' id='Stroke-37'></path><path d='M983.1022,522.5015 C983.1022,524.5865 981.4122,526.2765 979.3272,526.2765 C977.2432,526.2765 975.5532,524.5865 975.5532,522.5015 C975.5532,520.4165 977.2432,518.7265 979.3272,518.7265 C981.4122,518.7265 983.1022,520.4165 983.1022,522.5015 Z' id='Stroke-39'></path><polyline id='Stroke-41' points='983.1022 499.5015 1047.2412 435.3635 1047.2412 78.1685'></polyline></g></g></svg>");
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    content: " ";
    display: block;
    height: 100%;
    left: 0;
    opacity: 0.6;
    position: absolute;
    top: 0;
    width: 100%;
}

.bg--image--tech.bg--bottom-aligned:before {
    background-position: bottom;
}

.has-turquoise-background-color {
    background-color: #2cd4d9;
    color: #f9f9fb;
}

.has-turquoise-color {
    color: #2cd4d9;
}

.has-purple-background-color {
    background-color: #5333ed;
    color: #f9f9fb;
}

.has-purple-color {
    color: #5333ed;
}

.has-blue-background-color {
    background-color: #150773;
    color: #f9f9fb;
}

.has-blue-color {
    color: #150773;
}

.has-light-blue-background-color {
    background-color: #fbfdff;
    color: #0c022f;
}

.has-light-blue-color {
    color: #fbfdff;
}

.has-dark-blue-background-color {
    background-color: #0c022f;
    color: #f9f9fb;
}

.has-dark-blue-color {
    color: #0c022f;
}

.has-gold-background-color {
    background-color: #ff961f;
    color: #f9f9fb;
}

.has-gold-color {
    color: #ff961f;
}

.has-green-background-color {
    background-color: #d4f5bc;
    color: #0c022f;
}

.has-green-color {
    color: #d4f5bc;
}

.has-red-background-color {
    background-color: #ed1c24;
    color: #f9f9fb;
}

.has-red-color {
    color: #ed1c24;
}

.has-white-background-color {
    background-color: #fff;
    color: #0c022f;
}

.has-white-color {
    color: #fff;
}

.has-offwhite-background-color {
    background-color: #fafafa;
    color: #0c022f;
}

.has-offwhite-color {
    color: #fafafa;
}

.has-gray-background-color {
    background-color: #e1eaf8;
    color: #0c022f;
}

.has-gray-color {
    color: #e1eaf8;
}

.has-light-gray-background-color {
    background-color: #f9f9fb;
    color: #0c022f;
}

.has-light-gray-color {
    color: #f9f9fb;
}

.has-medium-gray-background-color {
    background-color: #999;
    color: #f9f9fb;
}

.has-medium-gray-color {
    color: #999;
}

.has-dark-gray-background-color {
    background-color: #44414e;
    color: #f9f9fb;
}

.has-dark-gray-color {
    color: #44414e;
}

.has-dove-gray-background-color {
    background-color: #f3f3f6;
    color: #0c022f;
}

.has-dove-gray-color {
    color: #f3f3f6;
}

.has-success-background-color {
    background-color: #30b00f;
    color: #f9f9fb;
}

.has-success-color {
    color: #30b00f;
}

.has-error-background-color {
    background-color: #e43c3c;
    color: #f9f9fb;
}

.has-error-color {
    color: #e43c3c;
}

.has-turquoise-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #5333ed 0,
            #5333ed);
}

.has-turquoise-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #150773 0,
            #150773);
}

.has-turquoise-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-turquoise-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #0c022f 0,
            #0c022f);
}

.has-turquoise-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #ff961f 0,
            #ff961f);
}

.has-turquoise-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-turquoise-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-turquoise-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #fff 0,
            #fff);
}

.has-turquoise-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #fafafa 0,
            #fafafa);
}

.has-turquoise-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-turquoise-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-turquoise-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #999 0,
            #999);
}

.has-turquoise-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #44414e 0,
            #44414e);
}

.has-turquoise-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-turquoise-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #30b00f 0,
            #30b00f);
}

.has-turquoise-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #2cd4d9 0,
            #2cd4d9 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-purple-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-purple-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #150773 0,
            #150773);
}

.has-purple-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-purple-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #0c022f 0,
            #0c022f);
}

.has-purple-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #ff961f 0,
            #ff961f);
}

.has-purple-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-purple-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-purple-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #fff 0,
            #fff);
}

.has-purple-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #fafafa 0,
            #fafafa);
}

.has-purple-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-purple-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-purple-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #999 0,
            #999);
}

.has-purple-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #44414e 0,
            #44414e);
}

.has-purple-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-purple-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #30b00f 0,
            #30b00f);
}

.has-purple-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #5333ed 0,
            #5333ed 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-blue-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-blue-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #5333ed 0,
            #5333ed);
}

.has-blue-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-blue-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #0c022f 0,
            #0c022f);
}

.has-blue-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #ff961f 0,
            #ff961f);
}

.has-blue-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-blue-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-blue-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #fff 0,
            #fff);
}

.has-blue-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #fafafa 0,
            #fafafa);
}

.has-blue-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-blue-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-blue-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #999 0,
            #999);
}

.has-blue-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #44414e 0,
            #44414e);
}

.has-blue-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-blue-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #30b00f 0,
            #30b00f);
}

.has-blue-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #150773 0,
            #150773 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-light-blue-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-light-blue-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #5333ed 0,
            #5333ed);
}

.has-light-blue-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #150773 0,
            #150773);
}

.has-light-blue-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #0c022f 0,
            #0c022f);
}

.has-light-blue-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #ff961f 0,
            #ff961f);
}

.has-light-blue-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-light-blue-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-light-blue-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #fff 0,
            #fff);
}

.has-light-blue-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #fafafa 0,
            #fafafa);
}

.has-light-blue-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-light-blue-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-light-blue-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #999 0,
            #999);
}

.has-light-blue-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #44414e 0,
            #44414e);
}

.has-light-blue-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-light-blue-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #30b00f 0,
            #30b00f);
}

.has-light-blue-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fbfdff 0,
            #fbfdff 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-dark-blue-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-dark-blue-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #5333ed 0,
            #5333ed);
}

.has-dark-blue-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #150773 0,
            #150773);
}

.has-dark-blue-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-dark-blue-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #ff961f 0,
            #ff961f);
}

.has-dark-blue-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-dark-blue-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-dark-blue-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #fff 0,
            #fff);
}

.has-dark-blue-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #fafafa 0,
            #fafafa);
}

.has-dark-blue-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-dark-blue-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-dark-blue-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #999 0,
            #999);
}

.has-dark-blue-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #44414e 0,
            #44414e);
}

.has-dark-blue-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-dark-blue-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #30b00f 0,
            #30b00f);
}

.has-dark-blue-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #0c022f 0,
            #0c022f 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-gold-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-gold-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #5333ed 0,
            #5333ed);
}

.has-gold-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #150773 0,
            #150773);
}

.has-gold-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-gold-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #0c022f 0,
            #0c022f);
}

.has-gold-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-gold-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-gold-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #fff 0,
            #fff);
}

.has-gold-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #fafafa 0,
            #fafafa);
}

.has-gold-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-gold-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-gold-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #999 0,
            #999);
}

.has-gold-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #44414e 0,
            #44414e);
}

.has-gold-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-gold-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #30b00f 0,
            #30b00f);
}

.has-gold-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ff961f 0,
            #ff961f 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-green-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-green-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #5333ed 0,
            #5333ed);
}

.has-green-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #150773 0,
            #150773);
}

.has-green-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-green-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #0c022f 0,
            #0c022f);
}

.has-green-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #ff961f 0,
            #ff961f);
}

.has-green-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-green-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #fff 0,
            #fff);
}

.has-green-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #fafafa 0,
            #fafafa);
}

.has-green-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-green-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-green-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #999 0,
            #999);
}

.has-green-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #44414e 0,
            #44414e);
}

.has-green-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-green-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #30b00f 0,
            #30b00f);
}

.has-green-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #d4f5bc 0,
            #d4f5bc 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-red-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-red-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #5333ed 0,
            #5333ed);
}

.has-red-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #150773 0,
            #150773);
}

.has-red-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-red-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #0c022f 0,
            #0c022f);
}

.has-red-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #ff961f 0,
            #ff961f);
}

.has-red-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-red-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #fff 0,
            #fff);
}

.has-red-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #fafafa 0,
            #fafafa);
}

.has-red-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-red-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-red-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #999 0,
            #999);
}

.has-red-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #44414e 0,
            #44414e);
}

.has-red-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-red-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #30b00f 0,
            #30b00f);
}

.has-red-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #ed1c24 0,
            #ed1c24 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-white-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-white-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #5333ed 0,
            #5333ed);
}

.has-white-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #150773 0,
            #150773);
}

.has-white-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-white-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #0c022f 0,
            #0c022f);
}

.has-white-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #ff961f 0,
            #ff961f);
}

.has-white-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-white-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-white-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #fafafa 0,
            #fafafa);
}

.has-white-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-white-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-white-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg, #fff 0, #fff 50%, #999 0, #999);
}

.has-white-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #44414e 0,
            #44414e);
}

.has-white-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-white-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #30b00f 0,
            #30b00f);
}

.has-white-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fff 0,
            #fff 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-offwhite-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-offwhite-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #5333ed 0,
            #5333ed);
}

.has-offwhite-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #150773 0,
            #150773);
}

.has-offwhite-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-offwhite-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #0c022f 0,
            #0c022f);
}

.has-offwhite-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #ff961f 0,
            #ff961f);
}

.has-offwhite-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-offwhite-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-offwhite-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #fff 0,
            #fff);
}

.has-offwhite-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-offwhite-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-offwhite-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #999 0,
            #999);
}

.has-offwhite-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #44414e 0,
            #44414e);
}

.has-offwhite-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-offwhite-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #30b00f 0,
            #30b00f);
}

.has-offwhite-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #fafafa 0,
            #fafafa 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-gray-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-gray-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #5333ed 0,
            #5333ed);
}

.has-gray-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #150773 0,
            #150773);
}

.has-gray-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-gray-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #0c022f 0,
            #0c022f);
}

.has-gray-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #ff961f 0,
            #ff961f);
}

.has-gray-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-gray-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-gray-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #fff 0,
            #fff);
}

.has-gray-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #fafafa 0,
            #fafafa);
}

.has-gray-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-gray-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #999 0,
            #999);
}

.has-gray-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #44414e 0,
            #44414e);
}

.has-gray-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-gray-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #30b00f 0,
            #30b00f);
}

.has-gray-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e1eaf8 0,
            #e1eaf8 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-light-gray-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-light-gray-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #5333ed 0,
            #5333ed);
}

.has-light-gray-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #150773 0,
            #150773);
}

.has-light-gray-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-light-gray-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #0c022f 0,
            #0c022f);
}

.has-light-gray-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #ff961f 0,
            #ff961f);
}

.has-light-gray-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-light-gray-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-light-gray-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #fff 0,
            #fff);
}

.has-light-gray-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #fafafa 0,
            #fafafa);
}

.has-light-gray-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-light-gray-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #999 0,
            #999);
}

.has-light-gray-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #44414e 0,
            #44414e);
}

.has-light-gray-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-light-gray-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #30b00f 0,
            #30b00f);
}

.has-light-gray-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f9f9fb 0,
            #f9f9fb 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-medium-gray-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-medium-gray-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #5333ed 0,
            #5333ed);
}

.has-medium-gray-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #150773 0,
            #150773);
}

.has-medium-gray-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-medium-gray-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #0c022f 0,
            #0c022f);
}

.has-medium-gray-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #ff961f 0,
            #ff961f);
}

.has-medium-gray-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-medium-gray-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-medium-gray-white-50-split-gradient {
    background-image: linear-gradient(180deg, #999 0, #999 50%, #fff 0, #fff);
}

.has-medium-gray-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #fafafa 0,
            #fafafa);
}

.has-medium-gray-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-medium-gray-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-medium-gray-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #44414e 0,
            #44414e);
}

.has-medium-gray-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-medium-gray-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #30b00f 0,
            #30b00f);
}

.has-medium-gray-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #999 0,
            #999 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-dark-gray-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-dark-gray-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #5333ed 0,
            #5333ed);
}

.has-dark-gray-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #150773 0,
            #150773);
}

.has-dark-gray-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-dark-gray-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #0c022f 0,
            #0c022f);
}

.has-dark-gray-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #ff961f 0,
            #ff961f);
}

.has-dark-gray-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-dark-gray-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-dark-gray-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #fff 0,
            #fff);
}

.has-dark-gray-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #fafafa 0,
            #fafafa);
}

.has-dark-gray-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-dark-gray-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-dark-gray-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #999 0,
            #999);
}

.has-dark-gray-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-dark-gray-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #30b00f 0,
            #30b00f);
}

.has-dark-gray-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #44414e 0,
            #44414e 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-dove-gray-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-dove-gray-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #5333ed 0,
            #5333ed);
}

.has-dove-gray-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #150773 0,
            #150773);
}

.has-dove-gray-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-dove-gray-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #0c022f 0,
            #0c022f);
}

.has-dove-gray-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #ff961f 0,
            #ff961f);
}

.has-dove-gray-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-dove-gray-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-dove-gray-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #fff 0,
            #fff);
}

.has-dove-gray-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #fafafa 0,
            #fafafa);
}

.has-dove-gray-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-dove-gray-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-dove-gray-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #999 0,
            #999);
}

.has-dove-gray-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #44414e 0,
            #44414e);
}

.has-dove-gray-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #30b00f 0,
            #30b00f);
}

.has-dove-gray-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #f3f3f6 0,
            #f3f3f6 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-success-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-success-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #5333ed 0,
            #5333ed);
}

.has-success-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #150773 0,
            #150773);
}

.has-success-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-success-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #0c022f 0,
            #0c022f);
}

.has-success-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #ff961f 0,
            #ff961f);
}

.has-success-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-success-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-success-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #fff 0,
            #fff);
}

.has-success-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #fafafa 0,
            #fafafa);
}

.has-success-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-success-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-success-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #999 0,
            #999);
}

.has-success-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #44414e 0,
            #44414e);
}

.has-success-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-success-error-50-split-gradient {
    background-image: linear-gradient(180deg,
            #30b00f 0,
            #30b00f 50%,
            #e43c3c 0,
            #e43c3c);
}

.has-error-turquoise-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #2cd4d9 0,
            #2cd4d9);
}

.has-error-purple-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #5333ed 0,
            #5333ed);
}

.has-error-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #150773 0,
            #150773);
}

.has-error-light-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #fbfdff 0,
            #fbfdff);
}

.has-error-dark-blue-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #0c022f 0,
            #0c022f);
}

.has-error-gold-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #ff961f 0,
            #ff961f);
}

.has-error-green-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #d4f5bc 0,
            #d4f5bc);
}

.has-error-red-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #ed1c24 0,
            #ed1c24);
}

.has-error-white-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #fff 0,
            #fff);
}

.has-error-offwhite-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #fafafa 0,
            #fafafa);
}

.has-error-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #e1eaf8 0,
            #e1eaf8);
}

.has-error-light-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #f9f9fb 0,
            #f9f9fb);
}

.has-error-medium-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #999 0,
            #999);
}

.has-error-dark-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #44414e 0,
            #44414e);
}

.has-error-dove-gray-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #f3f3f6 0,
            #f3f3f6);
}

.has-error-success-50-split-gradient {
    background-image: linear-gradient(180deg,
            #e43c3c 0,
            #e43c3c 50%,
            #30b00f 0,
            #30b00f);
}

.kinsta-pagination:empty {
    display: none;
}

.kinsta-pagination a.page-numbers:not(.next):not(.prev) {
    box-sizing: content-box;
    margin: 0 5px;
}

.kinsta-pagination .dots {
    margin: 0 5px;
}

.is-mykinsta-embed .page-numbers {
    margin-top: 12px;
}

.post-content {
    position: relative;
}

.user-content {
    word-break: break-word;
}

.user-content> :first-child {
    margin-top: 0;
}

.user-content .in-post-container {
    margin: 57.6px 0;
}

.user-content abbr {
    outline: none;
    text-decoration: none;
}

.user-content .aligncenter {
    margin-left: auto;
    margin-right: auto;
}

.user-content .responsive-table {
    overflow: auto;
    word-break: normal;
}

.user-content .responsive-table .responsive-table>table {
    width: auto;
}

.user-content table {
    margin-bottom: 28.8px;
}

.user-content table th {
    background: #e1eaf8;
    vertical-align: bottom;
}

.user-content table td,
.user-content table th {
    padding: 11px 22px;
    text-align: left;
}

.user-content table td {
    border-bottom: 1px solid #eee;
}

.user-content table tbody tr:nth-of-type(odd) td {
    background: #fafafa;
}

.user-content table.nowrap--col-1 tbody tr td:first-child,
.user-content table.nowrap--col-1 tbody tr th:first-child,
.user-content table.nowrap--col-2 tbody tr td:nth-child(2),
.user-content table.nowrap--col-2 tbody tr th:nth-child(2),
.user-content table.nowrap--col-3 tbody tr td:nth-child(3),
.user-content table.nowrap--col-3 tbody tr th:nth-child(3),
.user-content table.nowrap--col-4 tbody tr td:nth-child(4),
.user-content table.nowrap--col-4 tbody tr th:nth-child(4),
.user-content table.nowrap--col-5 tbody tr td:nth-child(5),
.user-content table.nowrap--col-5 tbody tr th:nth-child(5),
.user-content table.nowrap--col-6 tbody tr td:nth-child(6),
.user-content table.nowrap--col-6 tbody tr th:nth-child(6),
.user-content table.nowrap--col-7 tbody tr td:nth-child(7),
.user-content table.nowrap--col-7 tbody tr th:nth-child(7),
.user-content table.nowrap--col-8 tbody tr td:nth-child(8),
.user-content table.nowrap--col-8 tbody tr th:nth-child(8),
.user-content table.nowrap--col-9 tbody tr td:nth-child(9),
.user-content table.nowrap--col-9 tbody tr th:nth-child(9) {
    white-space: nowrap;
}

.user-content blockquote {
    border-left: 8px solid #f3f3f6;
    margin: 0 28.8px 28.8px;
    padding: 28.8px;
}

.user-content blockquote p:last-child {
    margin-bottom: 0;
}

.user-content ol,
.user-content ul {
    margin-bottom: 1rem;
    margin-top: 0;
    padding-left: 2rem;
}

.user-content ul {
    list-style: disc;
}

.user-content ol {
    list-style: decimal;
}

.user-content img {
    display: block;
}

.user-content p>img {
    margin-bottom: 57.6px;
    margin-top: 57.6px;
}

.user-content pre,
.user-content pre[class*="language-"] {
    background: #f9f9f9;
    border: 1px solid #f3f3f4;
    border-radius: 0.25rem;
    display: block;
    font-family: monospace;
    line-height: 28.8px;
    margin-bottom: 57.6px;
    margin-top: 57.6px;
    overflow: auto;
    padding: 28.8px 40px;
    white-space: pre;
    width: 100%;
}

.user-content code {
    background: #f9f9f9;
    border: 1px solid #f3f3f4;
    font-family: monospace;
    padding: 4px 8px;
}

.user-content pre code {
    border: 0;
    padding: 0;
}

.user-content .wp-video {
    margin-bottom: 57.6px;
    margin-top: 57.6px;
}

.user-content .wp-caption {
    margin: 57.6px auto;
    max-width: 100%;
}

.user-content .wp-caption img {
    border-radius: 4px;
    box-shadow: 0 4px 8px 0 rgba(67, 65, 78, 0.08);
}

.user-content .wp-caption-text {
    margin-bottom: 1em;
    margin-top: 1em;
    padding-left: 8px;
    padding-right: 8px;
    text-align: right;
}

.user-content .wp-caption-text:before {
    content: "— ";
}

.user-content table {
    width: 100%;
}

.user-content .twitter-tweet {
    margin-left: auto;
    margin-right: auto;
}

.user-content a.novashare-ctt {
    color: inherit;
    color: #44414e !important;
    display: flex;
    flex-direction: column;
    position: relative;
}

.user-content a.novashare-ctt,
.user-content a.novashare-ctt:hover {
    background: transparent !important;
    border: 0;
    margin: 43.2px 0 28.8px;
    padding: 0 0 0 40px;
}

.user-content a.novashare-ctt:hover .novashare-ctt-cta {
    color: #5333ed !important;
}

.user-content a.novashare-ctt:hover .novashare-ctt-cta-icon svg {
    fill: #5333ed !important;
}

.user-content a.novashare-ctt:before {
    color: #44414e;
    content: "“" !important;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif !important;
    font-size: 42px;
    font-weight: 900;
    left: 0;
    line-height: 1;
    position: absolute;
    top: 0;
}

.user-content a.novashare-ctt .novashare-ctt-tweet {
    color: inherit;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.6;
}

.user-content a.novashare-ctt .novashare-ctt-cta-container .novashare-ctt-cta {
    color: #999;
    transition: color 0.1s cubic-bezier(0.645, 0.045, 0.355, 1),
        transform 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.user-content a.novashare-ctt .novashare-ctt-cta-container .novashare-ctt-cta-icon svg {
    fill: #999;
    transition: fill 0.1s cubic-bezier(0.645, 0.045, 0.355, 1),
        transform 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.user-content a.novashare-ctt .novashare-ctt-cta-container {
    display: flex;
    margin-top: 0.5em;
}

.user-content a.novashare-ctt .novashare-ctt-cta {
    align-items: center;
    cursor: pointer;
    display: flex;
}

.user-content a.novashare-ctt .novashare-ctt-cta-text {
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
}

.user-content a.novashare-ctt .novashare-ctt-cta-icon {
    visibility: hidden;
}

.user-content kinsta-video {
    display: block;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.user-content .wp-embedded-content {
    border: none;
    border-radius: 0.25rem;
    box-shadow: 0 4px 8px 0 rgba(67, 65, 78, 0.08);
    display: block;
    width: 100%;
}

.user-content .wp-embedded-content[src*="://codepen.io/"] {
    border-radius: 0;
    height: 30em;
    max-height: 80vh;
}

iframe.airtable-embed {
    border-radius: 0.25rem;
    box-shadow: 0 4px 8px 0 rgba(67, 65, 78, 0.08);
    height: 30em;
    max-height: 80vh;
    width: 100%;
}

@media only screen and (min-width: 64em) {
    pre {
        width: calc(100% + 80px);
    }

    pre[class*="language-"] {
        margin-right: 0;
    }
}

.user-content .embed-responsive {
    margin-bottom: 28.8px;
}

.embed-responsive--video,
.embed-responsive--youtube {
    padding-bottom: 56.25%;
    position: relative;
}

.embed-responsive--video iframe,
.embed-responsive--youtube iframe {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

.is-mykinsta-embed {
    overflow: visible !important;
}

.is-mykinsta-embed__container {
    margin-left: auto;
    margin-right: auto;
    max-width: 680px;
    padding: 30px 30px 60px;
}

.is-mykinsta-embed .open-in-new-tab {
    font-size: 14px;
}

.is-mykinsta-embed .open-in-new-tab__link {
    font-weight: 600;
}

.is-mykinsta-embed .open-in-new-tab__icon {
    color: #999;
}

.is-mykinsta-embed .open-in-new-tab__icon svg {
    display: inline-block;
    height: 12px;
    position: relative;
    top: 2px;
    width: 12px;
}

.is-mykinsta-embed .breadcrumb li {
    background-position: right 48%;
    margin-right: 4px;
}

.is-mykinsta-embed .post-content h1 {
    margin-bottom: 1em;
}

.is-mykinsta-embed .post-content a[target="_blank"]:not(:empty) {
    margin-right: 24px;
    position: relative;
}

.is-mykinsta-embed .post-content a[target="_blank"]:not(:empty):after {
    background-image: url("data:image/svg+xml;utf8,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22%23999%22%20fill-rule%3D%22evenodd%22%20d%3D%22M12.586%202H10V0h6v6h-2V3.414l-5%205L7.586%207l5-5zM12%2012V9h2v5H2V2h5v2H4v8h8z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    display: inline-block;
    height: 16px;
    margin-left: 4px;
    margin-top: 6px;
    position: absolute;
    width: 16px;
}

.is-mykinsta-embed .post-content a[href^="https://my.kinsta.com"]:not(:empty) {
    margin-left: 24px;
    margin-right: 0;
    position: relative;
}

.is-mykinsta-embed .post-content a[href^="https://my.kinsta.com"]:not(:empty):before {
    background-image: url(https://my.kinsta.com/icons/favicon-32x32.png);
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    display: inline-block;
    height: 16px;
    margin-left: -20px;
    margin-top: 6px;
    position: absolute;
    width: 16px;
}

.is-mykinsta-embed .post-content a[href^="#"]:after,
.is-mykinsta-embed .post-content a[href^="#"]:before,
.is-mykinsta-embed .post-content a[href^="https://my.kinsta.com"]:not(:empty):after {
    display: none;
}

.is-mykinsta-embed #hubspot-messages-iframe-container {
    display: none !important;
}

.notice {
    background: #f9f9f9;
    border: 1px solid #f3f3f4;
    margin-bottom: 28.8px;
    padding: 28.8px;
    width: 100%;
}

.notice__content:last-of-type,
.notice__content:only-of-type {
    margin-bottom: 0;
}

.notice--important,
.notice--info {
    background-color: #f9f9fb;
    border-radius: 2px;
    margin-bottom: 30px;
    margin-left: 0;
    max-width: 100%;
    padding: 30px 60px 30px 65px;
    position: relative;
    width: 100%;
}

.notice--important .notice__heading,
.notice--info .notice__heading {
    align-items: center;
    display: flex;
    font-weight: 700;
}

.notice--important .notice__heading-icon,
.notice--info .notice__heading-icon {
    left: 35px;
    position: absolute;
}

@media screen and (min-width: 520px) {
    #feedback-buttons {
        display: flex;
    }
}

.help svg {
    display: inline-block;
}

.page-template-mykinsta-v2 .help {
    cursor: help;
    left: 4px;
    position: relative;
    top: 2px;
}

.label,
.label--blue,
.label--green,
.label--purple {
    border-radius: 6px;
    display: inline-block;
    font-size: 10px;
    height: 16px;
    padding: 1px 8px;
    position: relative;
    text-transform: uppercase;
    top: -2px;
    vertical-align: middle;
}

.label--small {
    text-transform: none;
}

.label--large {
    font-size: 11px;
    padding: 3px 11px;
}

.label--green {
    background: #2cd4d9;
    color: #150773;
}

.label--purple {
    background: #5333ed;
    color: #fff;
}

.label--blue {
    background: #150773;
    color: #fff;
}

.list,
.user-content .list {
    list-style-type: disc;
    margin-bottom: 28.8px;
    margin-left: 20px;
    margin-top: 28.8px;
}

.list ol,
.list ul,
.user-content .list ol,
.user-content .list ul {
    margin-bottom: 10px;
    margin-left: 20px;
    margin-top: 0;
}

.list li,
.user-content .list li {
    margin-bottom: 10px;
}

.list li:last-child,
.user-content .list li:last-child {
    margin-bottom: 0;
}

.list--none,
.list--none li,
.user-content .list--none,
.user-content .list--none li {
    list-style-type: none !important;
}

.list--square,
.list--square li,
.user-content .list--square,
.user-content .list--square li {
    list-style-type: square;
}

.list--disc,
.list--disc li,
.user-content .list--disc,
.user-content .list--disc li {
    list-style-type: disc;
}

.list--circle,
.list--circle li,
.user-content .list--circle,
.user-content .list--circle li {
    list-style-type: circle;
}

.list--map-pin,
.user-content .list--map-pin {
    margin-left: 0;
}

.list--map-pin li,
.user-content .list--map-pin li {
    display: flex;
}

.list--map-pin,
.list--map-pin li,
.user-content .list--map-pin,
.user-content .list--map-pin li {
    list-style-type: none;
}

@media (min-width: 48em) {

    ol.has-columns,
    ul.has-columns {
        grid-column-gap: 2rem;
        column-count: 2;
        column-gap: 2rem;
    }
}

ol.is-style-location-list,
ul.is-style-location-list {
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 700;
    padding-left: 0;
}

ol.is-style-location-list>li,
ul.is-style-location-list>li {
    align-items: center;
    display: inline-flex;
    line-height: 1.5;
    padding-bottom: 0.5rem;
    padding-top: 0.5rem;
    width: 100%;
}

ol.is-style-location-list>li:before,
ul.is-style-location-list>li:before {
    background-image: url(/wp-content/themes/kinsta/images/features-choose-datacenter.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    content: "";
    display: block;
    height: 1.5em;
    margin-right: 0.5rem;
    width: 1.5em;
}

ol.is-style-check-list,
ul.is-style-check-list {
    padding-left: 0.5rem;
}

ol.is-style-check-list>li,
ul.is-style-check-list>li {
    align-items: baseline;
    display: block;
    line-height: 1.5;
    padding-bottom: 0.5rem;
    padding-left: 1.5em;
    padding-top: 0.5rem;
    position: relative;
    width: 100%;
}

ol.is-style-check-list>li:before,
ul.is-style-check-list>li:before {
    background-color: #5333ed;
    content: "";
    display: block;
    flex-shrink: 0;
    height: 1em;
    left: 0;
    margin-right: 0.5rem;
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#check-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#check-usage);
    position: absolute;
    top: 0.75rem;
    width: 1em;
}

ol.is-style-none,
ul.is-style-none {
    list-style-type: none !important;
    padding-left: 0;
}

ol.is-style-arrow,
ul.is-style-arrow {
    list-style-type: none !important;
}

ol.is-style-arrow>li,
ul.is-style-arrow>li {
    position: relative;
}

ol.is-style-arrow>li:before,
ul.is-style-arrow>li:before {
    color: #999;
    content: "→";
    left: -2rem;
    margin-right: 1em;
    position: absolute;
}

ol.is-style-circle,
ul.is-style-circle {
    list-style-type: circle !important;
}

ol.is-style-disc,
ul.is-style-disc {
    list-style-type: disc !important;
}

ol.is-style-square,
ul.is-style-square {
    list-style-type: square !important;
}

ol.is-style-decimal,
ul.is-style-decimal {
    list-style-type: decimal !important;
}

ol.is-style-lower-alpha,
ul.is-style-lower-alpha {
    list-style-type: lower-alpha !important;
}

ol.is-style-lower-roman,
ul.is-style-lower-roman {
    list-style-type: lower-roman !important;
}

.bullet-list {
    list-style-type: square;
}

.bullet-list li {
    margin-bottom: 6px;
}

.bullet-list--green-bullet {
    span: #444;
    color: #2cd4d9;
}

.bullet-list--green-bullet.color--white span {
    color: #fff;
}

.bullet-list--margin-large li {
    margin-bottom: 11px;
}

.dot-list {
    list-style-type: disc;
}

.check-list>li {
    align-items: baseline;
    display: flex;
    line-height: 1.5;
    padding-bottom: 0.5em;
    padding-top: 0.5em;
    position: relative;
}

.check-list>li:before {
    border: 1px solid;
    border-radius: 50%;
    content: "";
    display: inline-block;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 0.6em;
    height: 1.8em;
    line-height: 1.9em;
    margin-right: 1em;
    position: relative;
    text-align: center;
    top: 0.4em;
    width: 1.8em;
}

.check-list>li:after {
    background-color: #44414e;
    content: "";
    height: 0.8em;
    left: 0.15em;
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#check-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#check-usage);
    position: absolute;
    top: 0.9em;
    width: 0.8em;
}

.check-list--green>li:before {
    color: #2cd4d9;
}

.check-list--green>li:after {
    background-color: #2cd4d9;
}

.check-list--white>li:before {
    color: #fff;
}

.check-list--white>li:after {
    background-color: #fff;
}

.check-list--inline {
    list-style: none;
}

.check-list--inline>li {
    display: inline-block;
    margin-right: 1em;
    padding-bottom: 0;
    padding-top: 0;
}

.check-list--inline>li:last-child {
    margin-right: 0;
}

.check-list--inline>li:before {
    margin-right: 0.5em;
}

.check-list--inline>li:after {
    top: 0.4em;
}

.arrow-list li a.text--link {
    display: flex;
    margin-bottom: 6px;
}

.arrow-list li a.text--link:before {
    speak: never;
    content: "→";
    content: "→" /"";
    display: block;
    margin-right: 10px;
    opacity: 0.7;
}

.arrow-list li a.text--link.hide-arrow:before {
    opacity: 0;
}

.text-quote {
    margin-top: 40px;
}

.text-quote:first-child {
    margin-top: 0;
}

.text-quote.text-quote--alternating {
    margin-top: -30px;
}

.text-quote.text-quote--alternating:first-child {
    margin-top: 0;
}

.text-quote.text-quote--alternating:nth-of-type(2n)>.col-sm-6 {
    padding-left: 20px;
}

.text-quote.text-quote--alternating:nth-of-type(odd)>.col-sm-6 {
    padding-right: 20px;
}

@media only screen and (max-width: 48em) {
    .text-quote.text-quote--alternating {
        margin-top: 40px;
    }

    .text-quote.text-quote--alternating:nth-of-type(2n)>.col-sm-6 {
        margin-left: 0;
        padding-left: 0;
    }

    .text-quote.text-quote--alternating:nth-of-type(odd)>.col-sm-6 {
        margin-right: 0;
        padding-right: 0;
    }
}

.text-quote__text {
    border: 2px solid #e1eaf8;
    border-radius: 6px;
    padding: 20px;
}

.bg--gray .text-quote__text {
    border-color: #ccdcf3;
}

.text-quote__avatar {
    margin-right: 30px;
    position: relative;
}

.text-quote__avatar.noimage {
    margin-right: 22px;
}

.text-quote__avatar:before {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #e1eaf8;
    right: 21px;
    top: -22px;
}

.text-quote__avatar:after,
.text-quote__avatar:before {
    content: " ";
    display: block;
    height: 0;
    position: absolute;
    width: 0;
}

.text-quote__avatar:after {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
    right: 23px;
    top: -23px;
}

.text-quote__avatar.noimage:before {
    right: -38px;
}

.text-quote__avatar.noimage:after {
    right: -36px;
}

.bg--gray .text-quote__avatar:before {
    border-top-color: #ccdcf3;
}

.bg--gray .text-quote__avatar:after {
    border-top-color: #e1eaf8;
}

.message {
    border-radius: 200px;
    border-style: solid;
    border-width: 1px;
    font-size: 12px;
    padding: 6px 22px;
}

.message.success {
    background: #d4f5bc;
    border-color: #b8ee90;
    color: #0b1603;
}

.message.error {
    background: #ed1c24;
    border-color: #c61017;
    color: #000;
}

dialog {
    background: #fff;
    border: solid;
    color: #000;
    height: -moz-fit-content;
    height: fit-content;
    margin: auto;
    padding: 1em;
    position: absolute;
    right: 0;
    width: -moz-fit-content;
    width: fit-content;
}

dialog:not([open]) {
    display: none;
}

dialog+.backdrop {
    background: rgba(0, 0, 0, 0.1);
}

._dialog_overlay,
dialog+.backdrop {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
}

dialog.fixed {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
}

dialog {
    background: #fafafa;
    border: none;
    border-radius: 4px;
    box-shadow: 0 4px 8px 0 rgba(67, 65, 78, 0.16);
    color: #44414e !important;
    display: block;
    left: 0;
    max-height: 100%;
    max-height: calc(100vh - 1rem);
    max-width: 96% !important;
    max-width: calc(100% - 2rem) !important;
    opacity: 0;
    overflow: auto;
    padding: 1rem;
    pointer-events: none;
    position: fixed;
    top: 0;
    transform: scale(0.95);
    transition: opacity 0.3s, transform 0.3s;
    visibility: hidden;
    width: 700px;
    z-index: 10000;
}

dialog.has-dark-blue-background-color {
    color: #fafafa !important;
}

dialog[role="dialog"] {
    top: 50%;
    transform: translateY(-50%) scale(0.95);
}

dialog[role="dialog"]:target,
dialog[role="dialog"][open] {
    transform: translateY(-50%) scale(1);
}

dialog:not([open]) {
    display: block;
}

dialog:not([open])::backdrop {
    display: block;
}

dialog:target,
dialog[open] {
    display: block;
    opacity: 1;
    pointer-events: all;
    transform: scale(1);
    visibility: visible;
}

body .kinsta-blocks dialog,
body .kinsta-blocks>dialog:first-child,
body .kinsta-blocks>dialog:last-child {
    margin-bottom: auto !important;
    margin-top: auto !important;
}

.dialog--nopadding {
    padding: 0;
}

.dialog--wide {
    width: 942px;
}

@media (min-height: 760px) {
    .dialog--wide {
        max-height: 700px;
    }
}

dialog:not([open])::backdrop {
    -webkit-backdrop-filter: blur(0);
    backdrop-filter: blur(0);
    background-color: transparent;
}

dialog+.backdrop,
dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.4);
    bottom: 0;
    cursor: pointer;
    left: 0;
    max-width: none;
    max-width: 100vw !important;
    position: fixed;
    right: 0;
    top: 0;
    transition: background-color 0.3s, -webkit-backdrop-filter 0.3s;
    transition: background-color 0.3s, backdrop-filter 0.3s;
    transition: background-color 0.3s, backdrop-filter 0.3s,
        -webkit-backdrop-filter 0.3s;
    width: 100vw !important;
}

dialog.dialog--dark-backdrop+.backdrop,
dialog.dialog--dark-backdrop::backdrop {
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    background-color: rgba(0, 0, 0, 0.8);
}

.dialog__close {
    background: transparent;
    background-color: #fff;
    border: none;
    display: block;
    height: 2rem;
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#cross-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#cross-usage);
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: 1.5rem;
    mask-size: 1.5rem;
    mix-blend-mode: difference;
    opacity: 0.6;
    outline: none;
    overflow: hidden;
    position: absolute;
    right: 0;
    text-indent: -4rem;
    top: 0;
    transition: opacity 0.2s;
    width: 2rem;
}

.no-js .dialog__close {
    display: none;
}

.dialog__close:hover {
    opacity: 1;
}

.dialog__terms .text--normal {
    font-size: 0.9em;
    line-height: 1.3;
}

.signup-modal {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    max-width: 942px;
    padding: 0;
}

@media (min-width: 40em) {
    .signup-modal {
        flex-direction: row;
    }
}

.signup-modal__background {
    background-color: #5333ed;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
    justify-content: center;
    padding: 1rem;
}

@media (min-width: 60em) {
    .signup-modal__background {
        padding: 2rem;
    }
}

.signup-modal__background .heading--huge {
    color: #fff;
}

@media (min-width: 40em) {
    .signup-modal__background .heading--huge {
        max-width: 7em;
    }
}

.signup-modal__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
}

@media (min-width: 50em) {
    .signup-modal__content {
        width: 35em;
    }
}

@media (min-width: 60em) {
    .signup-modal__content {
        padding: 2rem;
    }
}

@media (min-width: 60em) and (min-height: 40em) {
    .signup-modal__content {
        padding-bottom: 3rem;
        padding-top: 3rem;
    }
}

@media (min-width: 60em) and (min-height: 50em) {
    .signup-modal__content {
        padding-bottom: 4rem;
        padding-top: 4rem;
    }
}

@media (min-width: 64em) {
    .email-modal {
        padding: 2rem;
    }
}

@media (min-width: 75em) {
    .email-modal {
        padding: 3rem;
    }
}

.email-modal.has-dark-blue-background-color .unslidelink--text {
    background-image: linear-gradient(transparent calc(100% - 1px),
            currentColor 1px);
    color: inherit;
}

dialog .contact-form__notice {
    background-color: transparent;
    color: inherit;
    text-align: center;
}

dialog .contact-form__notice h2 {
    color: inherit;
}

.responsive-video,
kinsta-video {
    background-color: #e1eaf8;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 4px;
    display: block;
    overflow: hidden;
    position: relative;
}

.responsive-video[playsinline],
.responsive-video[playsinline]>*,
kinsta-video[playsinline],
kinsta-video[playsinline]>* {
    background-color: transparent;
}

.responsive-video:before,
kinsta-video:before {
    content: "";
    display: block;
    padding-bottom: 56.25%;
    width: 100%;
}

.responsive-video>*,
kinsta-video>* {
    border: none;
    bottom: 0;
    display: block;
    height: 100%;
    left: 0;
    position: absolute !important;
    right: 0;
    top: 0;
    width: 100%;
}

.responsive-video [id*="big_play_button_graphic"] {
    background-image: none !important;
}

.responsive-video [id*="big_play_button_graphic"]:after {
    background-color: rgba(83, 51, 237, 0.8);
    border-radius: 50%;
    box-sizing: content-box;
    content: url(/wp-content/themes/kinsta/images/icon-play.svg);
    display: block;
    height: 40px;
    left: 50%;
    padding: 25px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: padding 0.2s, background-color 0.2s;
    width: 40px;
}

.responsive-video [id*="big_play_button_graphic"].wistia_mouseover:after,
.responsive-video [id*="big_play_button_graphic"]:hover:after {
    background-color: #5333ed;
    padding: 30px;
}

.responsive-video [id*="big_play_button_background"] {
    background: none !important;
}

.responsive-video [id*="big_play_button_bottom_text"] {
    display: none !important;
}

.video-play-button {
    background-color: rgba(83, 51, 237, 0.8);
    border-radius: 50%;
    box-sizing: content-box;
    display: block;
    height: 40px;
    left: 50%;
    padding: 25px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: padding 0.2s, background-color 0.2s;
    width: 40px;
}

.video-play-button:before {
    content: url(/wp-content/themes/kinsta/images/icon-play.svg);
}

.responsive-video:hover .video-play-button,
.video-thumbnail:hover .video-play-button {
    background-color: #5333ed;
    padding: 30px;
}

.related-posts {
    background-color: #f9f9fb;
    padding-bottom: 2rem;
    padding-top: 2rem;
}

.container.related-posts__inner {
    max-width: 43rem;
}

@media (min-width: 48em) {
    .container.related-posts__inner {
        max-width: 45rem;
    }
}

.related-posts__title {
    color: #999;
    font-size: 0.875rem;
    font-weight: 600;
    margin: 0 0 2rem;
}

@media (min-width: 64em) {
    .related-posts__title {
        font-size: 1rem;
    }
}

.related-posts__list {
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
}

.related-posts:not(.related-posts--grid) .related-posts__post+.related-posts__post {
    margin-top: 2rem;
}

.related-posts:not(.related-posts--grid) .post-preview {
    display: flex;
    flex-direction: column;
}

@media (min-width: 22em) {
    .related-posts:not(.related-posts--grid) .post-preview {
        align-items: center;
        flex-direction: row-reverse;
        justify-content: space-between;
    }
}

.related-posts:not(.related-posts--grid) .post-preview__title {
    font-size: 1.25rem;
    font-weight: 900;
    margin: 0;
    transition: color 0.2s;
}

@media (min-width: 64em) {
    .related-posts:not(.related-posts--grid) .post-preview__title {
        font-size: 1.5rem;
    }
}

.related-posts:not(.related-posts--grid) .post-preview__title a {
    text-decoration: none;
}

.related-posts:not(.related-posts--grid) .post-preview__title a:focus,
.related-posts:not(.related-posts--grid) .post-preview__title a:hover {
    color: #5333ed;
}

.related-posts:not(.related-posts--grid) .post-preview__thumbnail {
    flex-grow: 0;
    flex-shrink: 0;
    margin-bottom: 1rem;
    width: 50%;
}

@media (min-width: 22em) {
    .related-posts:not(.related-posts--grid) .post-preview__thumbnail {
        margin-bottom: 0;
        margin-left: 2rem;
        width: 35%;
    }
}

.related-posts:not(.related-posts--grid) .post-preview__excerpt,
.related-posts:not(.related-posts--grid) .post-preview__subtitle {
    display: none;
}

.related-posts--grid .related-posts__inner {
    max-width: 1200px;
}

@media (min-width: 48em) {
    .related-posts--grid .related-posts__list {
        grid-gap: 1rem;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
}

@media (min-width: 64em) {
    .related-posts--grid .related-posts__list {
        grid-template-columns: 1fr 1fr 1fr;
    }
}

.post-preview {
    align-items: flex-start;
    color: inherit;
    display: flex;
    flex-direction: column;
    font-size: 0.875rem;
    text-decoration: none;
}

@media (min-width: 64em) {
    .post-preview {
        font-size: 1rem;
    }
}

.post-preview__thumbnail {
    margin-bottom: 1rem;
    position: relative;
}

.post-preview__thumbnail,
.post-preview__thumbnail img {
    border-radius: 0.25rem;
    display: block;
    width: 100%;
}

.post-preview__label {
    align-items: center;
    background-color: #5333ed;
    border-radius: 0.25rem;
    bottom: 0.5rem;
    color: #fff;
    display: inline-flex;
    flex-direction: row;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 0.625rem;
    font-weight: 600;
    left: 0.5rem;
    letter-spacing: 0.1em;
    line-height: 1.2;
    padding: 0.3em 0.6em;
    position: absolute;
    text-transform: uppercase;
}

@media (min-width: 64em) {
    .post-preview__label {
        font-size: 0.75rem;
    }
}

.post-preview__label img {
    display: block;
    height: 1em;
    width: auto;
}

.post-preview__title {
    color: #44414e;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.4;
    margin: 0;
    order: 2;
    transition: color 0.2s;
}

@media (min-width: 64em) {
    .post-preview__title {
        font-size: 1.125rem;
    }
}

.post-preview:focus .post-preview__title,
.post-preview:hover .post-preview__title {
    color: #5333ed;
}

.post-preview__subtitle {
    align-items: center;
    color: #999;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 0.625rem;
    font-weight: 700;
    margin: 0 0 0.5rem;
    order: 1;
    text-transform: uppercase;
}

@media (min-width: 64em) {
    .post-preview__subtitle {
        font-size: 0.75rem;
    }
}

.post-preview__excerpt {
    margin: 0.5rem 0 0;
    order: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}

.input-with-button {
    align-items: stretch;
    background-color: #fff;
    border-radius: 2em;
    display: flex;
    flex-direction: row;
    font-size: 0.875rem;
    justify-content: space-between;
    overflow: hidden;
    padding: 0.2em;
}

@media (min-width: 64em) {
    .input-with-button {
        font-size: 1rem;
    }
}

.input-with-button .input,
.input-with-button input {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    display: block;
    flex-grow: 1;
    flex-shrink: 1;
    font-size: 1em;
    margin: 0;
    outline: none;
    padding: 0.5em 1.5em;
    width: 100%;
}

.input-with-button .button,
.input-with-button button,
.input-with-button input[type="submit"] {
    font-size: 1em;
    outline: none;
}

@media (max-width: 30em) {

    .input-with-button .button,
    .input-with-button button,
    .input-with-button input[type="submit"] {
        padding-left: 1em;
        padding-right: 1em;
    }
}

.copy-to-clipboard {
    cursor: pointer;
    opacity: 0.7;
    transition: 0.2s;
}

.copy-to-clipboard:focus,
.copy-to-clipboard:hover {
    opacity: 1;
}

.copy-to-clipboard.icon--check {
    color: #30b00f;
}

.copy-to-clipboard.icon--cross {
    color: #ed1c24;
}

.contact-form {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    overflow: hidden;
    position: relative;
}

.contact-form__panel {
    background-color: #fff;
    display: block;
    flex-shrink: 0;
    overflow: auto;
    position: relative;
    width: 100%;
}

.contact-form__panel__header {
    align-items: stretch;
    background-color: #fff;
    border-bottom: 1px solid #f8f8f8;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
    min-height: 4rem;
    overflow: hidden;
    padding: 0 2rem;
    position: sticky;
    top: 0;
}

.contact-form__panel__header__text {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 2;
    justify-content: center;
    max-width: 100%;
    overflow: hidden;
    padding: 1rem;
}

.contact-form__panel__header__text:first-child {
    padding-left: 0;
}

.contact-form__panel__header__title {
    display: block;
    font-size: 1.125em;
    font-weight: 600;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.contact-form__panel__header__subtitle {
    font-size: 0.875em;
    margin-bottom: 0;
}

.contact-form__panel__action {
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    border: none;
    display: block;
    flex-shrink: 0;
    margin: 0;
    min-width: 1em;
    min-width: calc(1em + 2rem);
    padding: 1rem 1.5rem;
    text-align: center;
    transition: background-color 0.2s;
}

.contact-form__panel__action:active,
.contact-form__panel__action:focus,
.contact-form__panel__action:hover {
    background-color: #f3f3f6;
    outline: 0;
}

.contact-form__panel__action--back {
    margin-left: -2rem;
}

.contact-form__panel__action--close {
    margin-right: -2rem;
}

.contact-form__panel__body {
    padding: 2rem;
}

.contact-form__menu {
    display: flex;
    flex-direction: column;
    margin: 0;
}

.contact-form__menu__item {
    align-items: stretch;
    display: flex;
    font-weight: 600;
    justify-content: stretch;
}

.contact-form__menu__button {
    align-items: center;
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    border: none;
    border-bottom: 1px solid #f8f8f8;
    display: flex;
    flex-direction: row;
    font-size: 1em;
    font-weight: 400;
    justify-content: space-between;
    line-height: normal;
    margin: 0;
    overflow: visible;
    padding: 1rem 2rem;
    position: relative;
    text-align: left;
    transition: background-color 0.2s;
    width: 100%;
}

@media (min-height: 40em) {
    .contact-form__menu__button {
        padding: 2rem;
    }
}

.contact-form__menu__button::-moz-focus-inner {
    border: 0;
    padding: 0;
}

.contact-form__menu__button:active,
.contact-form__menu__button:focus,
.contact-form__menu__button:hover {
    background-color: #f3f3f6;
    outline: 0;
}

.contact-form__menu__button:after {
    content: "›";
    display: block;
    flex-shrink: 0;
    font-weight: 600;
    height: 1.5rem;
    line-height: 1.2;
    margin-left: 0.5rem;
    right: 1rem;
    text-align: center;
    width: 1.5rem;
}

.contact-form__menu__item:last-child .contact-form__menu__button {
    border-bottom: 0;
}

.contact-form__form {
    grid-gap: 1rem;
    align-items: flex-end;
    display: grid;
    grid-template-columns: 1fr;
}

@media (min-width: 48em) {
    .contact-form__form {
        grid-gap: 1rem 2rem;
        grid-template-columns: 1fr 1fr;
    }

    .contact-form__error,
    .contact-form__form .submit-container,
    .contact-form__form__full,
    .contact-form__form__legal,
    .contact-form__form__message {
        grid-column: span 2;
    }
}

.contact-form__form__legal {
    align-items: center;
    display: flex;
    flex-direction: row;
}

.contact-form__form__legal .row:last-child,
.contact-form__form__legal p:last-child {
    margin-bottom: 0;
}

.contact-form__notice {
    background-color: #fff;
    width: 100%;
    z-index: 2;
}

.contact-form__notice__inner {
    padding: 40px;
}

.is-submit-success .contact-form__notice {
    transform: translateY(0);
}

.contact-form__notice p:last-child {
    margin-bottom: 0;
}

.contact-form__notice-status {
    border-bottom: 1px solid #f6f6fc;
    display: flex;
    flex: 1 1 auto;
}

.contact-form__notice-status__icon {
    align-items: center;
    display: flex;
    margin-right: 40px;
}

.contact-form__notice-status__message h2 {
    margin-bottom: 0.2em;
}

.contact-form__notice-status .kinsta-icon {
    border-radius: 12px;
    display: inline-block;
    height: 12px;
    padding: 4px;
    width: 12px;
}

.contact-form__notice-status .kinsta-icon svg {
    fill: #000;
}

.contact-form__notice-status .kinsta-icon--check {
    border: 2px solid #418f21;
}

.contact-form__notice-status .kinsta-icon--check svg {
    fill: none;
    stroke: #418f21;
}

.contact-form__notice-post__header {
    margin-bottom: 25px;
}

.contact-form__notice-post .post-item {
    border: 1px solid #f4f4f5;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.04);
    margin-bottom: 1em;
}

.contact-form__notice-post .post-item__url {
    display: flex;
    text-decoration: none;
}

.contact-form__notice-post .post-item__url:hover span {
    color: #5333ed;
}

.contact-form__notice-post .post-item__title {
    font-size: 16px;
    line-height: 1.375;
}

.contact-form__notice-post .post-item__thumbnail {
    flex: 1 1 181px;
}

.contact-form__notice-post .post-item__thumbnail img {
    display: block;
}

.contact-form__notice-post .post-item__content {
    flex: 3 1 70%;
    padding: 18px;
}

.contact-form__error {
    background-color: #ed1c24;
    border-radius: 0.25rem;
    color: #fff;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 0.875rem;
    font-weight: 600;
    margin: 0;
    padding: 0.5rem 1rem;
}

@media (min-width: 64em) {
    .contact-form__error {
        font-size: 1rem;
    }
}

.contact-list__item {
    display: flex;
}

.contact-list__item a {
    align-self: baseline;
    display: inline;
}

.contact-list .kinsta-icon {
    border-radius: 50%;
    display: inline-block;
    height: 30px;
    padding: 6px;
    width: 30px;
}

.contact-list .kinsta-icon svg {
    fill: #fff;
}

.newsletter-cta,
.newsletter-cta.box {
    background-color: #eaf4fe;
    background-image: url(/wp-content/themes/kinsta/images/newsletter-bg.jpg);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: 100% auto;
}

@media (min-width: 64em) {

    .newsletter-cta--wide,
    .newsletter-cta--wide.box {
        background-image: url(/wp-content/themes/kinsta/images/newsletter-bg-wide.jpg);
    }
}

.kinsta-global-banner {
    --banner-fg: #fff;
    --banner-bg: #5333ed;
    background-position: 0;
    background-size: 200% auto;
    background: var(--banner-bg);
    color: var(--banner-fg);
    display: block;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 0.875rem;
    font-weight: 900;
    line-height: 1.2;
    margin: 0;
    position: relative;
    text-align: center;
    text-decoration: none;
    transition: background 0.2s, background-position 0.5s, color 0.2s;
    z-index: 10;
}

@media (min-width: 64em) {
    .kinsta-global-banner {
        font-size: 1rem;
    }
}

.kinsta-global-banner:focus,
.kinsta-global-banner:hover {
    --banner-bg: #3f1ceb;
}

.kinsta-global-banner.is-theme-light {
    --banner-fg: #0c022f;
    --banner-bg: #e1eaf8;
}

.kinsta-global-banner.is-theme-light:focus,
.kinsta-global-banner.is-theme-light:hover {
    --banner-bg: #ccdcf3;
}

.kinsta-global-banner.is-theme-dark {
    --banner-fg: #fafafa;
    --banner-bg: #000;
}

.kinsta-global-banner.is-theme-dark:focus,
.kinsta-global-banner.is-theme-dark:hover {
    --banner-bg: #0c022f;
    --banner-fg: #fff;
}

.kinsta-global-banner__inner {
    color: inherit;
    display: block;
    padding: 1rem;
    text-decoration: none;
}

.kinsta-global-banner.has-close .kinsta-global-banner__inner {
    padding-right: 4rem;
}

.kinsta-global-banner__close {
    all: unset;
    background-color: currentColor;
    color: inherit;
    cursor: pointer;
    display: block;
    height: 3rem;
    margin-top: -1.5rem;
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#cross-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#cross-usage);
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 1.5rem;
    mask-size: 1.5rem;
    opacity: 0.6;
    position: absolute;
    right: 1rem;
    top: 50%;
    transition: opacity 0.2s;
    width: 3rem;
}

.kinsta-global-banner__close:active,
.kinsta-global-banner__close:hover {
    opacity: 1;
}

.ml--0 {
    margin-left: 0 !important;
}

.ml--6 {
    margin-left: 6px;
}

.ml--10 {
    margin-left: 10px;
}

.ml--20 {
    margin-left: 20px;
}

.ml--30 {
    margin-left: 30px;
}

.ml--40 {
    margin-left: 40px;
}

.ml--50 {
    margin-left: 50px;
}

.ml--60 {
    margin-left: 60px;
}

.ml--70 {
    margin-left: 70px;
}

.ml--80 {
    margin-left: 80px;
}

.ml--90 {
    margin-left: 90px;
}

.ml--100 {
    margin-left: 100px;
}

.ml--110 {
    margin-left: 110px;
}

.ml--120 {
    margin-left: 120px;
}

.mr--0 {
    margin-right: 0 !important;
}

.mr--6 {
    margin-right: 6px;
}

.mr--8 {
    margin-right: 8px;
}

.mr--10 {
    margin-right: 10px;
}

.mr--20 {
    margin-right: 20px;
}

.mr--30 {
    margin-right: 30px;
}

.mr--40 {
    margin-right: 40px;
}

.mr--50 {
    margin-right: 50px;
}

.mr--60 {
    margin-right: 60px;
}

.mr--70 {
    margin-right: 70px;
}

.mr--80 {
    margin-right: 80px;
}

.mr--90 {
    margin-right: 90px;
}

.mr--100 {
    margin-right: 100px;
}

.mr--110 {
    margin-right: 110px;
}

.mr--120 {
    margin-right: 120px;
}

.pl--0 {
    padding-left: 0 !important;
}

.pl--6 {
    padding-left: 6px;
}

.pl--10 {
    padding-left: 10px;
}

.pl--20 {
    padding-left: 20px;
}

.pl--30 {
    padding-left: 30px;
}

.pl--40 {
    padding-left: 40px;
}

.pl--50 {
    padding-left: 50px;
}

.pl--60 {
    padding-left: 60px;
}

.pl--70 {
    padding-left: 70px;
}

.pl--80 {
    padding-left: 80px;
}

.pl--90 {
    padding-left: 90px;
}

.pl--100 {
    padding-left: 100px;
}

.pl--110 {
    padding-left: 110px;
}

.pl--120 {
    padding-left: 120px;
}

.pr--0 {
    padding-right: 0 !important;
}

.pr--6 {
    padding-right: 6px;
}

.pr--10 {
    padding-right: 10px;
}

.pr--20 {
    padding-right: 20px;
}

.pr--30 {
    padding-right: 30px;
}

.pr--40 {
    padding-right: 40px;
}

.pr--50 {
    padding-right: 50px;
}

.pr--60 {
    padding-right: 60px;
}

.pr--70 {
    padding-right: 70px;
}

.pr--80 {
    padding-right: 80px;
}

.pr--90 {
    padding-right: 90px;
}

.pr--100 {
    padding-right: 100px;
}

.pr--110 {
    padding-right: 110px;
}

.pr--120 {
    padding-right: 120px;
}

.pt--0 {
    padding-top: 0 !important;
}

.pt--6 {
    padding-top: 6px;
}

.pt--10 {
    padding-top: 10px;
}

.pt--20 {
    padding-top: 20px;
}

.pt--30 {
    padding-top: 30px;
}

.pt--40 {
    padding-top: 40px;
}

.pt--50 {
    padding-top: 50px;
}

.pt--60 {
    padding-top: 60px;
}

.pt--70 {
    padding-top: 70px;
}

.pt--80 {
    padding-top: 80px;
}

.pt--90 {
    padding-top: 90px;
}

.pt--100 {
    padding-top: 100px;
}

.pt--110 {
    padding-top: 110px;
}

.pt--120 {
    padding-top: 120px;
}

.pt--130 {
    padding-top: 130px;
}

.pt--140 {
    padding-top: 140px;
}

.pt--150 {
    padding-top: 150px;
}

.pt--160 {
    padding-top: 160px;
}

.pt--170 {
    padding-top: 170px;
}

.pt--180 {
    padding-top: 180px;
}

.pb--0 {
    padding-bottom: 0 !important;
}

.pb--6 {
    padding-bottom: 6px;
}

.pb--10 {
    padding-bottom: 10px;
}

.pb--20 {
    padding-bottom: 20px;
}

.pb--30 {
    padding-bottom: 30px;
}

.pb--40 {
    padding-bottom: 40px;
}

.pb--50 {
    padding-bottom: 50px;
}

.pb--60 {
    padding-bottom: 60px;
}

.pb--70 {
    padding-bottom: 70px;
}

.pb--80 {
    padding-bottom: 80px;
}

.pb--90 {
    padding-bottom: 90px;
}

.pb--100 {
    padding-bottom: 100px;
}

.pb--110 {
    padding-bottom: 110px;
}

.pb--120 {
    padding-bottom: 120px;
}

.pb--130 {
    padding-bottom: 130px;
}

.pb--140 {
    padding-bottom: 140px;
}

.pb--150 {
    padding-bottom: 150px;
}

.pb--160 {
    padding-bottom: 160px;
}

.pb--170 {
    padding-bottom: 170px;
}

.pb--180 {
    padding-bottom: 180px;
}

.mt--0 {
    margin-top: 0 !important;
}

.mt--4 {
    margin-top: 4px;
}

.mt--5 {
    margin-top: 5px;
}

.mt--6 {
    margin-top: 6px;
}

.mt--10 {
    margin-top: 10px;
}

.mt--15 {
    margin-top: 15px;
}

.mt--20 {
    margin-top: 20px;
}

.mt--30 {
    margin-top: 30px;
}

.mt--40 {
    margin-top: 40px;
}

.mt--50 {
    margin-top: 50px;
}

.mt--60 {
    margin-top: 60px;
}

.mt--70 {
    margin-top: 70px;
}

.mt--80 {
    margin-top: 80px;
}

.mt--90 {
    margin-top: 90px;
}

.mt--100 {
    margin-top: 100px;
}

.mt--110 {
    margin-top: 110px;
}

.mt--120 {
    margin-top: 120px;
}

.mt--130,
.mt--140,
.mt--150 {
    margin-top: 130px;
}

.mt--220 {
    margin-top: 220px;
}

.mb--0 {
    margin-bottom: 0 !important;
}

.mb--6 {
    margin-bottom: 6px;
}

.mb--10 {
    margin-bottom: 10px;
}

.mb--20 {
    margin-bottom: 20px;
}

.mb--30 {
    margin-bottom: 30px;
}

.mb--40 {
    margin-bottom: 40px;
}

.mb--50 {
    margin-bottom: 50px;
}

.mb--60 {
    margin-bottom: 60px;
}

.mb--70 {
    margin-bottom: 70px;
}

.mb--80 {
    margin-bottom: 80px;
}

.mb--90 {
    margin-bottom: 90px;
}

.mb--100 {
    margin-bottom: 100px;
}

.mb--110 {
    margin-bottom: 110px;
}

.mb--120 {
    margin-bottom: 120px;
}

.mb--130,
.mb--140,
.mb--150 {
    margin-bottom: 130px;
}

@media only screen and (max-width: 46em) {
    .pt--xs--0 {
        padding-top: 0 !important;
    }

    .pt--xs--6 {
        padding-top: 6px;
    }

    .pt--xs--10 {
        padding-top: 10px;
    }

    .pt--xs--20 {
        padding-top: 20px;
    }

    .pt--xs--30 {
        padding-top: 30px;
    }

    .pt--xs--40 {
        padding-top: 40px;
    }

    .pt--xs--50 {
        padding-top: 50px;
    }

    .pt--xs--60 {
        padding-top: 60px;
    }

    .pt--xs--70 {
        padding-top: 70px;
    }

    .pt--xs--80 {
        padding-top: 80px;
    }

    .pt--xs--90 {
        padding-top: 90px;
    }

    .pt--xs--100 {
        padding-top: 100px;
    }

    .pt--xs--110 {
        padding-top: 110px;
    }

    .pt--xs--120 {
        padding-top: 120px;
    }

    .pt--xs--130,
    .pt--xs--140,
    .pt--xs--150 {
        padding-top: 130px;
    }

    .pb--xs--0 {
        padding-bottom: 0 !important;
    }

    .pb--xs--6 {
        padding-bottom: 6px;
    }

    .pb--xs--10 {
        padding-bottom: 10px;
    }

    .pb--xs--20 {
        padding-bottom: 20px;
    }

    .pb--xs--30 {
        padding-bottom: 30px;
    }

    .pb--xs--40 {
        padding-bottom: 40px;
    }

    .pb--xs--50 {
        padding-bottom: 50px;
    }

    .pb--xs--60 {
        padding-bottom: 60px;
    }

    .pb--xs--70 {
        padding-bottom: 70px;
    }

    .pb--xs--80 {
        padding-bottom: 80px;
    }

    .pb--xs--90 {
        padding-bottom: 90px;
    }

    .pb--xs--100 {
        padding-bottom: 100px;
    }

    .pb--xs--110 {
        padding-bottom: 110px;
    }

    .pb--xs--120 {
        padding-bottom: 120px;
    }

    .pb--xs--130,
    .pb--xs--140,
    .pb--xs--150 {
        padding-bottom: 130px;
    }

    .pr--xs--0 {
        padding-right: 0 !important;
    }

    .pr--xs--6 {
        padding-right: 6px;
    }

    .pr--xs--10 {
        padding-right: 10px;
    }

    .pr--xs--20 {
        padding-right: 20px;
    }

    .pr--xs--30 {
        padding-right: 30px;
    }

    .pr--xs--40 {
        padding-right: 40px;
    }

    .pr--xs--50 {
        padding-right: 50px;
    }

    .pr--xs--60 {
        padding-right: 60px;
    }

    .pr--xs--70 {
        padding-right: 70px;
    }

    .pr--xs--80 {
        padding-right: 80px;
    }

    .pr--xs--90 {
        padding-right: 90px;
    }

    .pr--xs--100 {
        padding-right: 100px;
    }

    .pr--xs--110 {
        padding-right: 110px;
    }

    .pr--xs--120 {
        padding-right: 120px;
    }

    .pl--xs--0 {
        padding-left: 0 !important;
    }

    .pl--xs--6 {
        padding-left: 6px;
    }

    .pl--xs--10 {
        padding-left: 10px;
    }

    .pl--xs--20 {
        padding-left: 20px;
    }

    .pl--xs--30 {
        padding-left: 30px;
    }

    .pl--xs--40 {
        padding-left: 40px;
    }

    .pl--xs--50 {
        padding-left: 50px;
    }

    .pl--xs--60 {
        padding-left: 60px;
    }

    .pl--xs--70 {
        padding-left: 70px;
    }

    .pl--xs--80 {
        padding-left: 80px;
    }

    .pl--xs--90 {
        padding-left: 90px;
    }

    .pl--xs--100 {
        padding-left: 100px;
    }

    .pl--xs--110 {
        padding-left: 110px;
    }

    .pl--xs--120 {
        padding-left: 120px;
    }

    .mt--xs--0 {
        margin-top: 0 !important;
    }

    .mt--xs--6 {
        margin-top: 6px;
    }

    .mt--xs--10 {
        margin-top: 10px;
    }

    .mt--xs--20 {
        margin-top: 20px;
    }

    .mt--xs--30 {
        margin-top: 30px;
    }

    .mt--xs--40 {
        margin-top: 40px;
    }

    .mt--xs--50 {
        margin-top: 50px;
    }

    .mt--xs--60 {
        margin-top: 60px;
    }

    .mt--xs--70 {
        margin-top: 70px;
    }

    .mt--xs--80 {
        margin-top: 80px;
    }

    .mt--xs--90 {
        margin-top: 90px;
    }

    .mt--xs--100 {
        margin-top: 100px;
    }

    .mt--xs--110 {
        margin-top: 110px;
    }

    .mt--xs--120 {
        margin-top: 120px;
    }

    .mt--xs--130,
    .mt--xs--140,
    .mt--xs--150 {
        margin-top: 130px;
    }

    .mb--xs--0 {
        margin-bottom: 0 !important;
    }

    .mb--xs--6 {
        margin-bottom: 6px;
    }

    .mb--xs--10 {
        margin-bottom: 10px;
    }

    .mb--xs--20 {
        margin-bottom: 20px;
    }

    .mb--xs--30 {
        margin-bottom: 30px;
    }

    .mb--xs--40 {
        margin-bottom: 40px;
    }

    .mb--xs--50 {
        margin-bottom: 50px;
    }

    .mb--xs--60 {
        margin-bottom: 60px;
    }

    .mb--xs--70 {
        margin-bottom: 70px;
    }

    .mb--xs--80 {
        margin-bottom: 80px;
    }

    .mb--xs--90 {
        margin-bottom: 90px;
    }

    .mb--xs--100 {
        margin-bottom: 100px;
    }

    .mb--xs--110 {
        margin-bottom: 110px;
    }

    .mb--xs--120 {
        margin-bottom: 120px;
    }

    .mb--xs--130,
    .mb--xs--140,
    .mb--xs--150 {
        margin-bottom: 130px;
    }

    .mr--xs--0 {
        margin-right: 0 !important;
    }

    .mr--xs--10 {
        margin-right: 10px;
    }

    .mr--xs--20 {
        margin-right: 20px;
    }

    .mr--xs--40 {
        margin-right: 40px;
    }

    .ml--xs--0 {
        margin-left: 0 !important;
    }

    .ml--xs--10 {
        margin-left: 10px;
    }

    .ml--xs--20 {
        margin-left: 20px;
    }

    .ml--xs--30 {
        margin-left: 30px;
    }

    .ml--xs--40 {
        margin-left: 40px;
    }
}

@media only screen and (max-width: 64em) {
    .pt--sm--0 {
        padding-top: 0 !important;
    }

    .pt--sm--6 {
        padding-top: 6px;
    }

    .pt--sm--10 {
        padding-top: 10px;
    }

    .pt--sm--20 {
        padding-top: 20px;
    }

    .pt--sm--30 {
        padding-top: 30px;
    }

    .pt--sm--40 {
        padding-top: 40px;
    }

    .pt--sm--50 {
        padding-top: 50px;
    }

    .pt--sm--60 {
        padding-top: 60px;
    }

    .pt--sm--70 {
        padding-top: 70px;
    }

    .pt--sm--80 {
        padding-top: 80px;
    }

    .pt--sm--90 {
        padding-top: 90px;
    }

    .pt--sm--100 {
        padding-top: 100px;
    }

    .pt--sm--110 {
        padding-top: 110px;
    }

    .pt--sm--120 {
        padding-top: 120px;
    }

    .pt--sm--130,
    .pt--sm--140,
    .pt--sm--150 {
        padding-top: 130px;
    }

    .pb--sm--0 {
        padding-bottom: 0 !important;
    }

    .pb--sm--6 {
        padding-bottom: 6px;
    }

    .pb--sm--10 {
        padding-bottom: 10px;
    }

    .pb--sm--20 {
        padding-bottom: 20px;
    }

    .pb--sm--30 {
        padding-bottom: 30px;
    }

    .pb--sm--40 {
        padding-bottom: 40px;
    }

    .pb--sm--50 {
        padding-bottom: 50px;
    }

    .pb--sm--60 {
        padding-bottom: 60px;
    }

    .pb--sm--70 {
        padding-bottom: 70px;
    }

    .pb--sm--80 {
        padding-bottom: 80px;
    }

    .pb--sm--90 {
        padding-bottom: 90px;
    }

    .pb--sm--100 {
        padding-bottom: 100px;
    }

    .pb--sm--110 {
        padding-bottom: 110px;
    }

    .pb--sm--120 {
        padding-bottom: 120px;
    }

    .pb--sm--130,
    .pb--sm--140,
    .pb--sm--150 {
        padding-bottom: 130px;
    }

    .pr--sm--0 {
        padding-right: 0 !important;
    }

    .pr--sm--6 {
        padding-right: 6px;
    }

    .pr--sm--10 {
        padding-right: 10px;
    }

    .pr--sm--20 {
        padding-right: 20px;
    }

    .pr--sm--30 {
        padding-right: 30px;
    }

    .pr--sm--40 {
        padding-right: 40px;
    }

    .pr--sm--50 {
        padding-right: 50px;
    }

    .pr--sm--60 {
        padding-right: 60px;
    }

    .pr--sm--70 {
        padding-right: 70px;
    }

    .pr--sm--80 {
        padding-right: 80px;
    }

    .pr--sm--90 {
        padding-right: 90px;
    }

    .pr--sm--100 {
        padding-right: 100px;
    }

    .pr--sm--110 {
        padding-right: 110px;
    }

    .pr--sm--120 {
        padding-right: 120px;
    }

    .pl--sm--0 {
        padding-left: 0 !important;
    }

    .pl--sm--6 {
        padding-left: 6px;
    }

    .pl--sm--10 {
        padding-left: 10px;
    }

    .pl--sm--20 {
        padding-left: 20px;
    }

    .pl--sm--30 {
        padding-left: 30px;
    }

    .pl--sm--40 {
        padding-left: 40px;
    }

    .pl--sm--50 {
        padding-left: 50px;
    }

    .pl--sm--60 {
        padding-left: 60px;
    }

    .pl--sm--70 {
        padding-left: 70px;
    }

    .pl--sm--80 {
        padding-left: 80px;
    }

    .pl--sm--90 {
        padding-left: 90px;
    }

    .pl--sm--100 {
        padding-left: 100px;
    }

    .pl--sm--110 {
        padding-left: 110px;
    }

    .pl--sm--120 {
        padding-left: 120px;
    }

    .mt--sm--0 {
        margin-top: 0 !important;
    }

    .mt--sm--6 {
        margin-top: 6px;
    }

    .mt--sm--10 {
        margin-top: 10px;
    }

    .mt--sm--20 {
        margin-top: 20px;
    }

    .mt--sm--30 {
        margin-top: 30px;
    }

    .mt--sm--40 {
        margin-top: 40px;
    }

    .mt--sm--50 {
        margin-top: 50px;
    }

    .mt--sm--60 {
        margin-top: 60px;
    }

    .mt--sm--70 {
        margin-top: 70px;
    }

    .mt--sm--80 {
        margin-top: 80px;
    }

    .mt--sm--90 {
        margin-top: 90px;
    }

    .mt--sm--100 {
        margin-top: 100px;
    }

    .mt--sm--110 {
        margin-top: 110px;
    }

    .mt--sm--120 {
        margin-top: 120px;
    }

    .mt--sm--130,
    .mt--sm--140,
    .mt--sm--150 {
        margin-top: 130px;
    }

    .mb--sm--0 {
        margin-bottom: 0 !important;
    }

    .mb--sm--6 {
        margin-bottom: 6px;
    }

    .mb--sm--10 {
        margin-bottom: 10px;
    }

    .mb--sm--20 {
        margin-bottom: 20px;
    }

    .mb--sm--30 {
        margin-bottom: 30px;
    }

    .mb--sm--40 {
        margin-bottom: 40px;
    }

    .mb--sm--50 {
        margin-bottom: 50px;
    }

    .mb--sm--60 {
        margin-bottom: 60px;
    }

    .mb--sm--70 {
        margin-bottom: 70px;
    }

    .mb--sm--80 {
        margin-bottom: 80px;
    }

    .mb--sm--90 {
        margin-bottom: 90px;
    }

    .mb--sm--100 {
        margin-bottom: 100px;
    }

    .mb--sm--110 {
        margin-bottom: 110px;
    }

    .mb--sm--120 {
        margin-bottom: 120px;
    }

    .mb--sm--130,
    .mb--sm--140,
    .mb--sm--150 {
        margin-bottom: 130px;
    }

    .mr--sm--0 {
        margin-right: 0 !important;
    }
}

@media only screen and (max-width: 75em) {
    .pt--md--0 {
        padding-top: 0 !important;
    }

    .pt--md--6 {
        padding-top: 6px;
    }

    .pt--md--10 {
        padding-top: 10px;
    }

    .pt--md--20 {
        padding-top: 20px;
    }

    .pt--md--30 {
        padding-top: 30px;
    }

    .pt--md--40 {
        padding-top: 40px;
    }

    .pt--md--50 {
        padding-top: 50px;
    }

    .pt--md--60 {
        padding-top: 60px;
    }

    .pt--md--70 {
        padding-top: 70px;
    }

    .pt--md--80 {
        padding-top: 80px;
    }

    .pt--md--90 {
        padding-top: 90px;
    }

    .pt--md--100 {
        padding-top: 100px;
    }

    .pt--md--110 {
        padding-top: 110px;
    }

    .pt--md--120 {
        padding-top: 120px;
    }

    .pt--md--130,
    .pt--md--140,
    .pt--md--150 {
        padding-top: 130px;
    }

    .pb--md--0 {
        padding-bottom: 0 !important;
    }

    .pb--md--6 {
        padding-bottom: 6px;
    }

    .pb--md--10 {
        padding-bottom: 10px;
    }

    .pb--md--20 {
        padding-bottom: 20px;
    }

    .pb--md--30 {
        padding-bottom: 30px;
    }

    .pb--md--40 {
        padding-bottom: 40px;
    }

    .pb--md--50 {
        padding-bottom: 50px;
    }

    .pb--md--60 {
        padding-bottom: 60px;
    }

    .pb--md--70 {
        padding-bottom: 70px;
    }

    .pb--md--80 {
        padding-bottom: 80px;
    }

    .pb--md--90 {
        padding-bottom: 90px;
    }

    .pb--md--100 {
        padding-bottom: 100px;
    }

    .pb--md--110 {
        padding-bottom: 110px;
    }

    .pb--md--120 {
        padding-bottom: 120px;
    }

    .pb--md--130,
    .pb--md--140,
    .pb--md--150 {
        padding-bottom: 130px;
    }

    .pr--md--0 {
        padding-right: 0 !important;
    }

    .pr--md--6 {
        padding-right: 6px;
    }

    .pr--md--10 {
        padding-right: 10px;
    }

    .pr--md--20 {
        padding-right: 20px;
    }

    .pr--md--30 {
        padding-right: 30px;
    }

    .pr--md--40 {
        padding-right: 40px;
    }

    .pr--md--50 {
        padding-right: 50px;
    }

    .pr--md--60 {
        padding-right: 60px;
    }

    .pr--md--70 {
        padding-right: 70px;
    }

    .pr--md--80 {
        padding-right: 80px;
    }

    .pr--md--90 {
        padding-right: 90px;
    }

    .pr--md--100 {
        padding-right: 100px;
    }

    .pr--md--110 {
        padding-right: 110px;
    }

    .pr--md--120 {
        padding-right: 120px;
    }

    .pl--md--0 {
        padding-left: 0 !important;
    }

    .pl--md--6 {
        padding-left: 6px;
    }

    .pl--md--10 {
        padding-left: 10px;
    }

    .pl--md--20 {
        padding-left: 20px;
    }

    .pl--md--30 {
        padding-left: 30px;
    }

    .pl--md--40 {
        padding-left: 40px;
    }

    .pl--md--50 {
        padding-left: 50px;
    }

    .pl--md--60 {
        padding-left: 60px;
    }

    .pl--md--70 {
        padding-left: 70px;
    }

    .pl--md--80 {
        padding-left: 80px;
    }

    .pl--md--90 {
        padding-left: 90px;
    }

    .pl--md--100 {
        padding-left: 100px;
    }

    .pl--md--110 {
        padding-left: 110px;
    }

    .pl--md--120 {
        padding-left: 120px;
    }

    .mt--md--0 {
        margin-top: 0 !important;
    }

    .mt--md--6 {
        margin-top: 6px;
    }

    .mt--md--10 {
        margin-top: 10px;
    }

    .mt--md--20 {
        margin-top: 20px;
    }

    .mt--md--30 {
        margin-top: 30px;
    }

    .mt--md--40 {
        margin-top: 40px;
    }

    .mt--md--50 {
        margin-top: 50px;
    }

    .mt--md--60 {
        margin-top: 60px;
    }

    .mt--md--70 {
        margin-top: 70px;
    }

    .mt--md--80 {
        margin-top: 80px;
    }

    .mt--md--90 {
        margin-top: 90px;
    }

    .mt--md--100 {
        margin-top: 100px;
    }

    .mt--md--110 {
        margin-top: 110px;
    }

    .mt--md--120 {
        margin-top: 120px;
    }

    .mt--md--130,
    .mt--md--140,
    .mt--md--150 {
        margin-top: 130px;
    }

    .mb--md--0 {
        margin-bottom: 0 !important;
    }

    .mb--md--6 {
        margin-bottom: 6px;
    }

    .mb--md--10 {
        margin-bottom: 10px;
    }

    .mb--md--20 {
        margin-bottom: 20px;
    }

    .mb--md--30 {
        margin-bottom: 30px;
    }

    .mb--md--40 {
        margin-bottom: 40px;
    }

    .mb--md--50 {
        margin-bottom: 50px;
    }

    .mb--md--60 {
        margin-bottom: 60px;
    }

    .mb--md--70 {
        margin-bottom: 70px;
    }

    .mb--md--80 {
        margin-bottom: 80px;
    }

    .mb--md--90 {
        margin-bottom: 90px;
    }

    .mb--md--100 {
        margin-bottom: 100px;
    }

    .mb--md--110 {
        margin-bottom: 110px;
    }

    .mb--md--120 {
        margin-bottom: 120px;
    }

    .mb--md--130,
    .mb--md--140,
    .mb--md--150 {
        margin-bottom: 130px;
    }

    .mr--md--0 {
        margin-right: 0 !important;
    }
}

.mt--first--0:first-child {
    margin-top: 0;
}

.pull--10 {
    margin-top: -10px;
}

.pull--10,
.pull--20 {
    position: relative;
    z-index: 2;
}

.pull--20 {
    margin-top: -20px;
}

.pull--40 {
    margin-top: -40px;
}

.pull--40,
.pull--60 {
    position: relative;
    z-index: 2;
}

.pull--60 {
    margin-top: -60px;
}

.pull--80 {
    margin-top: -80px;
}

.pull--100,
.pull--80 {
    position: relative;
    z-index: 2;
}

.pull--100 {
    margin-top: -100px;
}

.pull--120 {
    margin-top: -120px;
}

.pull--120,
.pull--140 {
    position: relative;
    z-index: 2;
}

.pull--140 {
    margin-top: -140px;
}

.pull--160 {
    margin-top: -160px;
}

.pull--160,
.pull--200 {
    position: relative;
    z-index: 2;
}

.pull--200 {
    margin-top: -200px;
}

.push--6 {
    margin-bottom: -6px;
    position: relative;
}

.push--8 {
    margin-bottom: -8px;
    position: relative;
}

.push--10 {
    margin-bottom: -10px;
    position: relative;
}

.push--20 {
    margin-bottom: -20px;
    position: relative;
}

.push--40 {
    margin-bottom: -40px;
    position: relative;
}

.push--60 {
    margin-bottom: -60px;
    position: relative;
}

.push--80 {
    margin-bottom: -80px;
    position: relative;
}

.push--100 {
    margin-bottom: -100px;
    position: relative;
}

.push--120 {
    margin-bottom: -120px;
    position: relative;
}

.push--140 {
    margin-bottom: -140px;
    position: relative;
}

@media only screen and (max-width: 48em) {
    .pull--xs--0 {
        margin-top: 0;
        position: relative;
    }

    .pull--xs--40 {
        margin-top: -40px;
        position: relative;
    }
}

.commission__graph {
    align-items: center;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    display: flex;
    height: 62px;
    position: relative;
}

.commission__graph__line {
    display: flex;
    height: 62px;
    justify-content: space-between;
    margin-left: 3px;
    width: calc(100% - 6px);
}

.commission__graph__line>div {
    font-size: 14px;
    margin-right: 5px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
}

.commission__graph__line>div:after {
    background: #ccc;
    content: " ";
    display: block;
    height: 22px;
    position: absolute;
    right: -3px;
    top: 20px;
    width: 1px;
}

.commission__graph__line>div:before {
    background: #ccc;
    content: " ";
    display: block;
    height: 1px;
    left: 3px;
    position: absolute;
    top: 50%;
    width: calc(100% - 6px);
}

.commission__graph__line>div:last-child {
    margin-right: 0;
}

.commission__graph__line>div:last-child:after {
    display: none;
}

.commission__plans {
    display: flex;
    justify-content: space-between;
    margin-left: 3px;
    margin-top: 20px;
    width: calc(100% - 6px);
}

.commission__plans>div {
    font-size: 14px;
    margin-right: 5px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
}

.commission__plans>div:last-child {
    margin-right: 0;
}

.commission__plans>div:first-of-type .commission__plans__plan {
    background: #4ae6d7;
}

.commission__plans>div:nth-of-type(2) .commission__plans__plan {
    background: #4855e1;
}

.commission__plans>div:nth-of-type(3) .commission__plans__plan {
    background: #bede81;
}

.commission__plans>div:nth-of-type(4) .commission__plans__plan {
    background: #d26ac7;
}

.commission__plans__plan {
    color: #fff;
    font-weight: 600;
    letter-spacing: 1px;
    padding: 11px;
}

.commission__calculations {
    color: #777;
    margin-top: 40px;
}

.commission__calculations ul {
    border-bottom: 1px solid #ddd;
    padding-bottom: 20px;
}

.commission__calculations ul:last-child {
    border-bottom: 0;
}

.commission__total {
    border-top: 4px solid #eee;
    color: #777;
    font-size: 22px;
    padding-top: 40px;
    text-align: center;
}

.commission__calculation__content {
    background: #fff;
    border-left: 2px solid #5333ed;
    color: #333;
    display: none;
    font-family: Monaco, monospace;
    font-size: 14px;
    line-height: 26px;
    margin-top: 10px;
    padding: 16px 22px;
    text-align: left;
}

.commission__calculation__content.is-shown {
    display: block;
}

.calculation {
    background: #fafafa;
    margin-bottom: 20px;
    padding: 40px;
    position: relative;
}

.calculation .title {
    font-weight: 600;
    margin-bottom: 10px;
}

.calculation .description {
    margin-bottom: 30px;
}

.calculation:before {
    background-image: url('data:image/svg+xml;utf8,<svg enable-background="new 0 0 136 136" height="136px" id="Layer_1" version="1.1" viewBox="0 0 136 136" width="136px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><g><path d="M91.087,27.988H79.062H68.181H40.763c-2.114,0-3.838,1.722-3.838,3.83v68.39    c0,2.106,1.724,3.83,3.838,3.83h50.324c2.116,0,3.838-1.724,3.838-3.83V81.662V47.207V31.818    C94.925,29.712,93.201,27.988,91.087,27.988z" fill="#455361"/></g></g><g><g><rect fill="#EBD16F" height="13.426" width="49.132" x="41.396" y="32.434"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="41.396" y="50.334"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="54.821" y="50.334"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="68.246" y="50.334"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="81.672" y="50.334"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="41.396" y="63.76"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="54.821" y="63.76"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="68.246" y="63.76"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="81.672" y="63.76"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="41.396" y="77.185"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="54.821" y="77.185"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="68.246" y="77.185"/></g></g><g><g><rect fill="#598F8D" height="22.519" width="8.95" x="81.672" y="77.185"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="41.396" y="90.61"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="54.821" y="90.61"/></g></g><g><g><rect fill="#F2ECE5" height="8.95" width="8.95" x="68.246" y="90.61"/></g></g><g><g><g><rect fill="#F2ECE5" height="6" width="1" x="85.647" y="85.443"/></g></g><g><g><rect fill="#F2ECE5" height="1" width="6" x="83.147" y="87.943"/></g></g></g><g><g><g><rect fill="#598F8D" height="1" width="6" x="83.147" y="67.734"/></g></g></g><g><g><g><rect fill="#598F8D" height="5.999" transform="matrix(0.7071 0.7071 -0.7071 0.7071 63.9875 -44.8624)" width="1" x="85.648" y="51.809"/></g></g><g><g><rect fill="#598F8D" height="1" transform="matrix(0.7071 0.7071 -0.7071 0.7071 63.9875 -44.8624)" width="5.999" x="83.148" y="54.309"/></g></g></g></svg>');
    background-repeat: no-repeat;
    background-size: 55px 55px;
    content: " ";
    display: block;
    height: 55px;
    left: -26px;
    position: absolute;
    top: 28px;
    width: 55px;
}

.calculation> :last-child {
    margin-bottom: 0;
}

.switch {
    display: inline-block;
    height: 12px;
    position: relative;
    width: 32px;
}

.switch.disabled {
    opacity: 0.3;
}

.switch input {
    background: transparent;
    border: 0;
    opacity: 0;
    position: relative;
}

.slider {
    background-color: #ccc;
    bottom: 0;
    cursor: pointer;
    right: 0;
    top: 0;
}

.slider,
.slider:before {
    left: 0;
    position: absolute;
    transition: 0.4s;
}

.slider:before {
    background: #777;
    bottom: -3px;
    content: "";
    height: 18px;
    width: 18px;
}

input:checked+.slider {
    background-color: #7b62f1;
}

input:checked+.slider:before {
    background-color: #5333ed;
}

input:focus+.slider {
    box-shadow: 0 0 1px #7b62f1;
}

input:checked+.slider:before {
    transform: translateX(18px);
}

.slider {
    border-radius: 34px;
}

.slider:before {
    border-radius: 50%;
}

.wp-block-kinsta-table-of-contents {
    background-color: #f9f9fb;
    border-radius: 0.25rem;
    line-height: 1.6;
    margin: 3rem -1rem !important;
    max-width: 100vw;
    padding: 2rem 1rem;
    width: auto !important;
}

@media (min-width: 48em) {
    .wp-block-kinsta-table-of-contents {
        margin-left: -2rem;
        margin-right: -2rem;
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

@media (min-width: 64em) {
    .wp-block-kinsta-table-of-contents {
        margin-left: -3rem;
        margin-right: -3rem;
        padding-left: 3rem;
        padding-right: 3rem;
    }
}

.wp-block-kinsta-table-of-contents .wp-block-kinsta-button {
    margin-top: 0.5rem;
}

kinsta-auto-toc {
    display: block;
}

.wp-block-kinsta-table-of-contents__inner {
    margin: 0 auto;
    max-width: 41rem;
    padding: 0;
    width: 100%;
}

.wp-block-kinsta-table-of-contents__title {
    font-size: 1.25rem;
    margin-bottom: 1rem;
    margin-top: 0;
}

@media (min-width: 64em) {
    .wp-block-kinsta-table-of-contents__title {
        font-size: 1.5rem;
    }
}

.user-content .wp-block-kinsta-table-of-contents__list,
.wp-block-kinsta-table-of-contents__list {
    margin-bottom: 0;
}

.wp-block-kinsta-table-of-contents__list li {
    line-height: 1.6;
    margin-bottom: 0.5rem;
}

.wp-block-kinsta-table-of-contents__list li:last-child {
    margin-bottom: 0;
}

.wp-block-kinsta-table-of-contents.is-style-sub-toc {
    background: none;
    margin: 2rem 0;
    padding: 0;
}

.wp-block-kinsta-table-of-contents.is-style-sub-toc li {
    margin: 0;
}

@media (min-width: 75em) and (min-height: 30em) {
    .wp-block-kinsta-table-of-contents.is-style-floating {
        background: none;
        margin: 0 auto !important;
        max-width: 100%;
        padding: 0 !important;
        position: sticky;
        top: 1rem;
        width: 71rem !important;
    }

    .wp-block-kinsta-table-of-contents.is-style-floating .wp-block-kinsta-table-of-contents__inner {
        left: 0;
        position: absolute;
        width: 13rem;
    }

    .wp-block-kinsta-table-of-contents.is-style-floating .wp-block-kinsta-table-of-contents__title {
        clip: rect(1px 1px 1px 1px);
        clip: rect(1px, 1px, 1px, 1px);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }

    .wp-block-kinsta-table-of-contents.is-style-floating .wp-block-kinsta-table-of-contents__list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .wp-block-kinsta-table-of-contents.is-style-floating .wp-block-kinsta-table-of-contents__list li:last-child {
        margin-bottom: 0;
    }

    .wp-block-kinsta-table-of-contents.is-style-floating .wp-block-kinsta-table-of-contents__list a {
        background: none;
        color: #44414e;
        text-decoration: none;
    }

    .wp-block-kinsta-table-of-contents.is-style-floating a.is-active {
        font-weight: 700;
    }
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs {
    background-color: #fff;
    border-radius: 0;
    box-shadow: 0 2px 8px 0 rgba(16, 7, 104, 0.07);
    height: 3rem;
    left: 0;
    margin-left: -1rem !important;
    margin-right: -1rem !important;
    max-width: 100vw !important;
    padding: 0;
    position: sticky;
    right: 0;
    top: -1px;
    transition: box-shadow 0.3s;
    z-index: 10;
}

@media (min-width: 64em) {
    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs {
        background-color: transparent;
        box-shadow: 0 2px 8px 0 rgba(16, 7, 104, 0);
        height: auto;
        margin-left: -2rem !important;
        margin-right: -2rem !important;
        padding: 1rem 0 0;
    }

    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs.is-stuck {
        background-color: #fff;
        box-shadow: 0 2px 8px 0 rgba(16, 7, 104, 0.07);
    }
}

.wp-block-group.pr--0.pl--0 .wp-block-kinsta-table-of-contents.is-style-sticky-tabs {
    margin: 0 !important;
    max-width: 100% !important;
}

body.admin-bar .wp-block-kinsta-table-of-contents.is-style-sticky-tabs {
    padding-top: 32px;
}

@media screen and (max-width: 782px) {
    body.admin-bar .wp-block-kinsta-table-of-contents.is-style-sticky-tabs {
        padding-top: 0;
    }
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__inner {
    max-width: 71rem;
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__title {
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__next,
.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__prev {
    background-color: #44414e;
    display: block;
    height: 3rem;
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#chevron-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#chevron-usage);
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 1.5rem 1.5rem;
    mask-size: 1.5rem 1.5rem;
    overflow: hidden;
    position: absolute;
    text-indent: 3rem;
    top: 0;
    width: 3rem;
}

@media (min-width: 64em) {

    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__next,
    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__prev {
        display: none;
    }
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__prev {
    left: 0;
    transform: rotate(90deg);
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__next {
    right: 0;
    transform: rotate(-90deg);
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list {
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 3rem;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
}

@media (min-width: 64em) {
    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list {
        grid-gap: 2rem;
        align-items: flex-end;
        gap: 2rem;
        height: auto;
    }
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list li {
    margin: 0;
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list a {
    background: transparent;
    color: #999;
    display: block;
    font-family: Brandon Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
        Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    text-decoration: none;
    text-transform: uppercase;
    transition: color 0.2s, background-color 0.2s, border-color 0.2s;
}

@media (min-width: 64em) {
    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list a {
        border-bottom: 2px solid transparent;
        border-top-left-radius: 1em;
        border-top-right-radius: 1em;
        font-size: 0.875rem;
        font-size: 0.625rem;
        padding: 1em 2em;
    }
}

@media (min-width: 64em) and (min-width: 64em) {
    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list a {
        font-size: 0.75rem;
    }
}

@media (min-width: 64em) {
    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list a:hover {
        color: #44414e;
    }
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list a.is-active {
    background-color: #fff;
    color: #44414e;
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list a:not(.is-active) {
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

@media (min-width: 64em) {
    .wp-block-kinsta-table-of-contents.is-style-sticky-tabs .wp-block-kinsta-table-of-contents__list a:not(.is-active) {
        clip: auto;
        height: auto;
        overflow: visible;
        position: static;
        white-space: normal;
        width: auto;
    }
}

.wp-block-kinsta-table-of-contents.is-style-sticky-tabs.is-stuck a.is-active {
    border-color: #2cd4d9;
}

.wp-block-kinsta-notice {
    background: #f9f9fb;
    border: 1px solid #e1eaf8;
    border-radius: 0.25rem;
    color: #44414e;
    display: block;
    margin-bottom: 3rem;
    margin-top: 3rem;
    padding: 1.5rem 2rem;
}

.wp-block-kinsta-notice.is-style-plain {
    padding-left: 2rem;
}

.wp-block-kinsta-notice.is-style-important,
.wp-block-kinsta-notice.is-style-info {
    padding-left: 4rem;
}

.wp-block-kinsta-notice> :first-child {
    margin-top: 0;
}

.wp-block-kinsta-notice> :last-child {
    margin-bottom: 0;
}

.wp-block-kinsta-notice h2,
.wp-block-kinsta-notice h3,
.wp-block-kinsta-notice h4,
.wp-block-kinsta-notice h5 {
    font-size: 1rem;
    margin-bottom: 1rem;
}

@media (min-width: 64em) {

    .wp-block-kinsta-notice h2,
    .wp-block-kinsta-notice h3,
    .wp-block-kinsta-notice h4,
    .wp-block-kinsta-notice h5 {
        font-size: 1.125rem;
    }
}

.wp-block-kinsta-notice h2:empty,
.wp-block-kinsta-notice h3:empty,
.wp-block-kinsta-notice h4:empty,
.wp-block-kinsta-notice h5:empty {
    display: none;
}

.wp-block-kinsta-notice:before {
    background-color: currentColor;
    content: none;
    display: block;
    height: 1rem;
    margin-bottom: -1rem;
    margin-left: -2rem;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: 1rem;
    mask-size: 1rem;
    position: relative;
    top: 0.1em;
    width: 1rem;
}

.wp-block-kinsta-notice.is-style-important:before {
    content: "";
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#important-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#important-usage);
}

.wp-block-kinsta-notice.is-style-info:before {
    content: "";
    -webkit-mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#info-usage);
    mask-image: url(/wp-content/themes/kinsta/dist/sprite.svg?ver=d0962dd110507a5ed5735a7e39ec8edda1609dc3#info-usage);
}

*,
:after,
:before {
    box-sizing: border-box;
}

html {
    height: -webkit-fill-available;
}

body,
html {
    min-height: 100%;
    min-height: -webkit-fill-available;
    scroll-behavior: smooth;
    scroll-padding-top: 5.375rem;
}

@media (prefers-reduced-motion: reduce) {

    body,
    html {
        scroll-behavior: auto;
    }
}

@media (min-width: 62em) {

    body,
    html {
        scroll-padding-top: 6.625rem;
    }
}

.screen-reader-text {
    clip: rect(1px, 1px, 1px, 1px);
    -webkit-clip-path: inset(50%);
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.overflow--hidden {
    overflow: hidden;
}

.pointer {
    cursor: pointer;
}

.display--inline {
    display: inline-block;
}

.display--block {
    display: block;
}

.display-none {
    display: none;
}

.position-relative {
    position: relative;
}

.position-absolute {
    position: absolute;
}

@media only screen and (max-width: 47.999em) {
    .display--xs--block {
        display: block;
    }
}

.height--100 {
    height: 100%;
}

.width--100 {
    width: 100%;
}

img {
    height: auto;
    margin-bottom: 0;
    max-height: 100%;
    max-width: 100%;
}

svg {
    display: block;
    margin: 0;
}

.lottie-animation {
    transform: translateZ(0);
}

a {
    cursor: pointer;
}

input:focus::placeholder {
    opacity: 0.3;
}

button {
    cursor: pointer;
}

.align--center {
    margin-right: auto;
}

.align--center,
.align--end {
    margin-left: auto;
}

.logo-image,
.logo-image img {
    max-height: 45px;
    max-width: 200px;
}

input[name="user_age"],
input[name="user_email"] {
    display: none !important;
}

.temporary-notice {
    background: #fdfcef;
    padding: 20px;
}

.mini-divider {
    background: #f3f3f6;
    border: none;
    height: 7px;
    margin: 20px 0;
    outline: none;
    width: 70px;
}

.cursor--help {
    cursor: help !important;
}

.imagelink img {
    border-radius: 0.25rem;
}

.js-email-gated {
    display: none;
}

.kinsta-book {
    cursor: pointer;
    margin: auto;
    max-width: 45vw;
    position: relative;
    transform: rotateX(10deg) rotateY(-10deg);
}

@media only screen and (max-width: 64em) {
    .kinsta-book {
        margin-left: auto;
        margin-right: auto;
    }
}

.kinsta-book--3d,
.kinsta-book--3d-tilted {
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    perspective: 1000;
    transform-style: preserve-3d;
}

.kinsta-book--3d .kinsta-book__cover--front,
.kinsta-book--3d-tilted .kinsta-book__cover--front {
    transform: rotateY(-28deg) translateX(4px) translateZ(7px);
    transition: transform 0.8s ease, z-index 0.6s;
}

.kinsta-book--3d {
    transform: rotateX(0) rotateY(-10deg);
}

.kinsta-book--3d-tilted {
    transform: rotateX(0) rotateY(5deg) rotate(10deg);
}

@media only screen and (min-width: 64em) {
    .kinsta-book--3d-tilted {
        transform: rotateX(0) rotateY(5deg) rotate(10deg) translateX(30px);
    }
}

.kinsta-book--animated {
    animation: spaceFloating 10s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
}

.kinsta-book__cover,
.kinsta-book__page,
.kinsta-book__pages {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform-style: preserve-3d;
    width: 100%;
}

.kinsta-book__cover,
.kinsta-book__page {
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
    transform-origin: 0 100%;
}

.kinsta-book__cover--front {
    background-color: #c7c3be;
    position: relative;
}

.kinsta-book__cover--front figure {
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
    overflow: hidden;
    perspective: 1000;
}

.kinsta-book img {
    display: block;
}

.kinsta-book__cover--back {
    background-color: #c7c3be;
    transform: rotateY(-20deg) translateZ(-10px);
}

.kinsta-book__pages {
    height: 98%;
    left: 2%;
    top: 1%;
    width: 100%;
    z-index: 10;
}

.kinsta-book__page {
    background: linear-gradient(90deg, #f6f6f6, #fff);
    box-shadow: inset 0 -1px 2px rgba(50, 50, 50, 0.1),
        inset -1px 0 1px hsla(0, 0%, 59%, 0.2);
    overflow: hidden;
    transform-origin: left center;
    transition-property: transform;
    transition-timing-function: ease;
}

.kinsta-book__page:first-child {
    transform: rotateY(-27deg);
    transition-duration: 0.6s;
}

.kinsta-book__page:nth-child(2) {
    transform: rotateY(-26deg);
    transition-duration: 0.6s;
}

.kinsta-book__page:nth-child(3) {
    transform: rotateY(-25deg);
    transition-duration: 0.6s;
}

.kinsta-book__page:nth-child(4) {
    transform: rotateY(-24deg);
}

.kinsta-book__page:nth-child(5) {
    transform: rotateY(-23deg);
}

.kinsta-book__spine {
    background-color: #c7c3be;
    height: 100%;
    position: absolute;
    transform: rotateY(-80deg) translateX(0);
    transform-origin: 0 100%;
    width: 17px;
}

.kinsta-book--3d-tilted:hover,
.kinsta-book--3d:hover {
    animation-play-state: paused;
}

.kinsta-book--3d-tilted:hover .kinsta-book__cover--front,
.kinsta-book--3d:hover .kinsta-book__cover--front {
    transform: rotateY(-80deg) translateX(4px) translateZ(1px);
    z-index: 0;
}

.kinsta-book--3d-tilted:hover .kinsta-book__page:first-child,
.kinsta-book--3d:hover .kinsta-book__page:first-child {
    transform: rotateY(-80deg);
    transition-duration: 1.2s;
}

.kinsta-book--3d-tilted:hover .kinsta-book__page:nth-child(2),
.kinsta-book--3d:hover .kinsta-book__page:nth-child(2) {
    transform: rotateY(-78deg);
    transition-duration: 1.4s;
}

.kinsta-book--3d-tilted:hover .kinsta-book__page:nth-child(3),
.kinsta-book--3d:hover .kinsta-book__page:nth-child(3) {
    transform: rotateY(-76deg);
    transition-duration: 1.5s;
}

.kinsta-book--3d-tilted:hover .kinsta-book__page:nth-child(4),
.kinsta-book--3d:hover .kinsta-book__page:nth-child(4) {
    transform: rotateY(-24deg);
}

.kinsta-book--3d-tilted:hover .kinsta-book__page:nth-child(5),
.kinsta-book--3d:hover .kinsta-book__page:nth-child(5) {
    transform: rotateY(-23deg);
}

.kinsta-book-description {
    margin-left: auto;
    margin-right: auto;
    max-width: 480px;
    text-align: center;
}

@media screen and (min-width: 1024px) {
    .kinsta-book-description {
        max-width: 260px;
    }
}

.kinsta-book-description__content {
    margin-top: 14px;
}

@keyframes spaceFloating {
    0% {
        transform: rotateX(10deg) rotateY(-10deg) rotate(-5deg) translateY(-10px);
    }

    50% {
        transform: rotateX(10deg) rotateY(5deg) rotate(10deg) translateY(30px);
    }

    to {
        transform: rotateX(10deg) rotateY(-10deg) rotate(-5deg) translateY(-10px);
    }
}

kinsta-advanced-cta {
    clear: both;
    display: block;
}

.advanced-cta-wrapper .cta--color--turquoise,
.advanced-cta-wrapper .has-turquoise-color {
    color: #2cd4d9;
}

.advanced-cta-wrapper .cta--bg--turquoise,
.advanced-cta-wrapper .has-turquoise-background-color {
    background-color: #2cd4d9;
}

.advanced-cta-wrapper .cta--color--purple,
.advanced-cta-wrapper .has-purple-color {
    color: #5333ed;
}

.advanced-cta-wrapper .cta--bg--purple,
.advanced-cta-wrapper .has-purple-background-color {
    background-color: #5333ed;
}

.advanced-cta-wrapper .cta--color--blue,
.advanced-cta-wrapper .has-blue-color {
    color: #150773;
}

.advanced-cta-wrapper .cta--bg--blue,
.advanced-cta-wrapper .has-blue-background-color {
    background-color: #150773;
}

.advanced-cta-wrapper .cta--color--light-blue,
.advanced-cta-wrapper .has-light-blue-color {
    color: #fbfdff;
}

.advanced-cta-wrapper .cta--bg--light-blue,
.advanced-cta-wrapper .has-light-blue-background-color {
    background-color: #fbfdff;
}

.advanced-cta-wrapper .cta--color--dark-blue,
.advanced-cta-wrapper .has-dark-blue-color {
    color: #0c022f;
}

.advanced-cta-wrapper .cta--bg--dark-blue,
.advanced-cta-wrapper .has-dark-blue-background-color {
    background-color: #0c022f;
}

.advanced-cta-wrapper .cta--color--gold,
.advanced-cta-wrapper .has-gold-color {
    color: #ff961f;
}

.advanced-cta-wrapper .cta--bg--gold,
.advanced-cta-wrapper .has-gold-background-color {
    background-color: #ff961f;
}

.advanced-cta-wrapper .cta--color--green,
.advanced-cta-wrapper .has-green-color {
    color: #d4f5bc;
}

.advanced-cta-wrapper .cta--bg--green,
.advanced-cta-wrapper .has-green-background-color {
    background-color: #d4f5bc;
}

.advanced-cta-wrapper .cta--color--red,
.advanced-cta-wrapper .has-red-color {
    color: #ed1c24;
}

.advanced-cta-wrapper .cta--bg--red,
.advanced-cta-wrapper .has-red-background-color {
    background-color: #ed1c24;
}

.advanced-cta-wrapper .cta--color--white,
.advanced-cta-wrapper .has-white-color {
    color: #fff;
}

.advanced-cta-wrapper .cta--bg--white,
.advanced-cta-wrapper .has-white-background-color {
    background-color: #fff;
}

.advanced-cta-wrapper .cta--color--offwhite,
.advanced-cta-wrapper .has-offwhite-color {
    color: #fafafa;
}

.advanced-cta-wrapper .cta--bg--offwhite,
.advanced-cta-wrapper .has-offwhite-background-color {
    background-color: #fafafa;
}

.advanced-cta-wrapper .cta--color--gray,
.advanced-cta-wrapper .has-gray-color {
    color: #e1eaf8;
}

.advanced-cta-wrapper .cta--bg--gray,
.advanced-cta-wrapper .has-gray-background-color {
    background-color: #e1eaf8;
}

.advanced-cta-wrapper .cta--color--light-gray,
.advanced-cta-wrapper .has-light-gray-color {
    color: #f9f9fb;
}

.advanced-cta-wrapper .cta--bg--light-gray,
.advanced-cta-wrapper .has-light-gray-background-color {
    background-color: #f9f9fb;
}

.advanced-cta-wrapper .cta--color--medium-gray,
.advanced-cta-wrapper .has-medium-gray-color {
    color: #999;
}

.advanced-cta-wrapper .cta--bg--medium-gray,
.advanced-cta-wrapper .has-medium-gray-background-color {
    background-color: #999;
}

.advanced-cta-wrapper .cta--color--dark-gray,
.advanced-cta-wrapper .has-dark-gray-color {
    color: #44414e;
}

.advanced-cta-wrapper .cta--bg--dark-gray,
.advanced-cta-wrapper .has-dark-gray-background-color {
    background-color: #44414e;
}

.advanced-cta-wrapper .cta--color--dove-gray,
.advanced-cta-wrapper .has-dove-gray-color {
    color: #f3f3f6;
}

.advanced-cta-wrapper .cta--bg--dove-gray,
.advanced-cta-wrapper .has-dove-gray-background-color {
    background-color: #f3f3f6;
}

.advanced-cta-wrapper .cta--color--success,
.advanced-cta-wrapper .has-success-color {
    color: #30b00f;
}

.advanced-cta-wrapper .cta--bg--success,
.advanced-cta-wrapper .has-success-background-color {
    background-color: #30b00f;
}

.advanced-cta-wrapper .cta--color--error,
.advanced-cta-wrapper .has-error-color {
    color: #e43c3c;
}

.advanced-cta-wrapper .cta--bg--error,
.advanced-cta-wrapper .has-error-background-color {
    background-color: #e43c3c;
}

.advanced-cta-wrapper .cta--color--green,
.advanced-cta-wrapper .has-green-color {
    color: #2cd4d9;
}

.advanced-cta-wrapper .cta--bg--green,
.advanced-cta-wrapper .has-green-background-color {
    background-color: #2cd4d9;
}

.advanced-cta-wrapper .cta--bg--mask {
    background-image: linear-gradient(-30deg,
            rgba(0, 0, 77, 0.8),
            rgba(83, 51, 237, 0.8) 49%,
            rgba(44, 212, 217, 0.8));
}

.advanced-cta-wrapper .cta--bg--gradient--dark-light-blue {
    background-image: linear-gradient(-30deg, #00004d, #5333ed 49%, #2cd4d9);
}

.advanced-cta-wrapper .cta--bg--gradient--purple-light-blue {
    background-image: linear-gradient(-30deg, #24035b, #7533ed 49%, #2ca2d9);
}

.advanced-cta-wrapper .cta--bg--gradient--ebook {
    background-image: linear-gradient(180deg, #377792, #1e2865);
}

.advanced-cta-wrapper .cta--bg--image {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
}

.advanced-cta-wrapper .cta--bg--image-top {
    background-position-y: top;
}

.advanced-cta-wrapper .cta--bg--image-center {
    background-position-y: center;
}

.advanced-cta-wrapper .cta--bg--image-bottom {
    background-position-y: bottom;
}

.advanced-cta-wrapper .cta--ebook {
    max-width: 250px !important;
}

.advanced-cta-wrapper .cta-img {
    display: unset !important;
}

.advanced-cta-wrapper .cta-in-article-heading {
    font-size: 2rem;
}

.advanced-cta-wrapper .align-self-flex-end {
    align-self: flex-end;
}

.advanced-cta-wrapper .align-self-flex-start {
    align-self: flex-start;
}

.advanced-cta-wrapper .align-self-center {
    align-self: center;
}

.advanced-cta-wrapper .flex-direction-column-reverse {
    flex-direction: column-reverse !important;
    flex-wrap: nowrap !important;
}

.advanced-cta-wrapper .display--table {
    display: table;
}

@media only screen and (min-width: 48em) {
    .advanced-cta-wrapper .flex-direction-column-reverse {
        flex-direction: row !important;
        flex-wrap: wrap !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/common/book-animation.vue